import { emptyRootAPI as api } from './emptyRootAPI'

export const addTagTypes = [
  'Site Reservations Configuration',
  'Site Grid Profiles',
  'Scheduled Vehicle Trips',
  'Grid Event Integration Accounts',
  'Grid',
  'Custom Tariff Controller',
  'Schedule',
  'Charger Events',
  'Depot Event DST Backfill',
  'Charger Events DST Backfill',
  'Telemetry Exclusion Periods',
  'Site Energy Configurations',
  'Site Feature Configurations',
  'Node Energy Configurations',
  'Optimization',
  'Price Controller',
  'Average Rates Controller',
  'Load Balancer Events',
  'Transaction Profile Mapping',
  'Effective Node Energy Limit',
  'Profile History Records',
  'Synop Link',
  'Reservations',
  'Grid Event Integrations',
  'Vehicles',
  'Charging Transactions',
  'ML Models',
  'Weather',
  'Telematics Feed Cursors',
  'Integrations',
  'Payment Terminals',
  'Organization Integration Providers',
  'Payment Terminal Sessions',
  'Integration Providers',
  'analysis',
  'schema',
  'Sync',
  'Send',
  'OCPP Tag Authorization',
  'Credentials',
  'Authorization Decisions',
  'Virtual Chargers',
  'assistant-skill-api',
  'assistant-skill-schedule-api',
  'Notifications',
  'generative-dashboard-api',
  'Firmware Versions',
  'Firmware Deployments',
  'Bug reports',
  'assistant-api',
  'assistant-attachment-api',
  'arcade-score-api',
  'Virtual Charger Logs',
  'Routes',
  'Activity Events',
  'whats-new'
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSiteReservationConfiguration: build.query<
        GetSiteReservationConfigurationResponse,
        GetSiteReservationConfigurationArgs
      >({
        query: (queryArg) => ({ url: `/api/sites/${queryArg.siteId}/reservation-configuration` }),
        providesTags: ['Site Reservations Configuration']
      }),
      updateSiteReservationConfiguration: build.mutation<
        UpdateSiteReservationConfigurationResponse,
        UpdateSiteReservationConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/sites/${queryArg.siteId}/reservation-configuration`,
          method: 'PUT',
          body: queryArg.siteReservationConfigurationUpdateRequest
        }),
        invalidatesTags: ['Site Reservations Configuration']
      }),
      createSiteReservationConfiguration: build.mutation<
        CreateSiteReservationConfigurationResponse,
        CreateSiteReservationConfigurationArgs
      >({
        query: (queryArg) => ({ url: `/api/sites/${queryArg.siteId}/reservation-configuration`, method: 'POST' }),
        invalidatesTags: ['Site Reservations Configuration']
      }),
      getSiteGridProfiles: build.query<GetSiteGridProfilesResponse, GetSiteGridProfilesArgs>({
        query: (queryArg) => ({
          url: `/api/site-grid-profiles`,
          params: {
            gridEventIntegrationAccountId: queryArg.gridEventIntegrationAccountId
          }
        }),
        providesTags: ['Site Grid Profiles']
      }),
      updateSiteGridProfile: build.mutation<UpdateSiteGridProfileResponse, UpdateSiteGridProfileArgs>({
        query: (queryArg) => ({
          url: `/api/site-grid-profiles`,
          method: 'PUT',
          body: queryArg.updateSiteGridProfileRequestParams
        }),
        invalidatesTags: ['Site Grid Profiles']
      }),
      createSiteGridProfile: build.mutation<CreateSiteGridProfileResponse, CreateSiteGridProfileArgs>({
        query: (queryArg) => ({
          url: `/api/site-grid-profiles`,
          method: 'POST',
          body: queryArg.createSiteGridProfileRequestParams
        }),
        invalidatesTags: ['Site Grid Profiles']
      }),
      getScheduledTrips: build.query<GetScheduledTripsResponse, GetScheduledTripsArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-vehicle-trips`,
          params: {
            siteId: queryArg.siteId,
            vehicleId: queryArg.vehicleId,
            vehicleIds: queryArg.vehicleIds,
            routeId: queryArg.routeId,
            startsBefore: queryArg.startsBefore,
            startsAfter: queryArg.startsAfter,
            endsBefore: queryArg.endsBefore,
            endsAfter: queryArg.endsAfter,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Scheduled Vehicle Trips']
      }),
      updateTrip: build.mutation<UpdateTripResponse, UpdateTripArgs>({
        query: (queryArg) => ({ url: `/api/scheduled-vehicle-trips`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      createTrip: build.mutation<CreateTripResponse, CreateTripArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-vehicle-trips`,
          method: 'POST',
          body: queryArg.scheduledVehicleTripCreateModel
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      deleteTrip: build.mutation<DeleteTripResponse, DeleteTripArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-vehicle-trips`,
          method: 'DELETE',
          body: queryArg.scheduledVehicleTripDeleteModel
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      getRecurrenceSchedule: build.query<GetRecurrenceScheduleResponse, GetRecurrenceScheduleArgs>({
        query: (queryArg) => ({ url: `/api/scheduled-trip-recurrences/${queryArg.scheduleId}` }),
        providesTags: ['Scheduled Vehicle Trips']
      }),
      updateRecurrenceSchedule: build.mutation<UpdateRecurrenceScheduleResponse, UpdateRecurrenceScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-trip-recurrences/${queryArg.scheduleId}`,
          method: 'PUT',
          body: queryArg.scheduledTripRecurrenceUpdateModel,
          params: {
            vehicleIds: queryArg.vehicleIds,
            occurrenceIndex: queryArg.occurrenceIndex
          }
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      deleteRecurrenceSchedule: build.mutation<DeleteRecurrenceScheduleResponse, DeleteRecurrenceScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-trip-recurrences/${queryArg.scheduleId}`,
          method: 'DELETE',
          params: {
            vehicleIds: queryArg.vehicleIds,
            occurrenceIndex: queryArg.occurrenceIndex
          }
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      updateTripOccurrences: build.mutation<UpdateTripOccurrencesResponse, UpdateTripOccurrencesArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-trip-recurrences/${queryArg.scheduleId}/update-occurrences`,
          method: 'PUT',
          body: queryArg.scheduledTripRecurrenceUpdateOccurrencesModel,
          params: {
            vehicleIds: queryArg.vehicleIds,
            occurrenceIndex: queryArg.occurrenceIndex
          }
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      getGridEventIntegrationAccounts: build.query<
        GetGridEventIntegrationAccountsResponse,
        GetGridEventIntegrationAccountsArgs
      >({
        query: (queryArg) => ({
          url: `/api/grid-event-integration-accounts`,
          params: {
            organizationId: queryArg.organizationId,
            gridEventIntegrationId: queryArg.gridEventIntegrationId
          }
        }),
        providesTags: ['Grid Event Integration Accounts']
      }),
      updateGridEventIntegrationAccount: build.mutation<
        UpdateGridEventIntegrationAccountResponse,
        UpdateGridEventIntegrationAccountArgs
      >({
        query: (queryArg) => ({
          url: `/api/grid-event-integration-accounts`,
          method: 'PUT',
          body: queryArg.updateGridEventIntegrationsAccountRequestParams
        }),
        invalidatesTags: ['Grid Event Integration Accounts']
      }),
      createGridEventIntegrationAccount: build.mutation<
        CreateGridEventIntegrationAccountResponse,
        CreateGridEventIntegrationAccountArgs
      >({
        query: (queryArg) => ({
          url: `/api/grid-event-integration-accounts`,
          method: 'POST',
          body: queryArg.createGridEventIntegrationsAccountRequestParams
        }),
        invalidatesTags: ['Grid Event Integration Accounts']
      }),
      getDepotEventsByDepotId: build.query<GetDepotEventsByDepotIdResponse, GetDepotEventsByDepotIdArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/events`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Grid']
      }),
      updateDepotEvent: build.mutation<UpdateDepotEventResponse, UpdateDepotEventArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/events`,
          method: 'PUT',
          body: queryArg.depotEventModel,
          params: {
            isRecurrence: queryArg.isRecurrence
          }
        }),
        invalidatesTags: ['Grid']
      }),
      saveDepotEvent: build.mutation<SaveDepotEventResponse, SaveDepotEventArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/events`,
          method: 'POST',
          body: queryArg.depotEventModel
        }),
        invalidatesTags: ['Grid']
      }),
      updateCustomTariff: build.mutation<UpdateCustomTariffResponse, UpdateCustomTariffArgs>({
        query: (queryArg) => ({
          url: `/api/custom-tariffs/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.customTariffUpdateRequest
        }),
        invalidatesTags: ['Custom Tariff Controller']
      }),
      getScheduledChargerSession: build.query<GetScheduledChargerSessionResponse, GetScheduledChargerSessionArgs>({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}/events/${queryArg.eventId}` }),
        providesTags: ['Schedule']
      }),
      updateScheduledChargerSession: build.mutation<
        UpdateScheduledChargerSessionResponse,
        UpdateScheduledChargerSessionArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/events/${queryArg.eventId}`,
          method: 'PUT',
          body: queryArg.chargerEventUpdateModelDeprecated,
          params: {
            isRecurrence: queryArg.isRecurrence
          }
        }),
        invalidatesTags: ['Schedule']
      }),
      cancelScheduledChargerSession: build.mutation<
        CancelScheduledChargerSessionResponse,
        CancelScheduledChargerSessionArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/events/${queryArg.eventId}`,
          method: 'DELETE',
          params: {
            isRecurrence: queryArg.isRecurrence
          }
        }),
        invalidatesTags: ['Schedule']
      }),
      getChargerEventById: build.query<GetChargerEventByIdResponse, GetChargerEventByIdArgs>({
        query: (queryArg) => ({ url: `/api/charger-events/${queryArg.eventId}` }),
        providesTags: ['Charger Events']
      }),
      updateChargerEvent: build.mutation<UpdateChargerEventResponse, UpdateChargerEventArgs>({
        query: (queryArg) => ({
          url: `/api/charger-events/${queryArg.eventId}`,
          method: 'PUT',
          body: queryArg.chargerEventUpdateModel,
          params: {
            includeRecurring: queryArg.includeRecurring
          }
        }),
        invalidatesTags: ['Charger Events']
      }),
      cancelChargerEvent: build.mutation<CancelChargerEventResponse, CancelChargerEventArgs>({
        query: (queryArg) => ({
          url: `/api/charger-events/${queryArg.eventId}`,
          method: 'DELETE',
          params: {
            includeRecurring: queryArg.includeRecurring
          }
        }),
        invalidatesTags: ['Charger Events']
      }),
      patchChargerEvent: build.mutation<PatchChargerEventResponse, PatchChargerEventArgs>({
        query: (queryArg) => ({
          url: `/api/charger-events/${queryArg.eventId}`,
          method: 'PATCH',
          body: queryArg.chargerEventUpdateModel,
          params: {
            includeRecurring: queryArg.includeRecurring
          }
        }),
        invalidatesTags: ['Charger Events']
      }),
      moveChargerEvent: build.mutation<MoveChargerEventResponse, MoveChargerEventArgs>({
        query: (queryArg) => ({
          url: `/api/charger-events/${queryArg.eventId}/transaction-update`,
          method: 'PUT',
          body: queryArg.reassignEventConnectorModel
        }),
        invalidatesTags: ['Charger Events']
      }),
      startDepotBackfill: build.mutation<StartDepotBackfillResponse, StartDepotBackfillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/depot-events/dst-backfill/site/${queryArg.siteId}`,
          method: 'POST',
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Depot Event DST Backfill']
      }),
      startBackfillForSite: build.mutation<StartBackfillForSiteResponse, StartBackfillForSiteArgs>({
        query: (queryArg) => ({
          url: `/api/v1/charger-events/dst-backfill-v2/site/${queryArg.siteId}`,
          method: 'POST',
          params: {
            dryRun: queryArg.dryRun,
            batchSize: queryArg.batchSize
          }
        }),
        invalidatesTags: ['Charger Events DST Backfill']
      }),
      getTelemetryExclusionPeriod: build.query<GetTelemetryExclusionPeriodResponse, GetTelemetryExclusionPeriodArgs>({
        query: (queryArg) => ({
          url: `/api/telemetry-exclusion-periods`,
          params: {
            page: queryArg.page,
            count: queryArg.count,
            sort: queryArg.sort,
            vehicleIds: queryArg.vehicleIds,
            startsAfter: queryArg.startsAfter,
            startsBefore: queryArg.startsBefore,
            endsAfter: queryArg.endsAfter,
            endsBefore: queryArg.endsBefore
          }
        }),
        providesTags: ['Telemetry Exclusion Periods']
      }),
      createTelemetryExclusionPeriod: build.mutation<
        CreateTelemetryExclusionPeriodResponse,
        CreateTelemetryExclusionPeriodArgs
      >({
        query: (queryArg) => ({
          url: `/api/telemetry-exclusion-periods`,
          method: 'POST',
          body: queryArg.createTelemetryExclusionRequestModel
        }),
        invalidatesTags: ['Telemetry Exclusion Periods']
      }),
      getSiteEnergyConfigurations: build.query<GetSiteEnergyConfigurationsResponse, GetSiteEnergyConfigurationsArgs>({
        query: (queryArg) => ({
          url: `/api/sites/${queryArg.siteId}/energy-configurations`,
          params: {
            latest: queryArg.latest,
            from: queryArg['from'],
            to: queryArg.to,
            count: queryArg.count,
            afterId: queryArg.afterId
          }
        }),
        providesTags: ['Site Energy Configurations', 'Site Feature Configurations', 'Node Energy Configurations']
      }),
      createSiteEnergyConfiguration: build.mutation<
        CreateSiteEnergyConfigurationResponse,
        CreateSiteEnergyConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/sites/${queryArg.siteId}/energy-configurations`,
          method: 'POST',
          body: queryArg.createSiteEnergyConfigurationParams
        }),
        invalidatesTags: ['Site Energy Configurations', 'Site Feature Configurations', 'Node Energy Configurations']
      }),
      createRecurrenceSchedule: build.mutation<CreateRecurrenceScheduleResponse, CreateRecurrenceScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/scheduled-trip-recurrences`,
          method: 'POST',
          body: queryArg.scheduledTripRecurrenceCreateModel
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      setRecurrenceScheduleVehicles: build.mutation<
        SetRecurrenceScheduleVehiclesResponse,
        SetRecurrenceScheduleVehiclesArgs
      >({
        query: (queryArg) => ({
          url: `/api/scheduled-trip-recurrences/${queryArg.scheduleId}/set-vehicles`,
          method: 'POST',
          body: queryArg.scheduledTripRecurrenceSetVehiclesModel
        }),
        invalidatesTags: ['Scheduled Vehicle Trips']
      }),
      getOptimizations: build.query<GetOptimizationsResponse, GetOptimizationsArgs>({
        query: (queryArg) => ({
          url: `/api/optimizations`,
          params: {
            organizationId: queryArg.organizationId,
            depotId: queryArg.depotId,
            from: queryArg['from'],
            to: queryArg.to,
            feasible: queryArg.feasible,
            parentOptimizationId: queryArg.parentOptimizationId,
            latest: queryArg.latest,
            activeAt: queryArg.activeAt,
            includeVehicleOptimizations: queryArg.includeVehicleOptimizations,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Optimization']
      }),
      createOptimization: build.mutation<CreateOptimizationResponse, CreateOptimizationArgs>({
        query: (queryArg) => ({ url: `/api/optimizations`, method: 'POST', body: queryArg.optimizationModel }),
        invalidatesTags: ['Optimization']
      }),
      getActiveNodeEnergyConfigurations: build.query<
        GetActiveNodeEnergyConfigurationsResponse,
        GetActiveNodeEnergyConfigurationsArgs
      >({
        query: (queryArg) => ({
          url: `/api/nodes-energy-configurations`,
          params: {
            nodeId: queryArg.nodeId,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Node Energy Configurations']
      }),
      createNodeEnergyConfiguration: build.mutation<
        CreateNodeEnergyConfigurationResponse,
        CreateNodeEnergyConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/nodes-energy-configurations`,
          method: 'POST',
          body: queryArg.createNodeEnergyConfigurationParams
        }),
        invalidatesTags: ['Node Energy Configurations']
      }),
      deleteNodeEnergyConfigurationByNodeId: build.mutation<
        DeleteNodeEnergyConfigurationByNodeIdResponse,
        DeleteNodeEnergyConfigurationByNodeIdArgs
      >({
        query: (queryArg) => ({
          url: `/api/nodes-energy-configurations`,
          method: 'DELETE',
          params: {
            nodeId: queryArg.nodeId
          }
        }),
        invalidatesTags: ['Node Energy Configurations']
      }),
      listMarketRegions: build.query<ListMarketRegionsResponse, ListMarketRegionsArgs>({
        query: () => ({ url: `/api/market-regions` }),
        providesTags: ['Price Controller']
      }),
      createMarketRegion: build.mutation<CreateMarketRegionResponse, CreateMarketRegionArgs>({
        query: (queryArg) => ({ url: `/api/market-regions`, method: 'POST', body: queryArg.createMarketRegionRequest }),
        invalidatesTags: ['Price Controller']
      }),
      getAverageRates: build.mutation<GetAverageRatesResponse, GetAverageRatesArgs>({
        query: (queryArg) => ({
          url: `/api/energy/regions/averageRates`,
          method: 'POST',
          body: queryArg.averageRatesRequestBody
        }),
        invalidatesTags: ['Average Rates Controller']
      }),
      getLoadBalancerEvents: build.query<GetLoadBalancerEventsResponse, GetLoadBalancerEventsArgs>({
        query: (queryArg) => ({
          url: `/api/energy/events/load-balancer`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Load Balancer Events']
      }),
      createLoadBalancerEvent: build.mutation<CreateLoadBalancerEventResponse, CreateLoadBalancerEventArgs>({
        query: (queryArg) => ({
          url: `/api/energy/events/load-balancer`,
          method: 'POST',
          params: {
            origin: queryArg.origin,
            eventType: queryArg.eventType,
            chargerId: queryArg.chargerId,
            fleetId: queryArg.fleetId,
            depotId: queryArg.depotId,
            originTime: queryArg.originTime,
            executionTime: queryArg.executionTime
          }
        }),
        invalidatesTags: ['Load Balancer Events']
      }),
      getEnergyEfficiencyPredictions: build.query<
        GetEnergyEfficiencyPredictionsResponse,
        GetEnergyEfficiencyPredictionsArgs
      >({
        query: (queryArg) => ({
          url: `/api/energy-efficiency-predictions`,
          params: {
            fleetId: queryArg.fleetId,
            depotId: queryArg.depotId,
            vehicleId: queryArg.vehicleId,
            modelName: queryArg.modelName,
            validFrom: queryArg.validFrom,
            validTo: queryArg.validTo,
            windowFrom: queryArg.windowFrom,
            windowTo: queryArg.windowTo,
            mostRecent: queryArg.mostRecent,
            confidenceLower: queryArg.confidenceLower,
            confidenceUpper: queryArg.confidenceUpper,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Optimization']
      }),
      createEnergyEfficiencyPrediction: build.mutation<
        CreateEnergyEfficiencyPredictionResponse,
        CreateEnergyEfficiencyPredictionArgs
      >({
        query: (queryArg) => ({
          url: `/api/energy-efficiency-predictions`,
          method: 'POST',
          body: queryArg.createEnergyEfficiencyPredictionRequestParams
        }),
        invalidatesTags: ['Optimization']
      }),
      getTransactionProfileMappings1: build.query<
        GetTransactionProfileMappings1Response,
        GetTransactionProfileMappings1Args
      >({
        query: (queryArg) => ({
          url: `/api/ems-profiles`,
          params: {
            transactionId: queryArg.transactionId,
            chargerId: queryArg.chargerId,
            from: queryArg['from'],
            to: queryArg.to,
            isMostRecent: queryArg.isMostRecent,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Transaction Profile Mapping']
      }),
      getTransactionProfileMappings: build.mutation<
        GetTransactionProfileMappingsResponse,
        GetTransactionProfileMappingsArgs
      >({
        query: (queryArg) => ({
          url: `/api/ems-profiles`,
          method: 'POST',
          body: queryArg.transactionProfileMappingModel
        }),
        invalidatesTags: ['Transaction Profile Mapping']
      }),
      createEffectiveNodeEnergyLimit: build.mutation<
        CreateEffectiveNodeEnergyLimitResponse,
        CreateEffectiveNodeEnergyLimitArgs
      >({
        query: (queryArg) => ({
          url: `/api/effective-node-limit`,
          method: 'POST',
          body: queryArg.effectiveNodeEnergyLimitRequest
        }),
        invalidatesTags: ['Effective Node Energy Limit']
      }),
      searchCustomTariffs: build.query<SearchCustomTariffsResponse, SearchCustomTariffsArgs>({
        query: (queryArg) => ({
          url: `/api/custom-tariffs`,
          params: {
            orgId: queryArg.orgId,
            masterTariffId: queryArg.masterTariffId,
            isActive: queryArg.isActive
          }
        }),
        providesTags: ['Custom Tariff Controller']
      }),
      createCustomTariff: build.mutation<CreateCustomTariffResponse, CreateCustomTariffArgs>({
        query: (queryArg) => ({ url: `/api/custom-tariffs`, method: 'POST', body: queryArg.customTariffCreateRequest }),
        invalidatesTags: ['Custom Tariff Controller']
      }),
      getProfileHistories1: build.query<GetProfileHistories1Response, GetProfileHistories1Args>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/profile-history`,
          params: {
            latest: queryArg.latest,
            from: queryArg['from'],
            to: queryArg.to,
            count: queryArg.count,
            afterId: queryArg.afterId
          }
        }),
        providesTags: ['Profile History Records']
      }),
      createProfileHistory: build.mutation<CreateProfileHistoryResponse, CreateProfileHistoryArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/profile-history`,
          method: 'POST',
          body: queryArg.createProfileApplicationRecordParams
        }),
        invalidatesTags: ['Profile History Records']
      }),
      getScheduledChargerSessions: build.query<GetScheduledChargerSessionsResponse, GetScheduledChargerSessionsArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/events`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            type: queryArg['type'],
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Schedule']
      }),
      createScheduledChargerSession: build.mutation<
        CreateScheduledChargerSessionResponse,
        CreateScheduledChargerSessionArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/events`,
          method: 'POST',
          body: queryArg.scheduleRequestModel
        }),
        invalidatesTags: ['Schedule']
      }),
      getScheduledChargerSessionDetails: build.query<
        GetScheduledChargerSessionDetailsResponse,
        GetScheduledChargerSessionDetailsArgs
      >({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}/events/${queryArg.eventId}/details` }),
        providesTags: ['Schedule']
      }),
      saveScheduledChargerSessionDetails: build.mutation<
        SaveScheduledChargerSessionDetailsResponse,
        SaveScheduledChargerSessionDetailsArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/events/${queryArg.eventId}/details`,
          method: 'POST',
          body: queryArg.chargerEventSessionModel
        }),
        invalidatesTags: ['Schedule']
      }),
      createChargerEventPrediction: build.mutation<
        CreateChargerEventPredictionResponse,
        CreateChargerEventPredictionArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/event-predictions`,
          method: 'POST',
          body: queryArg.chargerEventPredictionRequestModel
        }),
        invalidatesTags: ['Schedule']
      }),
      getChargerEvents: build.query<GetChargerEventsResponse, GetChargerEventsArgs>({
        query: (queryArg) => ({
          url: `/api/charger-events`,
          params: {
            siteId: queryArg.siteId,
            chargerId: queryArg.chargerId,
            connectorId: queryArg.connectorId,
            vehicleId: queryArg.vehicleId,
            ocppTag: queryArg.ocppTag,
            eventType: queryArg.eventType,
            targetType: queryArg.targetType,
            startsBefore: queryArg.startsBefore,
            startsAfter: queryArg.startsAfter,
            endsBefore: queryArg.endsBefore,
            endsAfter: queryArg.endsAfter,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Charger Events']
      }),
      createChargerEvent: build.mutation<CreateChargerEventResponse, CreateChargerEventArgs>({
        query: (queryArg) => ({ url: `/api/charger-events`, method: 'POST', body: queryArg.chargerEventCreateModel }),
        invalidatesTags: ['Charger Events']
      }),
      getChargerEventDetailsById: build.query<GetChargerEventDetailsByIdResponse, GetChargerEventDetailsByIdArgs>({
        query: (queryArg) => ({ url: `/api/charger-events/${queryArg.eventId}/sessions` }),
        providesTags: ['Charger Events']
      }),
      addSessionToChargerEvent: build.mutation<AddSessionToChargerEventResponse, AddSessionToChargerEventArgs>({
        query: (queryArg) => ({
          url: `/api/charger-events/${queryArg.eventId}/sessions`,
          method: 'POST',
          body: queryArg.chargerEventNewSessionModel
        }),
        invalidatesTags: ['Charger Events']
      }),
      getVehicleOptimizations: build.query<GetVehicleOptimizationsResponse, GetVehicleOptimizationsArgs>({
        query: (queryArg) => ({
          url: `/api/vehicle-optimizations`,
          params: {
            vehicleIds: queryArg.vehicleIds,
            startsBefore: queryArg.startsBefore,
            startsAfter: queryArg.startsAfter,
            endsBefore: queryArg.endsBefore,
            endsAfter: queryArg.endsAfter,
            page: queryArg.page,
            count: queryArg.count,
            latest: queryArg.latest,
            mode: queryArg.mode
          }
        }),
        providesTags: ['Optimization']
      }),
      getTariffs: build.query<GetTariffsResponse, GetTariffsArgs>({
        query: (queryArg) => ({
          url: `/api/tariffs`,
          params: {
            lseId: queryArg.lseId,
            masterTariffId: queryArg.masterTariffId,
            effectiveOn: queryArg.effectiveOn,
            openOn: queryArg.openOn,
            isActive: queryArg.isActive,
            fromDateTime: queryArg.fromDateTime,
            toDateTime: queryArg.toDateTime,
            customerClasses: queryArg.customerClasses,
            chargeTypes: queryArg.chargeTypes,
            tariffTypes: queryArg.tariffTypes,
            serviceTypes: queryArg.serviceTypes,
            privacyFlags: queryArg.privacyFlags,
            zipCode: queryArg.zipCode,
            postCode: queryArg.postCode,
            country: queryArg.country,
            addressString: queryArg.addressString,
            riderId: queryArg.riderId,
            populateProperties: queryArg.populateProperties,
            populateRates: queryArg.populateRates,
            accountId: queryArg.accountId,
            consumption: queryArg.consumption,
            demand: queryArg.demand,
            hasNetMetering: queryArg.hasNetMetering,
            hasTimeOfUseRates: queryArg.hasTimeOfUseRates,
            hasTieredRates: queryArg.hasTieredRates,
            hasContractedRates: queryArg.hasContractedRates,
            bundleRates: queryArg.bundleRates,
            applicableRatesOnly: queryArg.applicableRatesOnly,
            filterRiderRates: queryArg.filterRiderRates,
            pageStart: queryArg.pageStart,
            pageCount: queryArg.pageCount
          }
        }),
        providesTags: ['Price Controller']
      }),
      getTariff: build.query<GetTariffResponse, GetTariffArgs>({
        query: (queryArg) => ({
          url: `/api/tariffs/${queryArg.masterTariffId}`,
          params: {
            fields: queryArg.fields,
            populateProperties: queryArg.populateProperties,
            populateRates: queryArg.populateRates,
            applicableRatesOnly: queryArg.applicableRatesOnly,
            lookupVariableRates: queryArg.lookupVariableRates,
            bundleRates: queryArg.bundleRates
          }
        }),
        providesTags: ['Price Controller']
      }),
      getDemandCharges: build.query<GetDemandChargesResponse, GetDemandChargesArgs>({
        query: (queryArg) => ({
          url: `/api/tariffs/${queryArg.masterTariffId}/demand-charges`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Price Controller']
      }),
      getPriceCurve: build.query<GetPriceCurveResponse, GetPriceCurveArgs>({
        query: (queryArg) => ({
          url: `/api/tariffs/smart-prices`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            tariffProvider: queryArg.tariffProvider,
            tariffId: queryArg.tariffId
          }
        }),
        providesTags: ['Price Controller']
      }),
      getLinkTelemetry: build.query<GetLinkTelemetryResponse, GetLinkTelemetryArgs>({
        query: (queryArg) => ({
          url: `/api/sites/${queryArg.siteId}/link-telemetry`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Synop Link']
      }),
      getSiteEnergyConfiguration: build.query<GetSiteEnergyConfigurationResponse, GetSiteEnergyConfigurationArgs>({
        query: (queryArg) => ({ url: `/api/sites/${queryArg.siteId}/energy-configurations/${queryArg.id}` }),
        providesTags: ['Site Feature Configurations']
      }),
      getBulkSiteEnergyConfigurations: build.query<
        GetBulkSiteEnergyConfigurationsResponse,
        GetBulkSiteEnergyConfigurationsArgs
      >({
        query: (queryArg) => ({
          url: `/api/sites/energy-configurations`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Site Feature Configurations']
      }),
      getBulkSiteReservationConfigurations: build.query<
        GetBulkSiteReservationConfigurationsResponse,
        GetBulkSiteReservationConfigurationsArgs
      >({
        query: (queryArg) => ({
          url: `/api/site-reservation-configurations`,
          params: {
            organizationId: queryArg.organizationId,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Reservations']
      }),
      getSiteGridProfile: build.query<GetSiteGridProfileResponse, GetSiteGridProfileArgs>({
        query: (queryArg) => ({ url: `/api/site-grid-profiles/${queryArg.id}` }),
        providesTags: ['Site Grid Profiles']
      }),
      getOptimization: build.query<GetOptimizationResponse, GetOptimizationArgs>({
        query: (queryArg) => ({ url: `/api/optimizations/${queryArg.id}` }),
        providesTags: ['Optimization']
      }),
      getNodeEnergyConfiguration: build.query<GetNodeEnergyConfigurationResponse, GetNodeEnergyConfigurationArgs>({
        query: (queryArg) => ({ url: `/api/nodes-energy-configurations/${queryArg.id}` }),
        providesTags: ['Node Energy Configurations']
      }),
      deleteNodeEnergyConfigurationId: build.mutation<
        DeleteNodeEnergyConfigurationIdResponse,
        DeleteNodeEnergyConfigurationIdArgs
      >({
        query: (queryArg) => ({ url: `/api/nodes-energy-configurations/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Node Energy Configurations']
      }),
      getLoadServingEntities: build.query<GetLoadServingEntitiesResponse, GetLoadServingEntitiesArgs>({
        query: (queryArg) => ({
          url: `/api/load-serving-entities`,
          params: {
            zipCode: queryArg.zipCode,
            country: queryArg.country,
            pageCount: queryArg.pageCount,
            pageStart: queryArg.pageStart,
            extendedFields: queryArg.extendedFields
          }
        }),
        providesTags: ['Price Controller']
      }),
      getGridEventIntegrations: build.query<GetGridEventIntegrationsResponse, GetGridEventIntegrationsArgs>({
        query: () => ({ url: `/api/grid-event-integrations` }),
        providesTags: ['Grid Event Integrations']
      }),
      getGridEventIntegration: build.query<GetGridEventIntegrationResponse, GetGridEventIntegrationArgs>({
        query: (queryArg) => ({ url: `/api/grid-event-integrations/${queryArg.gridEventIntegrationId}` }),
        providesTags: ['Grid Event Integrations']
      }),
      getGridEventIntegrationAccount: build.query<
        GetGridEventIntegrationAccountResponse,
        GetGridEventIntegrationAccountArgs
      >({
        query: (queryArg) => ({
          url: `/api/grid-event-integration-accounts/${queryArg.gridEventIntegrationAccountId}`
        }),
        providesTags: ['Grid Event Integration Accounts']
      }),
      getGridEventIntegrationEventByAccount: build.query<
        GetGridEventIntegrationEventByAccountResponse,
        GetGridEventIntegrationEventByAccountArgs
      >({
        query: (queryArg) => ({
          url: `/api/grid-event-integration-accounts/${queryArg.gridEventIntegrationAccountId}/events`
        }),
        providesTags: ['Grid Event Integration Accounts']
      }),
      getGridEventIntegrationEvent: build.query<GetGridEventIntegrationEventResponse, GetGridEventIntegrationEventArgs>(
        {
          query: (queryArg) => ({
            url: `/api/grid-event-integration-accounts/${queryArg.gridEventIntegrationAccountId}/events/${queryArg.externalId}`
          }),
          providesTags: ['Grid Event Integration Accounts']
        }
      ),
      getLoadBalancerEvent: build.query<GetLoadBalancerEventResponse, GetLoadBalancerEventArgs>({
        query: (queryArg) => ({ url: `/api/energy/events/load-balancer/${queryArg.id}` }),
        providesTags: ['Load Balancer Events']
      }),
      getEnergyEfficiencyPrediction: build.query<
        GetEnergyEfficiencyPredictionResponse,
        GetEnergyEfficiencyPredictionArgs
      >({
        query: (queryArg) => ({ url: `/api/energy-efficiency-predictions/${queryArg.id}` }),
        providesTags: ['Optimization']
      }),
      getEffectiveEnergyLimit: build.query<GetEffectiveEnergyLimitResponse, GetEffectiveEnergyLimitArgs>({
        query: (queryArg) => ({
          url: `/api/effective-node-limit/${queryArg.nodeId}`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Effective Node Energy Limit']
      }),
      getSmartPrices: build.query<GetSmartPricesResponse, GetSmartPricesArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/smart-prices`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Price Controller']
      }),
      getScheduledDepotPower: build.query<GetScheduledDepotPowerResponse, GetScheduledDepotPowerArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/power-forecast`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            asOf: queryArg.asOf,
            vehicleIds: queryArg.vehicleIds
          }
        }),
        providesTags: ['Grid']
      }),
      getDepotEventById: build.query<GetDepotEventByIdResponse, GetDepotEventByIdArgs>({
        query: (queryArg) => ({ url: `/api/depots/${queryArg.depotId}/events/${queryArg.eventId}` }),
        providesTags: ['Grid']
      }),
      cancelDepotEvent: build.mutation<CancelDepotEventResponse, CancelDepotEventArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/events/${queryArg.eventId}`,
          method: 'DELETE',
          params: {
            isRecurrence: queryArg.isRecurrence
          }
        }),
        invalidatesTags: ['Grid']
      }),
      getDepotEventDetails: build.query<GetDepotEventDetailsResponse, GetDepotEventDetailsArgs>({
        query: (queryArg) => ({ url: `/api/depots/${queryArg.depotId}/events/${queryArg.eventId}/details` }),
        providesTags: ['Grid']
      }),
      getScheduledChargerSessionsByDepot: build.query<
        GetScheduledChargerSessionsByDepotResponse,
        GetScheduledChargerSessionsByDepotArgs
      >({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/chargers/events`,
          params: {
            assetId: queryArg.assetId,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Schedule']
      }),
      getPredictedChargerEvents: build.query<GetPredictedChargerEventsResponse, GetPredictedChargerEventsArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/chargers/event-predictions`,
          params: {
            chargerId: queryArg.chargerId,
            dispenserId: queryArg.dispenserId,
            assetId: queryArg.assetId,
            from: queryArg['from'],
            to: queryArg.to,
            validFrom: queryArg.validFrom,
            validTo: queryArg.validTo,
            mostRecent: queryArg.mostRecent,
            modelName: queryArg.modelName,
            chargerEventId: queryArg.chargerEventId,
            confidenceLower: queryArg.confidenceLower,
            confidenceUpper: queryArg.confidenceUpper,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Schedule']
      }),
      getDepotEvents: build.query<GetDepotEventsResponse, GetDepotEventsArgs>({
        query: (queryArg) => ({
          url: `/api/depots/events`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Grid']
      }),
      getScheduledChargerSessionTelemetry: build.query<
        GetScheduledChargerSessionTelemetryResponse,
        GetScheduledChargerSessionTelemetryArgs
      >({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}/events/${queryArg.eventId}/telemetry` }),
        providesTags: ['Schedule']
      }),
      getProfileHistory: build.query<GetProfileHistoryResponse, GetProfileHistoryArgs>({
        query: (queryArg) => ({ url: `/api/chargers/profile-history/${queryArg.id}` }),
        providesTags: ['Profile History Records']
      }),
      deleteTelemetryExclusionPeriod: build.mutation<
        DeleteTelemetryExclusionPeriodResponse,
        DeleteTelemetryExclusionPeriodArgs
      >({
        query: (queryArg) => ({ url: `/api/telemetry-exclusion-periods/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Telemetry Exclusion Periods']
      }),
      getApiVehiclesByIdTimeToSoc: build.query<GetApiVehiclesByIdTimeToSocResponse, GetApiVehiclesByIdTimeToSocArgs>({
        query: (queryArg) => ({
          url: `/api/vehicles/${queryArg.id}/time-to-soc`,
          params: {
            targetSoc: queryArg.targetSoc,
            powerOffered: queryArg.powerOffered
          }
        }),
        providesTags: ['Vehicles']
      }),
      getApiTransactionsTimeToSoc: build.query<GetApiTransactionsTimeToSocResponse, GetApiTransactionsTimeToSocArgs>({
        query: (queryArg) => ({
          url: `/api/transactions/time-to-soc`,
          params: {
            ocppTag: queryArg.ocppTag,
            targetSoc: queryArg.targetSoc,
            powerOffered: queryArg.powerOffered
          }
        }),
        providesTags: ['Charging Transactions']
      }),
      getApiMlTimeToSoc: build.query<GetApiMlTimeToSocResponse, GetApiMlTimeToSocArgs>({
        query: (queryArg) => ({
          url: `/api/ml/time-to-soc`,
          params: {
            soc: queryArg.soc,
            deltaSoc: queryArg.deltaSoc,
            powerOffered: queryArg.powerOffered,
            batteryCapacity: queryArg.batteryCapacity,
            make: queryArg.make,
            model: queryArg.model,
            modelYear: queryArg.modelYear
          }
        }),
        providesTags: ['ML Models']
      }),
      getWeather: build.query<GetWeatherResponse, GetWeatherArgs>({
        query: (queryArg) => ({
          url: `/api/v1/weather`,
          params: {
            lat: queryArg.lat,
            lon: queryArg.lon,
            lang: queryArg.lang,
            units: queryArg.units
          }
        }),
        providesTags: ['Weather']
      }),
      getWeatherForecast: build.query<GetWeatherForecastResponse, GetWeatherForecastArgs>({
        query: (queryArg) => ({
          url: `/api/v1/weather/forecast`,
          params: {
            lat: queryArg.lat,
            lon: queryArg.lon,
            lang: queryArg.lang,
            units: queryArg.units
          }
        }),
        providesTags: ['Weather']
      }),
      updateTelematicsFeedCursorStatus: build.mutation<
        UpdateTelematicsFeedCursorStatusResponse,
        UpdateTelematicsFeedCursorStatusArgs
      >({
        query: (queryArg) => ({
          url: `/api/telematics-feed-cursors/${queryArg.id}/status`,
          method: 'PUT',
          body: queryArg.updateTelematicsFeedCursorStatusRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Telematics Feed Cursors']
      }),
      updateIntegrationStatus: build.mutation<UpdateIntegrationStatusResponse, UpdateIntegrationStatusArgs>({
        query: (queryArg) => ({
          url: `/api/integrations/${queryArg.id}/status`,
          method: 'PUT',
          body: queryArg.updateIntegrationStatusRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Integrations']
      }),
      searchTelematicsFeedCursors: build.query<SearchTelematicsFeedCursorsResponse, SearchTelematicsFeedCursorsArgs>({
        query: (queryArg) => ({
          url: `/api/telematics-feed-cursors`,
          params: {
            integrationId: queryArg.integrationId,
            feedType: queryArg.feedType
          }
        }),
        providesTags: ['Telematics Feed Cursors']
      }),
      createTelematicsFeedCursor: build.mutation<CreateTelematicsFeedCursorResponse, CreateTelematicsFeedCursorArgs>({
        query: (queryArg) => ({
          url: `/api/telematics-feed-cursors`,
          method: 'POST',
          body: queryArg.createTelematicsFeedCursorRequest
        }),
        invalidatesTags: ['Telematics Feed Cursors']
      }),
      searchPaymentTerminals: build.query<SearchPaymentTerminalsResponse, SearchPaymentTerminalsArgs>({
        query: (queryArg) => ({
          url: `/api/payment-terminals`,
          params: {
            organizationId: queryArg.organizationId,
            integrationId: queryArg.integrationId,
            serialNumber: queryArg.serialNumber,
            chargerId: queryArg.chargerId,
            chargerIds: queryArg.chargerIds
          }
        }),
        providesTags: ['Payment Terminals']
      }),
      createPaymentTerminal: build.mutation<CreatePaymentTerminalResponse, CreatePaymentTerminalArgs>({
        query: (queryArg) => ({
          url: `/api/payment-terminals`,
          method: 'POST',
          body: queryArg.createPaymentTerminalRequest
        }),
        invalidatesTags: ['Payment Terminals', 'Organization Integration Providers']
      }),
      assignPaymentTerminals: build.mutation<AssignPaymentTerminalsResponse, AssignPaymentTerminalsArgs>({
        query: (queryArg) => ({
          url: `/api/payment-terminals`,
          method: 'PATCH',
          body: queryArg.assignPaymentTerminalsRequest
        }),
        invalidatesTags: ['Payment Terminals', 'Organization Integration Providers']
      }),
      searchPaymentTerminalSessions: build.query<
        SearchPaymentTerminalSessionsResponse,
        SearchPaymentTerminalSessionsArgs
      >({
        query: (queryArg) => ({
          url: `/api/payment-terminal-sessions`,
          params: {
            integrationProviderId: queryArg.integrationProviderId,
            externalSessionId: queryArg.externalSessionId,
            lastModifiedFrom: queryArg.lastModifiedFrom,
            lastModifiedTo: queryArg.lastModifiedTo,
            paymentTerminalId: queryArg.paymentTerminalId,
            chargerId: queryArg.chargerId,
            connectorId: queryArg.connectorId,
            status: queryArg.status,
            lineItemId: queryArg.lineItemId,
            transactionId: queryArg.transactionId,
            authTag: queryArg.authTag
          }
        }),
        providesTags: ['Payment Terminal Sessions']
      }),
      createPaymentTerminalSession: build.mutation<
        CreatePaymentTerminalSessionResponse,
        CreatePaymentTerminalSessionArgs
      >({
        query: (queryArg) => ({
          url: `/api/payment-terminal-sessions`,
          method: 'POST',
          body: queryArg.createPaymentTerminalSessionRequest
        }),
        invalidatesTags: ['Payment Terminal Sessions']
      }),
      searchIntegrations: build.query<SearchIntegrationsResponse, SearchIntegrationsArgs>({
        query: (queryArg) => ({
          url: `/api/integrations`,
          params: {
            integrationProviderId: queryArg.integrationProviderId,
            organizationId: queryArg.organizationId,
            meterId: queryArg.meterId
          }
        }),
        providesTags: ['Integrations']
      }),
      createIntegration: build.mutation<CreateIntegrationResponse, CreateIntegrationArgs>({
        query: (queryArg) => ({ url: `/api/integrations`, method: 'POST', body: queryArg.createIntegrationRequest }),
        invalidatesTags: ['Integrations', 'Organization Integration Providers']
      }),
      searchIntegrationProviders: build.query<SearchIntegrationProvidersResponse, SearchIntegrationProvidersArgs>({
        query: (queryArg) => ({
          url: `/api/integration-providers`,
          params: {
            name: queryArg.name,
            integrationKey: queryArg.integrationKey,
            integrationType: queryArg.integrationType
          }
        }),
        providesTags: ['Integration Providers']
      }),
      createIntegrationProvider: build.mutation<CreateIntegrationProviderResponse, CreateIntegrationProviderArgs>({
        query: (queryArg) => ({
          url: `/api/integration-providers`,
          method: 'POST',
          body: queryArg.createIntegrationProviderRequest
        }),
        invalidatesTags: ['Integration Providers']
      }),
      retrieveTelematicsFeedCursor: build.query<RetrieveTelematicsFeedCursorResponse, RetrieveTelematicsFeedCursorArgs>(
        {
          query: (queryArg) => ({ url: `/api/telematics-feed-cursors/${queryArg.id}` }),
          providesTags: ['Telematics Feed Cursors']
        }
      ),
      deleteTelematicsFeedCursor: build.mutation<DeleteTelematicsFeedCursorResponse, DeleteTelematicsFeedCursorArgs>({
        query: (queryArg) => ({
          url: `/api/telematics-feed-cursors/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Telematics Feed Cursors']
      }),
      updateTelematicsFeedCursor: build.mutation<UpdateTelematicsFeedCursorResponse, UpdateTelematicsFeedCursorArgs>({
        query: (queryArg) => ({
          url: `/api/telematics-feed-cursors/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateTelematicsFeedCursorRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Telematics Feed Cursors']
      }),
      retrievePaymentTerminal: build.query<RetrievePaymentTerminalResponse, RetrievePaymentTerminalArgs>({
        query: (queryArg) => ({ url: `/api/payment-terminals/${queryArg.id}` }),
        providesTags: ['Payment Terminals']
      }),
      deletePaymentTerminal: build.mutation<DeletePaymentTerminalResponse, DeletePaymentTerminalArgs>({
        query: (queryArg) => ({
          url: `/api/payment-terminals/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Payment Terminals', 'Organization Integration Providers']
      }),
      updatePaymentTerminal: build.mutation<UpdatePaymentTerminalResponse, UpdatePaymentTerminalArgs>({
        query: (queryArg) => ({
          url: `/api/payment-terminals/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updatePaymentTerminalRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Payment Terminals', 'Organization Integration Providers']
      }),
      retrievePaymentTerminalSession: build.query<
        RetrievePaymentTerminalSessionResponse,
        RetrievePaymentTerminalSessionArgs
      >({
        query: (queryArg) => ({ url: `/api/payment-terminal-sessions/${queryArg.id}` }),
        providesTags: ['Payment Terminal Sessions']
      }),
      deletePaymentTerminalSession: build.mutation<
        DeletePaymentTerminalSessionResponse,
        DeletePaymentTerminalSessionArgs
      >({
        query: (queryArg) => ({
          url: `/api/payment-terminal-sessions/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Payment Terminal Sessions']
      }),
      updatePaymentTerminalSession: build.mutation<
        UpdatePaymentTerminalSessionResponse,
        UpdatePaymentTerminalSessionArgs
      >({
        query: (queryArg) => ({
          url: `/api/payment-terminal-sessions/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updatePaymentTerminalSessionRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Payment Terminal Sessions']
      }),
      retrieveIntegration: build.query<RetrieveIntegrationResponse, RetrieveIntegrationArgs>({
        query: (queryArg) => ({
          url: `/api/integrations/${queryArg.id}`,
          params: {
            includeSecrets: queryArg.includeSecrets
          }
        }),
        providesTags: ['Integrations']
      }),
      deleteIntegration: build.mutation<DeleteIntegrationResponse, DeleteIntegrationArgs>({
        query: (queryArg) => ({
          url: `/api/integrations/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Integrations', 'Organization Integration Providers']
      }),
      updateIntegration: build.mutation<UpdateIntegrationResponse, UpdateIntegrationArgs>({
        query: (queryArg) => ({
          url: `/api/integrations/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateIntegrationRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Integrations', 'Organization Integration Providers']
      }),
      retrieveIntegrationProvider: build.query<RetrieveIntegrationProviderResponse, RetrieveIntegrationProviderArgs>({
        query: (queryArg) => ({ url: `/api/integration-providers/${queryArg.id}` }),
        providesTags: ['Integration Providers']
      }),
      deleteIntegrationProvider: build.mutation<DeleteIntegrationProviderResponse, DeleteIntegrationProviderArgs>({
        query: (queryArg) => ({
          url: `/api/integration-providers/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Integration Providers']
      }),
      updateIntegrationProvider: build.mutation<UpdateIntegrationProviderResponse, UpdateIntegrationProviderArgs>({
        query: (queryArg) => ({
          url: `/api/integration-providers/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateIntegrationProviderRequest,
          headers: {
            'If-Match': queryArg['If-Match']
          }
        }),
        invalidatesTags: ['Integration Providers']
      }),
      searchOrganizationIntegrationProviders: build.query<
        SearchOrganizationIntegrationProvidersResponse,
        SearchOrganizationIntegrationProvidersArgs
      >({
        query: (queryArg) => ({
          url: `/api/organization-integration-providers`,
          params: {
            organizationId: queryArg.organizationId,
            integrationProviderId: queryArg.integrationProviderId
          }
        }),
        providesTags: ['Organization Integration Providers']
      }),
      retrieveOrganizationIntegrationProvider: build.query<
        RetrieveOrganizationIntegrationProviderResponse,
        RetrieveOrganizationIntegrationProviderArgs
      >({
        query: (queryArg) => ({ url: `/api/organization-integration-providers/${queryArg.id}` }),
        providesTags: ['Organization Integration Providers']
      }),
      retrieveIntegrationFeedCursor: build.query<
        RetrieveIntegrationFeedCursorResponse,
        RetrieveIntegrationFeedCursorArgs
      >({
        query: (queryArg) => ({ url: `/api/integrations/${queryArg.id}/feed-cursors/${queryArg.feedType}` }),
        providesTags: ['Integrations', 'Telematics Feed Cursors']
      }),
      ocppLogAnalysisApiV1OcppLogAnalysisPost: build.mutation<
        OcppLogAnalysisApiV1OcppLogAnalysisPostResponse,
        OcppLogAnalysisApiV1OcppLogAnalysisPostArgs
      >({
        query: (queryArg) => ({ url: `/api/v1/ocpp-log-analysis`, method: 'POST', body: queryArg.logAnalysisRequest }),
        invalidatesTags: ['analysis']
      }),
      submitFeedbackApiV1OcppLogAnalysisFeedbackPost: build.mutation<
        SubmitFeedbackApiV1OcppLogAnalysisFeedbackPostResponse,
        SubmitFeedbackApiV1OcppLogAnalysisFeedbackPostArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-log-analysis-feedback`,
          method: 'POST',
          body: queryArg.createFeedbackRequest
        }),
        invalidatesTags: ['analysis']
      }),
      updateFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdPut: build.mutation<
        UpdateFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdPutResponse,
        UpdateFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdPutArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-log-analysis-feedback/${queryArg.feedbackId}`,
          method: 'PUT',
          body: queryArg.updateFeedbackRequest
        }),
        invalidatesTags: ['analysis']
      }),
      deleteFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdDelete: build.mutation<
        DeleteFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdDeleteResponse,
        DeleteFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdDeleteArgs
      >({
        query: (queryArg) => ({ url: `/api/v1/ocpp-log-analysis-feedback/${queryArg.feedbackId}`, method: 'DELETE' }),
        invalidatesTags: ['analysis']
      }),
      getSchemaVersionApiChargerLlmSchemaVersionGet: build.query<
        GetSchemaVersionApiChargerLlmSchemaVersionGetResponse,
        GetSchemaVersionApiChargerLlmSchemaVersionGetArgs
      >({
        query: () => ({ url: `/api/charger-llm/schema-version` }),
        providesTags: ['schema']
      }),
      syncOcpiTariffs: build.mutation<SyncOcpiTariffsResponse, SyncOcpiTariffsArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/sync-tariffs`, method: 'POST', body: queryArg.syncTariffsRequest }),
        invalidatesTags: ['Sync']
      }),
      syncOcpiLocations: build.mutation<SyncOcpiLocationsResponse, SyncOcpiLocationsArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/sync-locations`, method: 'POST', body: queryArg.syncLocationsRequest }),
        invalidatesTags: ['Sync']
      }),
      syncOcpiIntegrations: build.mutation<SyncOcpiIntegrationsResponse, SyncOcpiIntegrationsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/sync-integrations`,
          method: 'POST',
          body: queryArg.syncIntegrationsRequest
        }),
        invalidatesTags: ['Sync']
      }),
      sendTariffs: build.mutation<SendTariffsResponse, SendTariffsArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/send-tariffs`, method: 'POST', body: queryArg.sendRequest }),
        invalidatesTags: ['Send']
      }),
      sendLocations: build.mutation<SendLocationsResponse, SendLocationsArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/send-locations`, method: 'POST', body: queryArg.sendRequest }),
        invalidatesTags: ['Send']
      }),
      authorize: build.mutation<AuthorizeResponse, AuthorizeArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/ocpp-tag-authorization`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['OCPP Tag Authorization']
      }),
      deleteUnusedOcpiTariffs: build.mutation<DeleteUnusedOcpiTariffsResponse, DeleteUnusedOcpiTariffsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/delete-unused-tariffs`,
          method: 'POST',
          body: queryArg.deleteUnusedTariffsRequest
        }),
        invalidatesTags: ['Sync']
      }),
      getCredentials: build.query<GetCredentialsResponse, GetCredentialsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/credentials`,
          params: {
            integration_key: queryArg.integrationKey
          }
        }),
        providesTags: ['Credentials']
      }),
      createCredentials: build.mutation<CreateCredentialsResponse, CreateCredentialsArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/credentials`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Credentials']
      }),
      getSessions: build.query<GetSessionsResponse, GetSessionsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/integrations/${queryArg.integrationId}/sessions`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Integrations']
      }),
      getCdrs: build.query<GetCdrsResponse, GetCdrsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/integrations/${queryArg.integrationId}/cdrs`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Integrations']
      }),
      getRequestLogs: build.query<GetRequestLogsResponse, GetRequestLogsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/credentials/${queryArg.credentialId}/request-logs`,
          params: {
            ocpi_request_id: queryArg.ocpiRequestId,
            ocpi_correlation_id: queryArg.ocpiCorrelationId,
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Credentials']
      }),
      getRequestLog: build.query<GetRequestLogResponse, GetRequestLogArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/credentials/${queryArg.credentialId}/request-logs/${queryArg.requestId}`
        }),
        providesTags: ['Credentials']
      }),
      getAuthorizationDecisions: build.query<GetAuthorizationDecisionsResponse, GetAuthorizationDecisionsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/authorization-decisions`,
          params: {
            id_tag: queryArg.idTag,
            evse_uid: queryArg.evseUid,
            charger_id: queryArg.chargerId,
            location_id: queryArg.locationId,
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Authorization Decisions']
      }),
      getAuthorizationDecision: build.query<GetAuthorizationDecisionResponse, GetAuthorizationDecisionArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/authorization-decisions/${queryArg.id}` }),
        providesTags: ['Authorization Decisions']
      }),
      getVirtualChargerGroup: build.query<GetVirtualChargerGroupResponse, GetVirtualChargerGroupArgs>({
        query: (queryArg) => ({ url: `/api/v1/virtual-chargers/${queryArg.virtualChargerId}` }),
        providesTags: ['Virtual Chargers']
      }),
      updateVirtualChargerGroup: build.mutation<UpdateVirtualChargerGroupResponse, UpdateVirtualChargerGroupArgs>({
        query: (queryArg) => ({
          url: `/api/v1/virtual-chargers/${queryArg.virtualChargerId}`,
          method: 'PUT',
          body: queryArg.virtualChargerGroupUpdateParams
        }),
        invalidatesTags: ['Virtual Chargers']
      }),
      deleteVirtualChargerGroup: build.mutation<DeleteVirtualChargerGroupResponse, DeleteVirtualChargerGroupArgs>({
        query: (queryArg) => ({ url: `/api/v1/virtual-chargers/${queryArg.virtualChargerId}`, method: 'DELETE' }),
        invalidatesTags: ['Virtual Chargers']
      }),
      getSkill: build.query<GetSkillResponse, GetSkillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skills/${queryArg.skillId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-skill-api']
      }),
      updateSkill: build.mutation<UpdateSkillResponse, UpdateSkillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skills/${queryArg.skillId}`,
          method: 'PUT',
          body: queryArg.assistantSkillUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-skill-api']
      }),
      deleteSkill: build.mutation<DeleteSkillResponse, DeleteSkillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skills/${queryArg.skillId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-skill-api']
      }),
      getSkillSchedule: build.query<GetSkillScheduleResponse, GetSkillScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules/${queryArg.scheduleId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-skill-schedule-api']
      }),
      updateSkillSchedule: build.mutation<UpdateSkillScheduleResponse, UpdateSkillScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules/${queryArg.scheduleId}`,
          method: 'PUT',
          body: queryArg.assistantSkillScheduleUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['assistant-skill-schedule-api']
      }),
      deleteSkillSchedule: build.mutation<DeleteSkillScheduleResponse, DeleteSkillScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules/${queryArg.scheduleId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-skill-schedule-api']
      }),
      listVirtualChargerGroups: build.query<ListVirtualChargerGroupsResponse, ListVirtualChargerGroupsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/virtual-chargers`,
          params: {
            siteId: queryArg.siteId,
            chargerId: queryArg.chargerId
          }
        }),
        providesTags: ['Virtual Chargers']
      }),
      createVirtualChargerGroup: build.mutation<CreateVirtualChargerGroupResponse, CreateVirtualChargerGroupArgs>({
        query: (queryArg) => ({
          url: `/api/v1/virtual-chargers`,
          method: 'POST',
          body: queryArg.virtualChargerGroupCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Virtual Chargers']
      }),
      bulkCreateVirtualChargerGroups: build.mutation<
        BulkCreateVirtualChargerGroupsResponse,
        BulkCreateVirtualChargerGroupsArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/virtual-chargers/bulk`,
          method: 'POST',
          body: queryArg.bulkCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Virtual Chargers']
      }),
      markAsRead: build.mutation<MarkAsReadResponse, MarkAsReadArgs>({
        query: (queryArg) => ({ url: `/api/v1/ops-notifications/${queryArg.notificationId}/read`, method: 'POST' }),
        invalidatesTags: ['Notifications']
      }),
      markAllAsRead: build.mutation<MarkAllAsReadResponse, MarkAllAsReadArgs>({
        query: () => ({ url: `/api/v1/ops-notifications/read-all`, method: 'POST' }),
        invalidatesTags: ['Notifications']
      }),
      listSaves: build.query<ListSavesResponse, ListSavesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['generative-dashboard-api']
      }),
      createSave: build.mutation<CreateSaveResponse, CreateSaveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves`,
          method: 'POST',
          body: queryArg.generativeDashboardSaveCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['generative-dashboard-api']
      }),
      refresh: build.mutation<RefreshResponse, RefreshArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/refresh`,
          method: 'POST',
          body: queryArg.generativeDashboardRefreshParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['generative-dashboard-api']
      }),
      listFirmwareVersions: build.query<ListFirmwareVersionsResponse, ListFirmwareVersionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-versions`,
          params: {
            vendor: queryArg.vendor,
            model: queryArg.model,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Firmware Versions']
      }),
      createFirmwareVersion: build.mutation<CreateFirmwareVersionResponse, CreateFirmwareVersionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-versions`,
          method: 'POST',
          body: queryArg.firmwareVersionCreateParams
        }),
        invalidatesTags: ['Firmware Versions']
      }),
      completeUpload: build.mutation<CompleteUploadResponse, CompleteUploadArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-versions/${queryArg.firmwareVersionId}/complete-upload`,
          method: 'POST'
        }),
        invalidatesTags: ['Firmware Versions']
      }),
      listDeployments: build.query<ListDeploymentsResponse, ListDeploymentsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Firmware Deployments']
      }),
      createDeployment: build.mutation<CreateDeploymentResponse, CreateDeploymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments`,
          method: 'POST',
          body: queryArg.firmwareDeploymentCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      retryStation: build.mutation<RetryStationResponse, RetryStationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/stations/${queryArg.chargerId}/retry`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      resumeSite: build.mutation<ResumeSiteResponse, ResumeSiteArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/sites/${queryArg.siteId}/resume`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      cancelSite: build.mutation<CancelSiteResponse, CancelSiteArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/sites/${queryArg.siteId}/cancel`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      resumeDeployment: build.mutation<ResumeDeploymentResponse, ResumeDeploymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/resume`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      pauseDeployment: build.mutation<PauseDeploymentResponse, PauseDeploymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/pause`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      cancelDeployment: build.mutation<CancelDeploymentResponse, CancelDeploymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/cancel`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Firmware Deployments']
      }),
      createBugReport: build.mutation<CreateBugReportResponse, CreateBugReportArgs>({
        query: (queryArg) => ({
          url: `/api/v1/bug-reports`,
          method: 'POST',
          body: queryArg.bugReportCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['Bug reports']
      }),
      listSkills: build.query<ListSkillsResponse, ListSkillsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skills`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            personal_limit: queryArg.personalLimit,
            personal_starting_after: queryArg.personalStartingAfter,
            organization_limit: queryArg.organizationLimit,
            organization_starting_after: queryArg.organizationStartingAfter
          }
        }),
        providesTags: ['assistant-skill-api']
      }),
      createSkill: build.mutation<CreateSkillResponse, CreateSkillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skills`,
          method: 'POST',
          body: queryArg.assistantSkillCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-skill-api']
      }),
      saveFromConversation: build.mutation<SaveFromConversationResponse, SaveFromConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skills/from-conversation`,
          method: 'POST',
          body: queryArg.assistantSkillSaveFromConversationParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-skill-api']
      }),
      listSkillSchedules: build.query<ListSkillSchedulesResponse, ListSkillSchedulesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['assistant-skill-schedule-api']
      }),
      createSkillSchedule: build.mutation<CreateSkillScheduleResponse, CreateSkillScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules`,
          method: 'POST',
          body: queryArg.assistantSkillScheduleCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['assistant-skill-schedule-api']
      }),
      listConversations: build.query<ListConversationsResponse, ListConversationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['assistant-api']
      }),
      createConversation: build.mutation<CreateConversationResponse, CreateConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations`,
          method: 'POST',
          body: queryArg.assistantConversationCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      shareConversation: build.mutation<ShareConversationResponse, ShareConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/share`,
          method: 'POST',
          body: queryArg.assistantConversationShareParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      sendMessage: build.mutation<SendMessageResponse, SendMessageArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/messages`,
          method: 'POST',
          body: queryArg.assistantSendMessageParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      setMessageFeedback: build.mutation<SetMessageFeedbackResponse, SetMessageFeedbackArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/messages/${queryArg.messageId}/feedback`,
          method: 'POST',
          body: queryArg.assistantMessageFeedbackParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      uploadAttachment: build.mutation<UploadAttachmentResponse, UploadAttachmentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/attachments`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-attachment-api']
      }),
      runAction: build.mutation<RunActionResponse, RunActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/run`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      rejectAction: build.mutation<RejectActionResponse, RejectActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/reject`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      dispatch: build.mutation<DispatchResponse, DispatchArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/dispatch`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id'],
            Authorization: queryArg.authorization
          }
        }),
        invalidatesTags: ['assistant-api']
      }),
      listScores: build.query<ListScoresResponse, ListScoresArgs>({
        query: (queryArg) => ({
          url: `/api/v1/arcade-scores`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            scope: queryArg.scope,
            game: queryArg.game,
            board: queryArg.board,
            order: queryArg.order,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['arcade-score-api']
      }),
      createScore: build.mutation<CreateScoreResponse, CreateScoreArgs>({
        query: (queryArg) => ({
          url: `/api/v1/arcade-scores`,
          method: 'POST',
          body: queryArg.arcadeScoreCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['arcade-score-api']
      }),
      getDecisionLogs: build.query<GetDecisionLogsResponse, GetDecisionLogsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/virtual-charger-logs`,
          params: {
            virtualChargerId: queryArg.virtualChargerId,
            siteId: queryArg.siteId,
            from: queryArg['from'],
            to: queryArg.to,
            limit: queryArg.limit,
            nextToken: queryArg.nextToken
          }
        }),
        providesTags: ['Virtual Charger Logs']
      }),
      getOpsNotifications: build.query<GetOpsNotificationsResponse, GetOpsNotificationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ops-notifications`,
          params: {
            unreadOnly: queryArg.unreadOnly,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Notifications']
      }),
      getNotification: build.query<GetNotificationResponse, GetNotificationArgs>({
        query: (queryArg) => ({ url: `/api/v1/ops-notifications/${queryArg.notificationId}` }),
        providesTags: ['Notifications']
      }),
      deleteNotification: build.mutation<DeleteNotificationResponse, DeleteNotificationArgs>({
        query: (queryArg) => ({ url: `/api/v1/ops-notifications/${queryArg.notificationId}`, method: 'DELETE' }),
        invalidatesTags: ['Notifications']
      }),
      getSave: build.query<GetSaveResponse, GetSaveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves/${queryArg.saveId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['generative-dashboard-api']
      }),
      deleteSave: build.mutation<DeleteSaveResponse, DeleteSaveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves/${queryArg.saveId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['generative-dashboard-api']
      }),
      getFirmwareVersion: build.query<GetFirmwareVersionResponse, GetFirmwareVersionArgs>({
        query: (queryArg) => ({ url: `/api/v1/firmware-versions/${queryArg.firmwareVersionId}` }),
        providesTags: ['Firmware Versions']
      }),
      deleteFirmwareVersion: build.mutation<DeleteFirmwareVersionResponse, DeleteFirmwareVersionArgs>({
        query: (queryArg) => ({ url: `/api/v1/firmware-versions/${queryArg.firmwareVersionId}`, method: 'DELETE' }),
        invalidatesTags: ['Firmware Versions']
      }),
      getDownloadUrl: build.query<GetDownloadUrlResponse, GetDownloadUrlArgs>({
        query: (queryArg) => ({ url: `/api/v1/firmware-versions/${queryArg.firmwareVersionId}/download-url` }),
        providesTags: ['Firmware Versions']
      }),
      getDeployment: build.query<GetDeploymentResponse, GetDeploymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Firmware Deployments']
      }),
      listStations: build.query<ListStationsResponse, ListStationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/firmware-deployments/${queryArg.deploymentId}/stations`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Firmware Deployments']
      }),
      listSkillScheduleRuns: build.query<ListSkillScheduleRunsResponse, ListSkillScheduleRunsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules/${queryArg.scheduleId}/runs`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['assistant-skill-schedule-api']
      }),
      getSkillScheduleRun: build.query<GetSkillScheduleRunResponse, GetSkillScheduleRunArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules/runs/${queryArg.runId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-skill-schedule-api']
      }),
      getSkillScheduleRunTranscript: build.query<
        GetSkillScheduleRunTranscriptResponse,
        GetSkillScheduleRunTranscriptArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/assistant/skill-schedules/runs/${queryArg.runId}/transcript`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-skill-schedule-api']
      }),
      getConversation: build.query<GetConversationResponse, GetConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-api']
      }),
      getAction: build.query<GetActionResponse, GetActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-api']
      }),
      streamAction: build.query<StreamActionResponse, StreamActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/stream`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['assistant-api']
      }),
      ingestDescartesRoute: build.mutation<IngestDescartesRouteResponse, IngestDescartesRouteArgs>({
        query: (queryArg) => ({ url: `/api/v1/routes/descartes`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Routes']
      }),
      listActivityEvents: build.query<ListActivityEventsResponse, ListActivityEventsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/activity-events/`,
          params: {
            since: queryArg.since,
            until: queryArg.until,
            page: queryArg.page,
            count: queryArg.count,
            event_category: queryArg.eventCategory,
            event_type: queryArg.eventType,
            actor_id: queryArg.actorId,
            resource_type: queryArg.resourceType,
            resource_id: queryArg.resourceId,
            response_status: queryArg.responseStatus,
            ip_hashed: queryArg.ipHashed,
            endpoint: queryArg.endpoint,
            org_depth: queryArg.orgDepth
          }
        }),
        providesTags: ['Activity Events']
      }),
      getWhatsNewFeedV1WhatsNewGet: build.query<GetWhatsNewFeedV1WhatsNewGetResponse, GetWhatsNewFeedV1WhatsNewGetArgs>(
        {
          query: () => ({ url: `/v1/whats-new` }),
          providesTags: ['whats-new']
        }
      ),
      markNotesSeenV1WhatsNewSeenPost: build.mutation<
        MarkNotesSeenV1WhatsNewSeenPostResponse,
        MarkNotesSeenV1WhatsNewSeenPostArgs
      >({
        query: (queryArg) => ({ url: `/v1/whats-new/seen`, method: 'POST', body: queryArg.markSeenRequest }),
        invalidatesTags: ['whats-new']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type GetSiteReservationConfigurationResponse =
  /** status 200 Configuration retrieved successfully */ SiteReservationConfigurationResponseModel
export type GetSiteReservationConfigurationArgs = {
  siteId: string
}
export type UpdateSiteReservationConfigurationResponse =
  /** status 200 Configuration updated successfully */ SiteReservationConfigurationResponseModel
export type UpdateSiteReservationConfigurationArgs = {
  siteId: string
  siteReservationConfigurationUpdateRequest: SiteReservationConfigurationUpdateRequest
}
export type CreateSiteReservationConfigurationResponse =
  /** status 200 Configuration created successfully */ SiteReservationConfigurationResponseModel
export type CreateSiteReservationConfigurationArgs = {
  siteId: string
}
export type GetSiteGridProfilesResponse = /** status 200 OK */ SiteGridProfileModel
export type GetSiteGridProfilesArgs = {
  gridEventIntegrationAccountId?: string
}
export type UpdateSiteGridProfileResponse = /** status 200 Updated */ SiteGridProfileModel
export type UpdateSiteGridProfileArgs = {
  updateSiteGridProfileRequestParams: UpdateSiteGridProfileRequestParams
}
export type CreateSiteGridProfileResponse = /** status 201 Created */ SiteGridProfileModel
export type CreateSiteGridProfileArgs = {
  createSiteGridProfileRequestParams: CreateSiteGridProfileRequestParams
}
export type GetScheduledTripsResponse = /** status 200 Success */ PagedResponseV2ScheduledVehicleTripModel
export type GetScheduledTripsArgs = {
  /** Filter for scheduled vehicle trips that are associated with a given site. */
  siteId?: string
  /** Filter for scheduled vehicle trips that are associated with a given vehicle. */
  vehicleId?: string
  /** Filter for scheduled vehicle trips that are associated with the given vehicles. */
  vehicleIds?: string[]
  /** Filter for scheduled vehicle trips that are associated with a given route. */
  routeId?: string
  /** Filter for scheduled vehicle trips that start before the given time. */
  startsBefore?: string
  /** Filter for scheduled vehicle trips that start after the given time. */
  startsAfter?: string
  /** Filter for scheduled vehicle trips that end before the given time. */
  endsBefore?: string
  /** Filter for scheduled vehicle trips that end after the given time. */
  endsAfter?: string
  /** The page number of scheduled vehicle trips to be returned. */
  page: number
  /** The number of scheduled vehicle trips to be returned per page. */
  count?: number
  /** A sort direction for the results. */
  order?: 'ASC' | 'DESC'
}
export type UpdateTripResponse = /** status 200 Success */ ScheduledVehicleTripModel[]
export type UpdateTripArgs = {
  body: ScheduledVehicleTripUpdateModel[]
}
export type CreateTripResponse = /** status 200 Success */ ScheduledVehicleTripModel
export type CreateTripArgs = {
  scheduledVehicleTripCreateModel: ScheduledVehicleTripCreateModel
}
export type DeleteTripResponse = /** status 200 Success */ boolean
export type DeleteTripArgs = {
  scheduledVehicleTripDeleteModel: ScheduledVehicleTripDeleteModel
}
export type GetRecurrenceScheduleResponse = /** status 200 Success */ ScheduledTripRecurrenceModel
export type GetRecurrenceScheduleArgs = {
  scheduleId: string
}
export type UpdateRecurrenceScheduleResponse = /** status 200 Success */ ScheduledTripRecurrenceModel
export type UpdateRecurrenceScheduleArgs = {
  scheduleId: string
  /** Set of vehicle IDs to associated with the trip schedule. */
  vehicleIds: string[]
  /** The index of the occurrence to update. */
  occurrenceIndex: number
  scheduledTripRecurrenceUpdateModel: ScheduledTripRecurrenceUpdateModel
}
export type DeleteRecurrenceScheduleResponse = /** status 200 Success */ boolean
export type DeleteRecurrenceScheduleArgs = {
  scheduleId: string
  /** Set of vehicle IDs to associated with the trip schedule. */
  vehicleIds: string[]
  /** The index of the occurrence to update. */
  occurrenceIndex: number
}
export type UpdateTripOccurrencesResponse = /** status 200 Success */ ScheduledVehicleTripModel[]
export type UpdateTripOccurrencesArgs = {
  scheduleId: string
  /** Set of vehicle IDs to associated with the trip schedule. */
  vehicleIds: string[]
  /** The index of the occurrence to update. */
  occurrenceIndex: number
  scheduledTripRecurrenceUpdateOccurrencesModel: ScheduledTripRecurrenceUpdateOccurrencesModel
}
export type GetGridEventIntegrationAccountsResponse = /** status 200 OK */ GridEventIntegrationAccountModel
export type GetGridEventIntegrationAccountsArgs = {
  organizationId?: string
  gridEventIntegrationId?: string
}
export type UpdateGridEventIntegrationAccountResponse = /** status 201 Updated */ GridEventIntegrationAccountModel
export type UpdateGridEventIntegrationAccountArgs = {
  updateGridEventIntegrationsAccountRequestParams: UpdateGridEventIntegrationsAccountRequestParams
}
export type CreateGridEventIntegrationAccountResponse = /** status 201 Created */ GridEventIntegrationAccountModel
export type CreateGridEventIntegrationAccountArgs = {
  createGridEventIntegrationsAccountRequestParams: CreateGridEventIntegrationsAccountRequestParams
}
export type GetDepotEventsByDepotIdResponse = /** status 200 Success */ DepotEventModel[]
export type GetDepotEventsByDepotIdArgs = {
  depotId: string
  from?: string
  to?: string
}
export type UpdateDepotEventResponse = unknown
export type UpdateDepotEventArgs = {
  depotId: string
  isRecurrence?: boolean
  depotEventModel: DepotEventModel
}
export type SaveDepotEventResponse = /** status 200 Success */ DepotEventModel
export type SaveDepotEventArgs = {
  depotId: string
  depotEventModel: DepotEventModel
}
export type UpdateCustomTariffResponse = /** status 200 Custom tariff updated successfully */ CustomTariffModel
export type UpdateCustomTariffArgs = {
  id: string
  customTariffUpdateRequest: CustomTariffUpdateRequest
}
export type GetScheduledChargerSessionResponse = /** status 200 Success */ ChargerEventModel
export type GetScheduledChargerSessionArgs = {
  chargerId: string
  eventId: string
}
export type UpdateScheduledChargerSessionResponse = /** status 200 Success */ ChargerEventModel
export type UpdateScheduledChargerSessionArgs = {
  chargerId: string
  eventId: string
  isRecurrence?: boolean
  chargerEventUpdateModelDeprecated: ChargerEventUpdateModelDeprecated
}
export type CancelScheduledChargerSessionResponse = /** status 200 Success */ ChargerEventModel
export type CancelScheduledChargerSessionArgs = {
  chargerId: string
  eventId: string
  isRecurrence?: boolean
}
export type GetChargerEventByIdResponse = /** status 200 OK */ ChargerEventModel
export type GetChargerEventByIdArgs = {
  eventId: string
}
export type UpdateChargerEventResponse = /** status 200 OK */ ChargerEventModel
export type UpdateChargerEventArgs = {
  eventId: string
  includeRecurring?: boolean
  chargerEventUpdateModel: ChargerEventUpdateModel
}
export type CancelChargerEventResponse = /** status 200 OK */ ChargerEventModel
export type CancelChargerEventArgs = {
  eventId: string
  includeRecurring?: boolean
}
export type PatchChargerEventResponse = /** status 200 OK */ ChargerEventModel
export type PatchChargerEventArgs = {
  eventId: string
  includeRecurring?: boolean
  chargerEventUpdateModel: ChargerEventUpdateModel
}
export type MoveChargerEventResponse = /** status 200 OK */ ChargerEventModel[]
export type MoveChargerEventArgs = {
  eventId: string
  reassignEventConnectorModel: ReassignEventConnectorModel
}
export type StartDepotBackfillResponse = /** status 200 OK */ object
export type StartDepotBackfillArgs = {
  siteId: string
  dryRun?: boolean
}
export type StartBackfillForSiteResponse = unknown
export type StartBackfillForSiteArgs = {
  /** Site ID to process */
  siteId: string
  /** If true, only simulates changes without updating database */
  dryRun?: boolean
  /** Number of events to process per batch */
  batchSize?: number
}
export type GetTelemetryExclusionPeriodResponse = /** status 200 OK */ PagedResponseV2GetTelemetryExclusionModel
export type GetTelemetryExclusionPeriodArgs = {
  page: number
  count: number
  sort?: string
  vehicleIds: string[]
  startsAfter?: string
  startsBefore?: string
  endsAfter?: string
  endsBefore?: string
}
export type CreateTelemetryExclusionPeriodResponse = unknown
export type CreateTelemetryExclusionPeriodArgs = {
  createTelemetryExclusionRequestModel: CreateTelemetryExclusionRequestModel
}
export type GetSiteEnergyConfigurationsResponse = /** status 200 OK */ SiteEnergyConfiguration[]
export type GetSiteEnergyConfigurationsArgs = {
  siteId: string
  latest?: boolean
  from?: string
  to?: string
  count?: number
  afterId?: string
}
export type CreateSiteEnergyConfigurationResponse = /** status 201 Created */ SiteEnergyConfiguration
export type CreateSiteEnergyConfigurationArgs = {
  siteId: string
  createSiteEnergyConfigurationParams: CreateSiteEnergyConfigurationParams
}
export type CreateRecurrenceScheduleResponse = /** status 200 Success */ ScheduledTripRecurrenceModel
export type CreateRecurrenceScheduleArgs = {
  scheduledTripRecurrenceCreateModel: ScheduledTripRecurrenceCreateModel
}
export type SetRecurrenceScheduleVehiclesResponse = /** status 200 Success */ ScheduledTripRecurrenceModel
export type SetRecurrenceScheduleVehiclesArgs = {
  scheduleId: string
  scheduledTripRecurrenceSetVehiclesModel: ScheduledTripRecurrenceSetVehiclesModel
}
export type GetOptimizationsResponse = /** status 200 Success */ PagedResponseV2OptimizationModel
export type GetOptimizationsArgs = {
  organizationId?: string
  depotId?: string
  from?: string
  to?: string
  feasible?: boolean
  parentOptimizationId?: string
  latest?: boolean
  /** Filter optimizations where this timestamp falls within the valid period (inclusive of validFrom and validTo) */
  activeAt?: string
  /** When false, vehicle optimizations are not loaded and vehicleOptimizations is null on every row; use this for a lightweight listing of optimization runs */
  includeVehicleOptimizations?: boolean
  page?: number
  count?: number
}
export type CreateOptimizationResponse = /** status 200 Success */ OptimizationModel
export type CreateOptimizationArgs = {
  optimizationModel: OptimizationModel
}
export type GetActiveNodeEnergyConfigurationsResponse = /** status 200 OK */ NodeEnergyConfigurationModel[]
export type GetActiveNodeEnergyConfigurationsArgs = {
  nodeId: string
  from?: string
  to?: string
}
export type CreateNodeEnergyConfigurationResponse = /** status 200 OK */ NodeEnergyConfigurationModel
export type CreateNodeEnergyConfigurationArgs = {
  createNodeEnergyConfigurationParams: CreateNodeEnergyConfigurationParams
}
export type DeleteNodeEnergyConfigurationByNodeIdResponse = unknown
export type DeleteNodeEnergyConfigurationByNodeIdArgs = {
  nodeId: string
}
export type ListMarketRegionsResponse = /** status 200 OK */ MarketRegionListModel
export type ListMarketRegionsArgs = void
export type CreateMarketRegionResponse = /** status 201 Created */ MarketRegionModel
export type CreateMarketRegionArgs = {
  createMarketRegionRequest: CreateMarketRegionRequest
}
export type GetAverageRatesResponse = /** status 200 Success */ AverageRatesResponse
export type GetAverageRatesArgs = {
  averageRatesRequestBody: AverageRatesRequestBody
}
export type GetLoadBalancerEventsResponse = /** status 200 Success */ PagedResponseLoadBalancerEventModel
export type GetLoadBalancerEventsArgs = {
  /** Zero-based page index (0..N) */
  page?: number
  /** The size of the page to be returned */
  size?: number
  /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
  sort?: string[]
}
export type CreateLoadBalancerEventResponse = /** status 200 Success */ LoadBalancerEventModel
export type CreateLoadBalancerEventArgs = {
  origin?: string
  eventType?:
    | 'DEPOT_EVENT'
    | 'CHARGER_EVENT'
    | 'SCHEDULED_EVENT_START'
    | 'HEARTBEAT'
    | 'AFTER_START'
    | 'AFTER_STOP'
    | 'EMS_ON'
    | 'EMS_OFF'
    | 'SITE_LIMIT'
    | 'FIXED_LOAD_MANAGEMENT_TURNED_OFF'
    | 'FIRST_SOC_UPDATE'
  chargerId?: string
  fleetId?: string
  depotId?: string
  originTime?: string
  executionTime?: string
}
export type GetEnergyEfficiencyPredictionsResponse = /** status 200 Success */ EnergyEfficiencyPredictionModel[]
export type GetEnergyEfficiencyPredictionsArgs = {
  fleetId: string
  depotId?: string
  vehicleId?: string
  modelName?: string
  validFrom?: string
  validTo?: string
  windowFrom?: string
  windowTo?: string
  /** Get most recent prediction for each charger event. Not compatible with other time filtering parameters. */
  mostRecent?: boolean
  confidenceLower?: number
  confidenceUpper?: number
  page?: number
  count?: number
}
export type CreateEnergyEfficiencyPredictionResponse = /** status 200 Success */ BooleanModel
export type CreateEnergyEfficiencyPredictionArgs = {
  createEnergyEfficiencyPredictionRequestParams: CreateEnergyEfficiencyPredictionRequestParams
}
export type GetTransactionProfileMappings1Response = /** status 200 Success */ TransactionProfileMappingModel[]
export type GetTransactionProfileMappings1Args = {
  transactionId?: string
  chargerId?: string
  from?: string
  to?: string
  /** Get most recent profile mapping generated by the EMS */
  isMostRecent?: boolean
  page?: number
  count?: number
}
export type GetTransactionProfileMappingsResponse = /** status 200 Success */ TransactionProfileMappingModel
export type GetTransactionProfileMappingsArgs = {
  transactionProfileMappingModel: TransactionProfileMappingModel
}
export type CreateEffectiveNodeEnergyLimitResponse = /** status 200 OK */ EffectiveNodeEnergyLimitModel
export type CreateEffectiveNodeEnergyLimitArgs = {
  effectiveNodeEnergyLimitRequest: EffectiveNodeEnergyLimitRequest
}
export type SearchCustomTariffsResponse = /** status 200 Custom tariff(s) retrieved successfully */ CustomTariffModel[]
export type SearchCustomTariffsArgs = {
  /** Organization ID to filter custom tariffs (required when no masterTariffId is provided) */
  orgId?: string
  /** Master tariff identifier to find all related custom tariffs */
  masterTariffId?: string
  /** Filter to only currently active tariffs */
  isActive?: boolean
}
export type CreateCustomTariffResponse = /** status 201 Custom tariff created successfully */ CustomTariffModel
export type CreateCustomTariffArgs = {
  customTariffCreateRequest: CustomTariffCreateRequest
}
export type GetProfileHistories1Response = /** status 200 OK */ ProfileApplicationRecord[]
export type GetProfileHistories1Args = {
  chargerId: string
  latest?: boolean
  from?: string
  to?: string
  count?: number
  afterId?: string
}
export type CreateProfileHistoryResponse = /** status 201 Created */ ProfileApplicationRecord
export type CreateProfileHistoryArgs = {
  chargerId: string
  createProfileApplicationRecordParams: CreateProfileApplicationRecordParams
}
export type GetScheduledChargerSessionsResponse = /** status 200 Success */ ChargerEventModel[]
export type GetScheduledChargerSessionsArgs = {
  chargerId: string
  from?: string
  to?: string
  type?: string
  page?: number
  count?: number
}
export type CreateScheduledChargerSessionResponse = /** status 200 Success */ ChargerEventModel
export type CreateScheduledChargerSessionArgs = {
  chargerId: string
  scheduleRequestModel: ScheduleRequestModel
}
export type GetScheduledChargerSessionDetailsResponse = /** status 200 OK */ ChargerEventSessionDetailsModel
export type GetScheduledChargerSessionDetailsArgs = {
  chargerId: string
  eventId: string
}
export type SaveScheduledChargerSessionDetailsResponse = /** status 200 Success */ ChargerEventSessionModel
export type SaveScheduledChargerSessionDetailsArgs = {
  chargerId: string
  eventId: string
  chargerEventSessionModel: ChargerEventSessionModel
}
export type CreateChargerEventPredictionResponse = /** status 200 Success */ BooleanModel
export type CreateChargerEventPredictionArgs = {
  chargerId: string
  chargerEventPredictionRequestModel: ChargerEventPredictionRequestModel
}
export type GetChargerEventsResponse = /** status 200 OK */ PagedResponseChargerEventModel
export type GetChargerEventsArgs = {
  /** Filter for charger events associated with the given site ID. */
  siteId?: string
  /** Filter for charger events associated with the given charger ID. */
  chargerId?: string
  /** Filter for charger events associated with the given connector ID. */
  connectorId?: string
  /** Filter for charger events associated with the given vehicle ID. */
  vehicleId?: string
  /** Filter for charger events matching an OCPP tag. */
  ocppTag?: string
  /** Filter for charger events based on the event type. Must be one of 'TIMED_CHARGE' or 'RESERVATION'. */
  eventType?: string
  /** Filter based on events with a target state of charge or power level. */
  targetType?: 'VEHICLE' | 'CHARGER'
  /** Filter for charger events that start before the given time. */
  startsBefore?: string
  /** Filter for charger events that start after the given time. */
  startsAfter?: string
  /** Filter for charger events that end before the given time. */
  endsBefore?: string
  /** Filter for charger events that end after the given time. */
  endsAfter?: string
  /** The page number of charger events to be returned. */
  page: number
  /** The number of charger events to be returned in a page. */
  count?: number
  /** A sort direction for the results. */
  order?: 'ASC' | 'DESC'
}
export type CreateChargerEventResponse = /** status 200 OK */ ChargerEventModel
export type CreateChargerEventArgs = {
  chargerEventCreateModel: ChargerEventCreateModel
}
export type GetChargerEventDetailsByIdResponse = /** status 200 OK */ ChargerEventSessionDetailsModel
export type GetChargerEventDetailsByIdArgs = {
  eventId: string
}
export type AddSessionToChargerEventResponse = /** status 200 OK */ BooleanModel
export type AddSessionToChargerEventArgs = {
  eventId: string
  chargerEventNewSessionModel: ChargerEventNewSessionModel
}
export type GetVehicleOptimizationsResponse = /** status 200 Success */ PagedResponseV2VehicleOptimizationModel
export type GetVehicleOptimizationsArgs = {
  /** List of vehicle IDs to retrieve latest optimizations for. Comma-separated. */
  vehicleIds: string[]
  /** Return items starting before the given time. */
  startsBefore?: string
  /** Return items starting after the given time. */
  startsAfter?: string
  /** Return items ending before the given time. */
  endsBefore?: string
  /** Return items ending after the given time. */
  endsAfter?: string
  /** Page number */
  page: number
  /** Page size */
  count?: number
  /** Deprecated alias for mode=next. If true, returns the immediately-next target per vehicle from the latest optimization run. */
  latest?: boolean
  /** Selection mode per vehicle. `next` returns the immediately-next target on the latest optimization run; `all` returns every target on the latest run. Absent → paginated history. Note: with `mode=all` and multiple `vehicleIds`, results are flattened in the order vehicleIds are supplied (and within each vehicle, ascending by `from`); a vehicle's targets may split across pages if its target count exceeds `count`. Increase `count` if you need each vehicle's targets on a single page. */
  mode?: 'NEXT' | 'ALL'
}
export type GetTariffsResponse = /** status 200 Success */ TariffsResponse
export type GetTariffsArgs = {
  lseId?: number
  masterTariffId?: number
  effectiveOn?: string
  openOn?: string
  isActive?: boolean
  fromDateTime?: string
  toDateTime?: string
  customerClasses?: string
  chargeTypes?: string
  tariffTypes?: string
  serviceTypes?: string
  privacyFlags?: string
  zipCode?: string
  postCode?: string
  country?: string
  addressString?: string
  riderId?: number
  populateProperties?: boolean
  populateRates?: boolean
  accountId?: string
  consumption?: number
  demand?: number
  hasNetMetering?: boolean
  hasTimeOfUseRates?: boolean
  hasTieredRates?: boolean
  hasContractedRates?: boolean
  bundleRates?: boolean
  applicableRatesOnly?: boolean
  filterRiderRates?: boolean
  pageStart?: number
  pageCount?: number
}
export type GetTariffResponse = /** status 200 Success */ TariffResponse
export type GetTariffArgs = {
  masterTariffId: number
  fields?: string
  populateProperties?: boolean
  populateRates?: boolean
  applicableRatesOnly?: boolean
  lookupVariableRates?: boolean
  bundleRates?: boolean
}
export type GetDemandChargesResponse = /** status 200 Success */ DemandChargesResponse
export type GetDemandChargesArgs = {
  masterTariffId: number
  /** Start of the date range for demand charge applicability (UTC ISO-8601) */
  from: string
  /** End of the date range for demand charge applicability (UTC ISO-8601) */
  to: string
}
export type GetPriceCurveResponse = /** status 200 Success */ Price
export type GetPriceCurveArgs = {
  /** Start timestamp (UTC, ISO-8601). Example: 2025-08-18T00:00:00Z */
  from: string
  /** End timestamp (UTC, ISO-8601, exclusive). Example: 2025-08-19T00:00:00Z */
  to: string
  /** Provider to use for price lookup (GENABILITY, CUSTOM, NORDPOOL) */
  tariffProvider: string
  /** Identifier used across providers. GENABILITY: masterTariffId; CUSTOM: tariff ID; NORDPOOL: region code (e.g., SE3, FR) */
  tariffId: string
}
export type GetLinkTelemetryResponse = /** status 200 OK */ LinkTelemetryResponse
export type GetLinkTelemetryArgs = {
  siteId: string
  /** Defaults to last 15 min if from are not supplied. */
  from?: string
  /** Defaults to current time if to is not supplied. */
  to?: string
}
export type GetSiteEnergyConfigurationResponse = /** status 200 OK */ SiteEnergyConfiguration
export type GetSiteEnergyConfigurationArgs = {
  siteId: string
  id: string
}
export type GetBulkSiteEnergyConfigurationsResponse = /** status 200 OK */ SiteEnergyConfiguration[]
export type GetBulkSiteEnergyConfigurationsArgs = {
  organizationId: string
}
export type GetBulkSiteReservationConfigurationsResponse =
  /** status 200 OK */ PagedResponseV2SiteReservationConfigurationResponseModel
export type GetBulkSiteReservationConfigurationsArgs = {
  /** Organization ID to query configurations for (includes child organizations). If not provided, defaults to user's organization. */
  organizationId?: string
  /** Page number (0-based) */
  page?: string
  /** Number of items per page (max 3000) */
  count?: string
}
export type GetSiteGridProfileResponse = /** status 200 OK */ SiteGridProfileModel
export type GetSiteGridProfileArgs = {
  id: string
}
export type GetOptimizationResponse = /** status 200 Success */ OptimizationModel
export type GetOptimizationArgs = {
  id: string
}
export type GetNodeEnergyConfigurationResponse = /** status 200 OK */ NodeEnergyConfigurationModel
export type GetNodeEnergyConfigurationArgs = {
  id: string
}
export type DeleteNodeEnergyConfigurationIdResponse = unknown
export type DeleteNodeEnergyConfigurationIdArgs = {
  id: string
}
export type GetLoadServingEntitiesResponse = /** status 200 Success */ LoadServingEntitiesResponse
export type GetLoadServingEntitiesArgs = {
  zipCode?: string
  country?: string
  pageCount?: number
  pageStart?: number
  extendedFields?: boolean
}
export type GetGridEventIntegrationsResponse = /** status 200 OK */ GridEventIntegrationModel[]
export type GetGridEventIntegrationsArgs = void
export type GetGridEventIntegrationResponse = /** status 200 OK */ GridEventIntegrationModel[]
export type GetGridEventIntegrationArgs = {
  gridEventIntegrationId: string
}
export type GetGridEventIntegrationAccountResponse = /** status 200 OK */ GridEventIntegrationAccountModel[]
export type GetGridEventIntegrationAccountArgs = {
  gridEventIntegrationAccountId: string
}
export type GetGridEventIntegrationEventByAccountResponse = /** status 200 OK */ DepotEventModel[]
export type GetGridEventIntegrationEventByAccountArgs = {
  gridEventIntegrationAccountId: string
}
export type GetGridEventIntegrationEventResponse = /** status 200 OK */ DepotEventModel[]
export type GetGridEventIntegrationEventArgs = {
  gridEventIntegrationAccountId: string
  externalId: string
}
export type GetLoadBalancerEventResponse = /** status 200 Success */ LoadBalancerEventModel
export type GetLoadBalancerEventArgs = {
  id: string
}
export type GetEnergyEfficiencyPredictionResponse = /** status 200 Success */ ChargerEventModel
export type GetEnergyEfficiencyPredictionArgs = {
  id: string
}
export type GetEffectiveEnergyLimitResponse = /** status 200 OK */ EffectiveNodeEnergyLimitModel
export type GetEffectiveEnergyLimitArgs = {
  nodeId: string
  from: string
  to: string
}
export type GetSmartPricesResponse = /** status 200 Success */ Price
export type GetSmartPricesArgs = {
  depotId: string
  from?: string
  to?: string
}
export type GetScheduledDepotPowerResponse = /** status 200 Success */ PowerTimeSeriesModel
export type GetScheduledDepotPowerArgs = {
  depotId: string
  from: string
  to: string
  /** Use the optimization that was in effect at this moment (the one with the latest validFrom whose valid period contains it) instead of the currently active optimization */
  asOf?: string
  /** Only include the charging profiles of these vehicles; all vehicles when omitted */
  vehicleIds?: string[]
}
export type GetDepotEventByIdResponse = /** status 200 Success */ DepotEventModel
export type GetDepotEventByIdArgs = {
  depotId: string
  eventId: string
}
export type CancelDepotEventResponse = unknown
export type CancelDepotEventArgs = {
  depotId: string
  eventId: string
  isRecurrence?: boolean
}
export type GetDepotEventDetailsResponse = /** status 200 Success */ DepotEventDetailsModel
export type GetDepotEventDetailsArgs = {
  depotId: string
  eventId: string
}
export type GetScheduledChargerSessionsByDepotResponse = /** status 200 Success */ ChargerEventModel[]
export type GetScheduledChargerSessionsByDepotArgs = {
  depotId: string
  assetId?: string
  from?: string
  to?: string
  page?: number
  count?: number
}
export type GetPredictedChargerEventsResponse = /** status 200 Success */ ChargerEventPredictionModel[]
export type GetPredictedChargerEventsArgs = {
  depotId: string
  chargerId?: string
  dispenserId?: string
  assetId?: string
  from?: string
  to?: string
  validFrom?: string
  validTo?: string
  /** Return only most recent predictions. Not compatible with other time filtering parameters. */
  mostRecent: boolean
  modelName: string
  chargerEventId: string
  confidenceLower?: number
  confidenceUpper?: number
  page?: number
  count?: number
}
export type GetDepotEventsResponse = /** status 200 Success */ DepotEventModel[]
export type GetDepotEventsArgs = {
  from?: string
  to?: string
}
export type GetScheduledChargerSessionTelemetryResponse = /** status 200 Success */ ChargerEventSessionTelemetryModel
export type GetScheduledChargerSessionTelemetryArgs = {
  chargerId: string
  eventId: string
}
export type GetProfileHistoryResponse = /** status 200 OK */ ProfileApplicationRecord
export type GetProfileHistoryArgs = {
  id: string
}
export type DeleteTelemetryExclusionPeriodResponse = unknown
export type DeleteTelemetryExclusionPeriodArgs = {
  id: string
}
export type GetApiVehiclesByIdTimeToSocResponse = /** status 200 Success */ TimeSourceAttributeValue
export type GetApiVehiclesByIdTimeToSocArgs = {
  /** vehicle id */
  id: string
  /** target soc in percentage */
  targetSoc: number
  /** power offered from charger in Watts */
  powerOffered: number
}
export type GetApiTransactionsTimeToSocResponse = /** status 200 Success */ TimeSourceAttributeValue
export type GetApiTransactionsTimeToSocArgs = {
  /** ocpp tag */
  ocppTag: string
  /** target soc in percentage */
  targetSoc: number
  /** power offered from charger in Watts */
  powerOffered: number
}
export type GetApiMlTimeToSocResponse = /** status 200 Success */ TimeSourceAttributeValue
export type GetApiMlTimeToSocArgs = {
  /** current soc in percentage */
  soc: number
  /** delta soc in percentage */
  deltaSoc: number
  /** power offered from charger in Watts */
  powerOffered: number
  /** battery capacity in kWh */
  batteryCapacity: number
  /** vehicle make */
  make: string
  /** vehicle model */
  model: string
  /** vehicle model year */
  modelYear: number
}
export type GetWeatherResponse = /** status 200 OK */ WeatherResponse
export type GetWeatherArgs = {
  /** Latitude in decimal degrees (-90 to 90). */
  lat: string
  /** Longitude in decimal degrees (-180 to 180). */
  lon: string
  /** Optional ISO 639-1 language code (default: 'en'). */
  lang?: string
  /** Units of measurement: 'metric', 'imperial', or 'standard' (default: 'imperial'). */
  units?: 'metric' | 'imperial' | 'standard'
}
export type GetWeatherForecastResponse = /** status 200 OK */ WeatherForecastResponse
export type GetWeatherForecastArgs = {
  /** Latitude in decimal degrees (-90 to 90). */
  lat: string
  /** Longitude in decimal degrees (-180 to 180). */
  lon: string
  /** Optional ISO 639-1 language code (default: 'en'). */
  lang?: string
  /** Units of measurement: 'metric' (°C, m/s), 'imperial' (°F, mph) or 'standard' (K, m/s); default 'imperial'. Efficiency callers (vehicle-intelligence) always pass 'metric'. */
  units?: 'metric' | 'imperial' | 'standard'
}
export type UpdateTelematicsFeedCursorStatusResponse = /** status 200 OK */ TelematicsFeedCursor
export type UpdateTelematicsFeedCursorStatusArgs = {
  id: string
  /** Required optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current. This resource has concurrent writers whose updates would otherwise overwrite one another silently, so a write with no precondition is refused with `428` rather than applied blindly. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match': string
  updateTelematicsFeedCursorStatusRequest: UpdateTelematicsFeedCursorStatusRequest
}
export type UpdateIntegrationStatusResponse = /** status 200 OK */ Integration
export type UpdateIntegrationStatusArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
  updateIntegrationStatusRequest: UpdateIntegrationStatusRequest
}
export type SearchTelematicsFeedCursorsResponse = /** status 200 OK */ TelematicsFeedCursor[]
export type SearchTelematicsFeedCursorsArgs = {
  integrationId: string
  feedType?: 'TRIP' | 'STATUS' | 'LOCATION' | 'CHARGE_EVENT' | 'FAULT_DATA'
}
export type CreateTelematicsFeedCursorResponse = /** status 201 Created */ TelematicsFeedCursor
export type CreateTelematicsFeedCursorArgs = {
  createTelematicsFeedCursorRequest: CreateTelematicsFeedCursorRequest
}
export type SearchPaymentTerminalsResponse = /** status 200 OK */ PaymentTerminal[]
export type SearchPaymentTerminalsArgs = {
  organizationId?: string
  integrationId?: string
  serialNumber?: string
  chargerId?: string[]
  chargerIds?: string
}
export type CreatePaymentTerminalResponse = /** status 201 Created */ PaymentTerminal
export type CreatePaymentTerminalArgs = {
  createPaymentTerminalRequest: CreatePaymentTerminalRequest
}
export type AssignPaymentTerminalsResponse = /** status 200 OK */ PaymentTerminal[]
export type AssignPaymentTerminalsArgs = {
  assignPaymentTerminalsRequest: AssignPaymentTerminalsRequest
}
export type SearchPaymentTerminalSessionsResponse = /** status 200 OK */ PaymentTerminalSession[]
export type SearchPaymentTerminalSessionsArgs = {
  integrationProviderId?: string
  externalSessionId?: string
  lastModifiedFrom?: string
  lastModifiedTo?: string
  paymentTerminalId?: string
  chargerId?: string
  connectorId?: number
  status?: ('READING' | 'AUTHORIZING' | 'AUTHORIZED' | 'COMMITTED' | 'CANCELLED' | 'FAILED')[]
  lineItemId?: string
  transactionId?: string
  authTag?: string
}
export type CreatePaymentTerminalSessionResponse = /** status 201 Created */ PaymentTerminalSession
export type CreatePaymentTerminalSessionArgs = {
  createPaymentTerminalSessionRequest: CreatePaymentTerminalSessionRequest
}
export type SearchIntegrationsResponse = /** status 200 OK */ Integration[]
export type SearchIntegrationsArgs = {
  integrationProviderId?: string
  organizationId?: string
  meterId?: string[]
}
export type CreateIntegrationResponse = /** status 201 Created */ Integration
export type CreateIntegrationArgs = {
  createIntegrationRequest: CreateIntegrationRequest
}
export type SearchIntegrationProvidersResponse = /** status 200 OK */ IntegrationProvider[]
export type SearchIntegrationProvidersArgs = {
  name?: string
  integrationKey?: string
  integrationType?:
    | 'PAYMENT_TERMINAL'
    | 'PAYMENT_WEB'
    | 'COMPLIANCE_REPORTING'
    | 'OPERATIONS'
    | 'PAYMENT_PROVIDERS'
    | 'VEHICLE_TELEMATICS'
    | 'ROAMING'
    | 'ENERGY_AGGREGATORS'
}
export type CreateIntegrationProviderResponse = /** status 201 Created */ IntegrationProvider
export type CreateIntegrationProviderArgs = {
  createIntegrationProviderRequest: CreateIntegrationProviderRequest
}
export type RetrieveTelematicsFeedCursorResponse = /** status 200 OK */ TelematicsFeedCursor
export type RetrieveTelematicsFeedCursorArgs = {
  id: string
}
export type DeleteTelematicsFeedCursorResponse = unknown
export type DeleteTelematicsFeedCursorArgs = {
  id: string
  /** Required optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current. This resource has concurrent writers whose updates would otherwise overwrite one another silently, so a write with no precondition is refused with `428` rather than applied blindly. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match': string
}
export type UpdateTelematicsFeedCursorResponse = /** status 200 OK */ TelematicsFeedCursor
export type UpdateTelematicsFeedCursorArgs = {
  id: string
  /** Required optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current. This resource has concurrent writers whose updates would otherwise overwrite one another silently, so a write with no precondition is refused with `428` rather than applied blindly. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match': string
  updateTelematicsFeedCursorRequest: UpdateTelematicsFeedCursorRequest
}
export type RetrievePaymentTerminalResponse = /** status 200 OK */ PaymentTerminal
export type RetrievePaymentTerminalArgs = {
  id: string
}
export type DeletePaymentTerminalResponse = unknown
export type DeletePaymentTerminalArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
}
export type UpdatePaymentTerminalResponse = /** status 200 OK */ PaymentTerminal
export type UpdatePaymentTerminalArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
  updatePaymentTerminalRequest: UpdatePaymentTerminalRequest
}
export type RetrievePaymentTerminalSessionResponse = /** status 200 OK */ PaymentTerminalSession
export type RetrievePaymentTerminalSessionArgs = {
  id: string
}
export type DeletePaymentTerminalSessionResponse = unknown
export type DeletePaymentTerminalSessionArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
}
export type UpdatePaymentTerminalSessionResponse = /** status 200 OK */ PaymentTerminalSession
export type UpdatePaymentTerminalSessionArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
  updatePaymentTerminalSessionRequest: UpdatePaymentTerminalSessionRequest
}
export type RetrieveIntegrationResponse = /** status 200 OK */ Integration
export type RetrieveIntegrationArgs = {
  id: string
  includeSecrets?: boolean
}
export type DeleteIntegrationResponse = unknown
export type DeleteIntegrationArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
}
export type UpdateIntegrationResponse = /** status 200 OK */ Integration
export type UpdateIntegrationArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
  updateIntegrationRequest: UpdateIntegrationRequest
}
export type RetrieveIntegrationProviderResponse = /** status 200 OK */ IntegrationProvider
export type RetrieveIntegrationProviderArgs = {
  id: string
}
export type DeleteIntegrationProviderResponse = unknown
export type DeleteIntegrationProviderArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
}
export type UpdateIntegrationProviderResponse = /** status 200 OK */ IntegrationProvider
export type UpdateIntegrationProviderArgs = {
  id: string
  /** Optional optimistic-locking precondition. Pass the `ETag` of the revision you read and the write is applied only while that revision is still current; omit it and the write behaves exactly as it always has — last writer wins, re-applied on top of anything that landed in between. A precondition naming a superseded revision is rejected with `412` and nothing is written. */
  'If-Match'?: string
  updateIntegrationProviderRequest: UpdateIntegrationProviderRequest
}
export type SearchOrganizationIntegrationProvidersResponse = /** status 200 OK */ OrganizationIntegrationProvider[]
export type SearchOrganizationIntegrationProvidersArgs = {
  organizationId: string
  integrationProviderId?: string
}
export type RetrieveOrganizationIntegrationProviderResponse = /** status 200 OK */ OrganizationIntegrationProvider
export type RetrieveOrganizationIntegrationProviderArgs = {
  id: string
}
export type RetrieveIntegrationFeedCursorResponse = /** status 200 OK */ TelematicsFeedCursor
export type RetrieveIntegrationFeedCursorArgs = {
  id: string
  feedType: 'TRIP' | 'STATUS' | 'LOCATION' | 'CHARGE_EVENT' | 'FAULT_DATA'
}
export type OcppLogAnalysisApiV1OcppLogAnalysisPostResponse = /** status 200 SSE stream of analysis events */
  | SseRequestIdEvent
  | SseStatusUpdateEvent
  | SseResponseStartEvent
  | SseBlockDeltaEvent
  | SseResponseEndEvent
  | SseErrorEvent
  | SseDebugEvent
export type OcppLogAnalysisApiV1OcppLogAnalysisPostArgs = {
  logAnalysisRequest: LogAnalysisRequest
}
export type SubmitFeedbackApiV1OcppLogAnalysisFeedbackPostResponse =
  /** status 201 Successful Response */ SubmitFeedbackResponse
export type SubmitFeedbackApiV1OcppLogAnalysisFeedbackPostArgs = {
  createFeedbackRequest: CreateFeedbackRequest
}
export type UpdateFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdPutResponse =
  /** status 200 Successful Response */ SubmitFeedbackResponse
export type UpdateFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdPutArgs = {
  feedbackId: string
  updateFeedbackRequest: UpdateFeedbackRequest
}
export type DeleteFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdDeleteResponse =
  /** status 200 Successful Response */ DeleteFeedbackResponse
export type DeleteFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdDeleteArgs = {
  feedbackId: string
}
export type GetSchemaVersionApiChargerLlmSchemaVersionGetResponse =
  /** status 200 Successful Response */ SchemaVersionResponse
export type GetSchemaVersionApiChargerLlmSchemaVersionGetArgs = void
export type SyncOcpiTariffsResponse = /** status 200 OK */ SyncTariffsResponse[]
export type SyncOcpiTariffsArgs = {
  syncTariffsRequest: SyncTariffsRequest
}
export type SyncOcpiLocationsResponse = /** status 200 OK */ SyncLocationsResponse[]
export type SyncOcpiLocationsArgs = {
  syncLocationsRequest: SyncLocationsRequest
}
export type SyncOcpiIntegrationsResponse = /** status 200 OK */ SyncIntegrationsResponse[]
export type SyncOcpiIntegrationsArgs = {
  syncIntegrationsRequest: SyncIntegrationsRequest
}
export type SendTariffsResponse = /** status 200 OK */ SendResponse
export type SendTariffsArgs = {
  sendRequest: SendRequest
}
export type SendLocationsResponse = /** status 200 OK */ SendResponse
export type SendLocationsArgs = {
  sendRequest: SendRequest
}
export type AuthorizeResponse =
  /** status 200 when the idTag is matched to an OCPI token or command */ AuthorizationResult
export type AuthorizeArgs = {
  body: {
    tagId: string
    chargerId: string
  }
}
export type DeleteUnusedOcpiTariffsResponse = /** status 200 OK */ DeleteUnusedTariffsResponse[]
export type DeleteUnusedOcpiTariffsArgs = {
  deleteUnusedTariffsRequest: DeleteUnusedTariffsRequest
}
export type GetCredentialsResponse = /** status 200 OK */ InternalCredentials[]
export type GetCredentialsArgs = {
  /** Filter to credentials for this integration provider */
  integrationKey?: string
}
export type CreateCredentialsResponse = /** status 200 OK */ InternalCredentials
export type CreateCredentialsArgs = {
  body: ExchangeCredentialsRequestWrite | GenerateTokenRequestWrite
}
export type GetSessionsResponse = /** status 200 OK */ PagedResultSession
export type GetSessionsArgs = {
  integrationId: string
  /** Lower bound on lastUpdated (inclusive); unbounded when omitted */
  from?: string
  /** Upper bound on lastUpdated (exclusive); unbounded when omitted */
  to?: string
  /** Number of results to skip; defaults to 0 */
  offset?: number
  /** Maximum number of results to return (1-1000); defaults to 100 */
  limit?: number
  /** Order by lastUpdated: DESC (newest first, default) or ASC (oldest first) */
  sort?: 'ASC' | 'DESC'
}
export type GetCdrsResponse = /** status 200 OK */ PagedResultCdr
export type GetCdrsArgs = {
  integrationId: string
  /** Lower bound on lastUpdated (inclusive); unbounded when omitted */
  from?: string
  /** Upper bound on lastUpdated (exclusive); unbounded when omitted */
  to?: string
  /** Number of results to skip; defaults to 0 */
  offset?: number
  /** Maximum number of results to return (1-1000); defaults to 100 */
  limit?: number
  /** Order by lastUpdated: DESC (newest first, default) or ASC (oldest first) */
  sort?: 'ASC' | 'DESC'
}
export type GetRequestLogsResponse = /** status 200 OK */ PagedResultOcpiRequestLog
export type GetRequestLogsArgs = {
  credentialId: string
  /** Narrow to the exchange carrying this OCPI X-Request-ID */
  ocpiRequestId?: string
  /** Narrow to the exchanges carrying this OCPI X-Correlation-ID */
  ocpiCorrelationId?: string
  /** Lower bound on the exchange time (inclusive); unbounded when omitted */
  from?: string
  /** Upper bound on the exchange time (exclusive); unbounded when omitted */
  to?: string
  /** Number of logs to skip; defaults to 0 */
  offset?: number
  /** Maximum number of logs to return (1-1000); defaults to the most recent 100 */
  limit?: number
  /** Order by exchange time: DESC (newest first, default) or ASC (oldest first) */
  sort?: 'ASC' | 'DESC'
}
export type GetRequestLogResponse = /** status 200 OK */ OcpiRequestLog
export type GetRequestLogArgs = {
  credentialId: string
  requestId: string
}
export type GetAuthorizationDecisionsResponse = /** status 200 OK */ PagedResultAuthorizationDecision
export type GetAuthorizationDecisionsArgs = {
  /** Narrow to decisions for this presented tag */
  idTag?: string
  /** Narrow to decisions naming this EVSE; wins over charger_id and location_id */
  evseUid?: string
  /** Narrow to decisions made at this OCPP charge box; wins over location_id */
  chargerId?: string
  /** Narrow to decisions naming this location */
  locationId?: string
  /** Lower bound on the decision time (inclusive); unbounded when omitted */
  from?: string
  /** Upper bound on the decision time (exclusive); unbounded when omitted */
  to?: string
  /** Number of decisions to skip; defaults to 0 */
  offset?: number
  /** Maximum number of decisions to return (1-1000); defaults to the most recent 100 */
  limit?: number
  /** Order by decision time: DESC (newest first, default) or ASC (oldest first) */
  sort?: 'ASC' | 'DESC'
}
export type GetAuthorizationDecisionResponse = /** status 200 OK */ AuthorizationDecision
export type GetAuthorizationDecisionArgs = {
  id: string
}
export type GetVirtualChargerGroupResponse = /** status 200 Virtual charger group found */ VirtualChargerGroup
export type GetVirtualChargerGroupArgs = {
  /** Virtual charger group ID */
  virtualChargerId: string
}
export type UpdateVirtualChargerGroupResponse = /** status 200 Virtual charger group updated */ VirtualChargerGroup
export type UpdateVirtualChargerGroupArgs = {
  /** Virtual charger group ID */
  virtualChargerId: string
  virtualChargerGroupUpdateParams: VirtualChargerGroupUpdateParams
}
export type DeleteVirtualChargerGroupResponse = unknown
export type DeleteVirtualChargerGroupArgs = {
  /** Virtual charger group ID */
  virtualChargerId: string
}
export type GetSkillResponse = /** status 200 OK */ AssistantSkill
export type GetSkillArgs = {
  skillId: string
  'X-Organization-Id': string
}
export type UpdateSkillResponse = /** status 200 OK */ AssistantSkill
export type UpdateSkillArgs = {
  skillId: string
  'X-Organization-Id': string
  assistantSkillUpdateParams: AssistantSkillUpdateParams
}
export type DeleteSkillResponse = unknown
export type DeleteSkillArgs = {
  skillId: string
  'X-Organization-Id': string
}
export type GetSkillScheduleResponse = /** status 200 OK */ AssistantSkillSchedule
export type GetSkillScheduleArgs = {
  scheduleId: string
  'X-Organization-Id': string
}
export type UpdateSkillScheduleResponse = /** status 200 OK */ AssistantSkillSchedule
export type UpdateSkillScheduleArgs = {
  scheduleId: string
  'X-Organization-Id': string
  authorization?: string
  assistantSkillScheduleUpdateParams: AssistantSkillScheduleUpdateParams
}
export type DeleteSkillScheduleResponse = unknown
export type DeleteSkillScheduleArgs = {
  scheduleId: string
  'X-Organization-Id': string
}
export type ListVirtualChargerGroupsResponse = /** status 200 List of virtual charger groups */ VirtualChargerGroup[]
export type ListVirtualChargerGroupsArgs = {
  /** Filter by site ID */
  siteId?: string
  /** Filter by physical charger ID */
  chargerId?: string
}
export type CreateVirtualChargerGroupResponse =
  /** status 201 Virtual charger group created successfully */ VirtualChargerGroup
export type CreateVirtualChargerGroupArgs = {
  /** Organization ID */
  'X-Organization-Id': string
  virtualChargerGroupCreateParams: VirtualChargerGroupCreateParams
}
export type BulkCreateVirtualChargerGroupsResponse = /** status 200 Bulk creation result */ BulkCreateResult
export type BulkCreateVirtualChargerGroupsArgs = {
  /** Organization ID */
  'X-Organization-Id': string
  bulkCreateParams: BulkCreateParams
}
export type MarkAsReadResponse = unknown
export type MarkAsReadArgs = {
  notificationId: string
}
export type MarkAllAsReadResponse = unknown
export type MarkAllAsReadArgs = void
export type ListSavesResponse = /** status 200 OK */ GenerativeDashboardSaveList
export type ListSavesArgs = {
  'X-Organization-Id': string
  limit?: number
  startingAfter?: string
}
export type CreateSaveResponse = /** status 200 OK */ GenerativeDashboardSave
export type CreateSaveArgs = {
  'X-Organization-Id': string
  generativeDashboardSaveCreateParams: GenerativeDashboardSaveCreateParams
}
export type RefreshResponse = unknown
export type RefreshArgs = {
  'X-Organization-Id': string
  authorization?: string
  generativeDashboardRefreshParams: GenerativeDashboardRefreshParams
}
export type ListFirmwareVersionsResponse = /** status 200 OK */ CursorPagedListFirmwareVersion
export type ListFirmwareVersionsArgs = {
  /** Filter by charger OEM / manufacturer name (case-insensitive) */
  vendor?: string
  /** Filter by charger model name (case-insensitive) */
  model?: string
  /** Maximum number of items to return (1-100, default 20) */
  limit?: number
  /** Cursor for pagination - ID of the item to start after */
  startingAfter?: string
}
export type CreateFirmwareVersionResponse = /** status 201 Firmware version registered */ FirmwareVersionUpload
export type CreateFirmwareVersionArgs = {
  firmwareVersionCreateParams: FirmwareVersionCreateParams
}
export type CompleteUploadResponse = /** status 200 Upload confirmed */ FirmwareVersion
export type CompleteUploadArgs = {
  firmwareVersionId: string
}
export type ListDeploymentsResponse = /** status 200 OK */ CursorPagedListFirmwareDeployment
export type ListDeploymentsArgs = {
  'X-Organization-Id': string
  /** Maximum number of items to return (1-100, default 20) */
  limit?: number
  /** Cursor for pagination - ID of the item to start after */
  startingAfter?: string
}
export type CreateDeploymentResponse = /** status 201 Firmware deployment created */ FirmwareDeployment
export type CreateDeploymentArgs = {
  /** Organization ID */
  'X-Organization-Id': string
  authorization?: string
  firmwareDeploymentCreateParams: FirmwareDeploymentCreateParams
}
export type RetryStationResponse = /** status 200 OK */ FirmwareDeployment
export type RetryStationArgs = {
  deploymentId: string
  chargerId: string
  'X-Organization-Id': string
}
export type ResumeSiteResponse = /** status 200 OK */ FirmwareDeployment
export type ResumeSiteArgs = {
  deploymentId: string
  siteId: string
  'X-Organization-Id': string
}
export type CancelSiteResponse = /** status 200 OK */ FirmwareDeployment
export type CancelSiteArgs = {
  deploymentId: string
  siteId: string
  'X-Organization-Id': string
}
export type ResumeDeploymentResponse = /** status 200 OK */ FirmwareDeployment
export type ResumeDeploymentArgs = {
  deploymentId: string
  'X-Organization-Id': string
}
export type PauseDeploymentResponse = /** status 200 OK */ FirmwareDeployment
export type PauseDeploymentArgs = {
  deploymentId: string
  'X-Organization-Id': string
}
export type CancelDeploymentResponse = /** status 200 OK */ FirmwareDeployment
export type CancelDeploymentArgs = {
  deploymentId: string
  'X-Organization-Id': string
}
export type CreateBugReportResponse = /** status 201 Bug report created */ BugReport
export type CreateBugReportArgs = {
  'X-Organization-Id': string
  authorization?: string
  bugReportCreateParams: BugReportCreateParams
}
export type ListSkillsResponse = /** status 200 OK */ AssistantSkillList
export type ListSkillsArgs = {
  'X-Organization-Id': string
  personalLimit?: number
  personalStartingAfter?: string
  organizationLimit?: number
  organizationStartingAfter?: string
}
export type CreateSkillResponse = /** status 200 OK */ AssistantSkill
export type CreateSkillArgs = {
  'X-Organization-Id': string
  assistantSkillCreateParams: AssistantSkillCreateParams
}
export type SaveFromConversationResponse = /** status 200 OK */ AssistantSkill
export type SaveFromConversationArgs = {
  'X-Organization-Id': string
  assistantSkillSaveFromConversationParams: AssistantSkillSaveFromConversationParams
}
export type ListSkillSchedulesResponse = /** status 200 OK */ AssistantSkillScheduleList
export type ListSkillSchedulesArgs = {
  'X-Organization-Id': string
  limit?: number
  startingAfter?: string
}
export type CreateSkillScheduleResponse = /** status 200 OK */ AssistantSkillSchedule
export type CreateSkillScheduleArgs = {
  'X-Organization-Id': string
  authorization?: string
  assistantSkillScheduleCreateParams: AssistantSkillScheduleCreateParams
}
export type ListConversationsResponse = /** status 200 OK */ AssistantConversationList
export type ListConversationsArgs = {
  'X-Organization-Id': string
  limit?: number
  startingAfter?: string
}
export type CreateConversationResponse = /** status 200 OK */ AssistantConversation
export type CreateConversationArgs = {
  'X-Organization-Id': string
  assistantConversationCreateParams: AssistantConversationCreateParams
}
export type ShareConversationResponse = /** status 200 OK */ AssistantConversation
export type ShareConversationArgs = {
  conversationId: string
  'X-Organization-Id': string
  assistantConversationShareParams: AssistantConversationShareParams
}
export type SendMessageResponse = unknown
export type SendMessageArgs = {
  conversationId: string
  'X-Organization-Id': string
  authorization?: string
  assistantSendMessageParams: AssistantSendMessageParams
}
export type SetMessageFeedbackResponse = /** status 200 OK */ AssistantMessage
export type SetMessageFeedbackArgs = {
  conversationId: string
  messageId: string
  'X-Organization-Id': string
  assistantMessageFeedbackParams: AssistantMessageFeedbackParams
}
export type UploadAttachmentResponse = /** status 200 OK */ AssistantAttachment
export type UploadAttachmentArgs = {
  conversationId: string
  'X-Organization-Id': string
  body: {
    file: Blob
  }
}
export type RunActionResponse = unknown
export type RunActionArgs = {
  actionId: string
  'X-Organization-Id': string
  authorization?: string
}
export type RejectActionResponse = /** status 200 OK */ AssistantAction
export type RejectActionArgs = {
  actionId: string
  'X-Organization-Id': string
}
export type DispatchResponse = /** status 200 OK */ AssistantActionDispatch
export type DispatchArgs = {
  actionId: string
  'X-Organization-Id': string
  authorization?: string
}
export type ListScoresResponse = /** status 200 OK */ ArcadeScoreList
export type ListScoresArgs = {
  scope?: string
  game?: string
  board?: string
  order?: string
  limit?: number
  startingAfter?: string
  'X-Organization-Id': string
}
export type CreateScoreResponse = /** status 200 OK */ ArcadeScore
export type CreateScoreArgs = {
  'X-Organization-Id': string
  arcadeScoreCreateParams: ArcadeScoreCreateParams
}
export type GetDecisionLogsResponse = /** status 200 Successfully retrieved decision logs */ PaginatedDecisionLog
export type GetDecisionLogsArgs = {
  /** Virtual charger group ID to filter by */
  virtualChargerId?: string
  /** Site ID to filter by */
  siteId?: string
  /** Start time (ISO format) */
  from: string
  /** End time (ISO format) */
  to: string
  /** Maximum number of results per page (default: 100, max: 1000) */
  limit?: number
  /** Pagination token from previous response */
  nextToken?: string
}
export type GetOpsNotificationsResponse = /** status 200 OK */ CursorPagedListNotification
export type GetOpsNotificationsArgs = {
  unreadOnly?: boolean
  /** Maximum number of items to return (1-100, default 20) */
  limit?: number
  /** Cursor for pagination - ID of the item to start after */
  startingAfter?: string
}
export type GetNotificationResponse = /** status 200 OK */ Notification
export type GetNotificationArgs = {
  notificationId: string
}
export type DeleteNotificationResponse = unknown
export type DeleteNotificationArgs = {
  notificationId: string
}
export type GetSaveResponse = /** status 200 OK */ GenerativeDashboardSave
export type GetSaveArgs = {
  saveId: string
  'X-Organization-Id': string
}
export type DeleteSaveResponse = unknown
export type DeleteSaveArgs = {
  saveId: string
  'X-Organization-Id': string
}
export type GetFirmwareVersionResponse = /** status 200 Firmware version found */ FirmwareVersion
export type GetFirmwareVersionArgs = {
  firmwareVersionId: string
}
export type DeleteFirmwareVersionResponse = unknown
export type DeleteFirmwareVersionArgs = {
  firmwareVersionId: string
}
export type GetDownloadUrlResponse = /** status 200 OK */ {
  [key: string]: string
}
export type GetDownloadUrlArgs = {
  firmwareVersionId: string
}
export type GetDeploymentResponse = /** status 200 Firmware deployment found */ FirmwareDeployment
export type GetDeploymentArgs = {
  deploymentId: string
  'X-Organization-Id': string
}
export type ListStationsResponse = /** status 200 OK */ FirmwareDeploymentStation[]
export type ListStationsArgs = {
  deploymentId: string
  'X-Organization-Id': string
}
export type ListSkillScheduleRunsResponse = /** status 200 OK */ AssistantSkillRunList
export type ListSkillScheduleRunsArgs = {
  scheduleId: string
  'X-Organization-Id': string
  limit?: number
  startingAfter?: string
}
export type GetSkillScheduleRunResponse = /** status 200 OK */ AssistantSkillRun
export type GetSkillScheduleRunArgs = {
  runId: string
  'X-Organization-Id': string
}
export type GetSkillScheduleRunTranscriptResponse = /** status 200 OK */ AssistantSkillRunTranscript
export type GetSkillScheduleRunTranscriptArgs = {
  runId: string
  'X-Organization-Id': string
}
export type GetConversationResponse = /** status 200 OK */ AssistantConversationDetail
export type GetConversationArgs = {
  conversationId: string
  'X-Organization-Id': string
}
export type GetActionResponse = /** status 200 OK */ AssistantAction
export type GetActionArgs = {
  actionId: string
  'X-Organization-Id': string
}
export type StreamActionResponse = unknown
export type StreamActionArgs = {
  actionId: string
  'X-Organization-Id': string
}
export type IngestDescartesRouteResponse = unknown
export type IngestDescartesRouteArgs = {
  body: string
}
export type ListActivityEventsResponse =
  /** status 200 Paginated list of activity events for the caller's organization. */ PagedResponseActivityEventResponse
export type ListActivityEventsArgs = {
  /** Range start (inclusive). ISO 8601 UTC timestamp. */
  since: string
  /** Range end (exclusive). ISO 8601 UTC timestamp. */
  until: string
  /** Page number (0-indexed). */
  page?: number
  /** Number of items per page */
  count?: number
  /** Filter by event category. 'request' — API activity; 'auth' — login and authentication events; 'stripe' — billing and payment events. */
  eventCategory?: ('request' | 'auth' | 'stripe') | null
  /** Filter by dot-namespaced event type. Examples: `vehicle.updated`, `charger.created`, `auth.login.succeeded`. */
  eventType?: string | null
  /** Filter to a specific actor's user ID. */
  actorId?: string | null
  /** Filter by affected resource type. Examples: `Vehicle`, `Charger`, `Depot`, `Organization`. */
  resourceType?: string | null
  /** Filter to a specific resource. */
  resourceId?: string | null
  /** Filter by HTTP response status code returned for the request (e.g. `200`, `201`, `400`, `403`, `404`). */
  responseStatus?: number | null
  /** Filter to events from a specific IP range. Pass the `ip_hashed` value from a previous response to correlate activity from the same subnet. */
  ipHashed?: string | null
  /** Filter to events matching this route template, e.g. `/api/v1/chargers/{id}`. */
  endpoint?: string | null
  /** Number of child-organization levels to include in the results. `0` returns only the caller's own organization; `100` (default) includes all descendants. */
  orgDepth?: number
}
export type GetWhatsNewFeedV1WhatsNewGetResponse = /** status 200 Successful Response */ WhatsNewFeedResponse
export type GetWhatsNewFeedV1WhatsNewGetArgs = void
export type MarkNotesSeenV1WhatsNewSeenPostResponse = unknown
export type MarkNotesSeenV1WhatsNewSeenPostArgs = {
  markSeenRequest: MarkSeenRequest
}
export type SiteReservationConfigurationResponseModel = {
  /** Unique identifier for the configuration */
  id?: string
  /** Site identifier */
  siteId?: string
  /** Date and time when the configuration becomes valid */
  validFrom?: string
  /** Date and time when the configuration expires. Null means active indefinitely */
  validTo?: string
  /** Whether site reservation is enabled */
  enabled: boolean
  /** User who created this configuration */
  createdBy?: string
  /** Organization identifier of the site. */
  organizationId?: string
  /** Creator organization identifier. */
  creatorOrganizationId?: string
  /** Minimum lead time for reservations in seconds */
  minLeadTime?: number
  /** Maximum reservation length in seconds */
  maxReservationLength?: number
  /** Minimum reservation length in seconds */
  minReservationLength?: number
  /** Maximum lead time for reservations in seconds */
  maxLeadTime?: number
}
export type SiteReservationConfigurationUpdateRequest = {
  enabled: boolean
}
export type SiteGridProfileModel = {
  id: string
  siteId: string
  gridEventIntegrationAccountId: string
  externalId?: string
  defaultEventLength?: number
  defaultCurtailedPowerLevel?: number
  autoOptIn: boolean
}
export type UpdateSiteGridProfileRequestParams = {
  id: string
  siteId: string
  gridEventIntegrationAccountId: string
  externalId?: string
  defaultEventLength?: number
  defaultCurtailedPowerLevel?: number
  autoOptIn: boolean
}
export type CreateSiteGridProfileRequestParams = {
  siteId: string
  gridEventIntegrationAccountId: string
  externalId?: string
  defaultEventLength?: number
  defaultCurtailedPowerLevel?: number
  autoOptIn: boolean
}
export type PaginationMetadata = {
  first: boolean
  last: boolean
  pageSize: number
  page: number
  totalPages: number
  totalItems: number
}
export type Meta = {
  pagination: PaginationMetadata
}
export type CalculatedEnergyRequirementModel = {
  id?: string
  scheduledVehicleTripId?: string
  energy?: number
  energyUnits?: string
  /** How energy was calculated: BASE_EFFICIENCY (distance x vehicle efficiency) or DUTY_MODEL (driving + standing + margin) */
  calcMethod?: 'BASE_EFFICIENCY' | 'DUTY_MODEL'
  distance?: number
  distanceUnits?: string
  vehicleEfficiency?: number
  /** Duty-model forecast for the route, kWh: driving + standing + margin. While the model runs in shadow this is stored beside energy and not read by the optimizer */
  dutyEnergyKwh?: number
  /** Driving term, kWh: driving efficiency x planned distance x planned-distance factor */
  drivingEnergyKwh?: number
  /** Standing term, kWh: standing power x planned hours (systems running while not on a trip) */
  standingEnergyKwh?: number
  /** Margin term, kWh: margin share x battery size */
  marginEnergyKwh?: number
  /** Vehicle's energy per mile while on trips, kWh/mi, as used */
  drivingEfficiency?: number
  /** Vehicle's typical distance driven over distance planned, as used (1 when unset) */
  plannedDistanceFactor?: number
  /** Vehicle's power draw while not on a trip, kW, as used */
  standingPowerKw?: number
  /** Planned hours the standing term covers: departure to arrival, or planned distance over 25 mph when no arrival was specified */
  plannedHours?: number
  /** Share of the battery added as margin, as used (0 when unset) */
  energyMarginShare?: number
  /** Battery size x (max SOC - min SOC), kWh: what one depot charge can deliver */
  usableBatteryKwh?: number
  /** Whether the duty-model forecast fits in the usable battery; false means the plan needs a charge on the road */
  feasibleOnOneCharge?: boolean
  /** Why no duty-model forecast was made: NO_PROFILE, NO_BATTERY or NO_PLANNED_DISTANCE; null when it was */
  dutyFallbackReason?: 'NO_PROFILE' | 'NO_BATTERY' | 'NO_PLANNED_DISTANCE'
  validFrom?: string
  validTo?: string
  created?: string
  updated?: string
}
export type ScheduledVehicleTripModel = {
  id: string
  vehicleId: string
  departureTime: string
  arrivalTime?: string
  distance?: number
  distanceUnits?: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  routeId?: string
  externalRouteId?: string
  externalVehicleId?: string
  sourceTms?: string
  metadata?: {
    [key: string]: object
  }
  recurrenceId?: string
  occurrenceIndex?: number
  calculatedEnergyRequirement?: CalculatedEnergyRequirementModel
}
export type PagedResponseV2ScheduledVehicleTripModel = {
  meta: Meta
  data: ScheduledVehicleTripModel[]
}
export type TripConflictsModel = object
export type ScheduledVehicleTripUpdateModel = {
  id: string
  departureTime: string
  arrivalTime?: string
  distance?: number
  distanceUnits?: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  routeId?: string
  externalRouteId?: string
  externalVehicleId?: string
  sourceTms?: string
  metadata?: {
    [key: string]: object
  }
}
export type ScheduledVehicleTripCreateModel = {
  vehicleId: string
  departureTime: string
  arrivalTime?: string
  distance?: number
  distanceUnits?: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  routeId?: string
  externalRouteId?: string
  externalVehicleId?: string
  sourceTms?: string
  metadata?: {
    [key: string]: object
  }
}
export type ScheduledVehicleTripDeleteModel = {
  tripIds: string[]
}
export type ScheduledTripRecurrenceModel = {
  id: string
  siteId: string
  vehicleIds: string[]
  startDate: string
  endDate: string
  neverEnding?: boolean
  startTime: string
  endTime?: string
  timezone: string
  distance?: number
  distanceUnits?: string
  scheduleName?: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  externalVehicleId?: string
  recurrenceRule: string
}
export type ScheduledTripRecurrenceUpdateModel = {
  startDate: string
  endDate?: string
  neverEnding?: boolean
  startTime: string
  endTime?: string
  timezone: string
  distance?: number
  distanceUnits?: string
  scheduleName?: string
  recurrenceRule: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  externalVehicleId?: string
}
export type ScheduledTripRecurrenceUpdateOccurrencesModel = {
  departureTime: string
  arrivalTime?: string
  distance?: number
  distanceUnits?: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
}
export type GridEventIntegrationAccountModel = {
  id: string
  organizationId?: string
  gridEventIntegrationId?: string
  authType?: 'PASSWORD' | 'API_KEY' | 'OAUTH'
}
export type UpdateGridEventIntegrationsAccountRequestParams = {
  id: string
  organizationId: string
  gridEventIntegrationId: string
  authType: 'PASSWORD' | 'API_KEY' | 'OAUTH'
}
export type CreateGridEventIntegrationsAccountRequestParams = {
  organizationId: string
  gridEventIntegrationId: string
  authType: 'PASSWORD' | 'API_KEY' | 'OAUTH'
  username?: string
  password?: string
  apiKey?: string
}
export type DepotEventIntervalModel = {
  intervalId?: string
  controlSignalValue?: string
  startDateTime: string
  endDateTime: string
  curtailedSiteLimit?: number
}
export type DepotEventScheduleModel = {
  depotEventScheduleId?: string
  intervals: DepotEventIntervalModel[]
}
export type EventRecurrenceModel1 = {
  eventRecurrenceId?: string
  recurrenceRule?: string
  startDate?: string
  validUntilDate?: string
  recurrenceName?: string
  recurrenceType?: 'DAILY' | 'WEEKLY' | 'WEEKDAYS' | 'CUSTOM'
  timezone?: string
  neverEnding?: boolean
}
export type DepotEventModel = {
  eventId?: string
  providerId?: string
  externalId?: string
  depotGridProfileId?: string
  depotId: string
  eventStartDate: string
  eventEndDate: string
  eventType: string
  eventDetails?: string
  schedule: DepotEventScheduleModel
  eventRecurrence?: EventRecurrenceModel1
  isCommitted?: boolean
  isConfirmed?: boolean
}
export type TimeOfUseRateModel = {
  id?: string
  rateName: string
  daysOfWeek: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Start time (HH:mm:ss) */
  startTime: string
  /** End time (HH:mm:ss) */
  endTime: string
  ratePerKWh: number
}
export type SeasonalRateModel = {
  seasonName: string
  /** Season start date in ISO MonthDay format (--MM-dd) */
  startDate: string
  /** Season end date in ISO MonthDay format (--MM-dd) */
  endDate: string
  defaultRate: number
  TariffTimeOfUse?: TimeOfUseRateModel[]
}
export type CustomTariffModel = {
  id: string
  name: string
  masterTariffId: string
  organizationId: string
  effectiveFrom: string
  effectiveTo?: string
  defaultRate: number
  currency: 'EUR' | 'USD' | 'SEK'
  createdBy?: string
  seasonalRates: SeasonalRateModel[]
}
export type CustomTariffUpdateRequest = {
  name: string
  defaultRate: number
  seasonalRates?: SeasonalRateModel[]
}
export type ChargerEventModel = {
  depotId: string
  eventId: string
  assetNm?: string
  assetId?: string
  chargerId?: string
  dispenserId?: string
  fleetId?: string
  status?: string
  scheduledStart?: string
  scheduledEnd?: string
  actualStart?: string
  actualEnd?: string
  eventType?: string
  powerOffered?: number
  targetSoc?: number
  eventTargetNm?: string
  chargerTagId?: string
  executionArn?: string
  profileId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  /** Padding duration added before the scheduled start time. */
  startPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    positive?: boolean
    units?: {
      durationEstimated?: boolean
      duration?: {
        seconds?: number
        zero?: boolean
        nano?: number
        negative?: boolean
        positive?: boolean
      }
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  /** Padding duration added after the scheduled end time. */
  endPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    positive?: boolean
    units?: {
      durationEstimated?: boolean
      duration?: {
        seconds?: number
        zero?: boolean
        nano?: number
        negative?: boolean
        positive?: boolean
      }
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  created?: string
  updated?: string
  createdBy?: string
  updatedBy?: string
  createdByOrganizationId?: string
  updatedByOrganizationId?: string
  eventRecurrence?: EventRecurrenceModel1
  effectiveStart?: string
  effectiveEnd?: string
}
export type ChargerEventUpdateModelDeprecated = {
  eventId: string
  status?: string
  eventType?: string
  targetSoc?: number
  profileId?: string
  powerOffered?: number
  chargerId?: string
  dispenserId?: string
  actualStart?: string
  actualEnd?: string
  scheduledStart?: string
  scheduledEnd?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
}
export type ChargerEventUpdateModel = {
  status?: string
  eventType?: string
  powerOffered?: number
  targetSoc?: number
  profileId?: string
  chargerId?: string
  connectorId?: string
  actualStart?: string
  actualEnd?: string
  scheduledStart?: string
  scheduledEnd?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  startPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    positive?: boolean
    units?: {
      durationEstimated?: boolean
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  endPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    positive?: boolean
    units?: {
      durationEstimated?: boolean
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  chargerTagId?: string
  effectiveStart?: string
  effectiveEnd?: string
}
export type ReassignEventConnectorModel = {
  chargerId?: string
  dispenserId?: string
}
export type GetTelemetryExclusionModel = {
  /** The id for a vehicle */
  vehicleId: string
  /** The start timestamp for this telemetry exclusion period */
  startTimestamp: string
  /** The end timestamp for this telemetry exclusion period */
  endTimestamp: string
  /** The id for this telemetry exclusion period */
  id: string
}
export type PagedResponseV2GetTelemetryExclusionModel = {
  meta: Meta
  data: GetTelemetryExclusionModel[]
}
export type BaseTelemetryExclusionModel = {
  /** The id for a vehicle */
  vehicleId: string
  /** The start timestamp for this telemetry exclusion period */
  startTimestamp: string
  /** The end timestamp for this telemetry exclusion period */
  endTimestamp: string
}
export type CreateTelemetryExclusionRequestModel = {
  /** The list of configurations to use to exclude telemetry */
  createTelemetryExclusionModelList: BaseTelemetryExclusionModel[]
}
export type ChargeManagementConfiguration = {
  status?: 'ACTIVE' | 'INACTIVE'
  loadManagement?: 'OFF' | 'FIXED' | 'DYNAMIC' | 'NODE_MANAGED'
  offlineControls?: 'OFF' | 'FIXED_POWER_DISTRIBUTION' | 'DYNAMIC_POWER_DISTRIBUTION'
  siteLimit?: number
  dynamicDefaultsEnabled?: boolean
  optimizeBeforeScheduleCharge?: boolean
  loadAwareAllocationEnabled?: boolean
  minimumTrickleChargeKw?: number
  trickleChargeInitialStepEnabled?: boolean
  stopAtMaxSocEnabled?: boolean
  defaultMaxSoc?: number
  stepIntoV2g?: boolean
  chargerAssignmentStrategy?: 'NONE' | 'FULL_CONNECTOR_ASSIGNMENT' | 'DEFINITIVE_PLACEMENT'
}
export type EnergyManagementConfiguration = {
  status?: 'ACTIVE' | 'INACTIVE'
  vehicleToGridStatus?: 'ACTIVE' | 'INACTIVE'
  linkStatus?: 'ACTIVE' | 'INACTIVE'
  autopilotStatus?: 'ACTIVE' | 'INACTIVE'
}
export type NodeChargeManagementConfigurationModel = {
  /** The unique identifier of the node charge management configuration. */
  id: string
  /** The status of the node charge management configuration. */
  status: 'ACTIVE' | 'INACTIVE'
  /** The load management strategy for the node charge management configuration. */
  loadManagement?: 'OFF' | 'FIXED' | 'DYNAMIC'
  nodeLimit?: number
  /** The ramp rate in kW per minute for gradual power ramping on generator-powered nodes. */
  rampRateKwPerMin?: number | null
  /** The default curtailment limit in kW: the limit the node is held to while a curtailment is active and no operator override is in place. Null means no default is configured. */
  defaultCurtailmentLimit?: number | null
  /** The percentage, from 0 to 50, of what the node's distributed energy resources can supply that is held back and never allocated to chargers, so they are not run at their absolute maximum. Null means no buffer, the same as 0. */
  derSupplyBufferPercent?: number | null
  /** Whether the optimizer reads this node's curtailment-state shadow and applies dynamic node limits to it. Off unless it has been switched on. */
  dynamicNodeLimitEnabled: boolean
}
export type NodeEnergyConfigurationModel = {
  id: string
  siteId: string
  nodeId: string
  validFrom: string
  validTo?: string
  createdBy: string
  nodeChargeManagementConfigurationModel: NodeChargeManagementConfigurationModel
}
export type SiteEnergyConfiguration = {
  id?: string
  siteId?: string
  chargeManagementConfiguration?: ChargeManagementConfiguration
  energyManagementConfiguration?: EnergyManagementConfiguration
  validFrom?: string
  validTo?: string
  nodeEnergyConfigurationModel?: NodeEnergyConfigurationModel[]
}
export type JsonApiErrorObject = {
  /** A unique identifier for the problem that occurred */
  id?: string
  /** A short summary of the problem that occurred */
  title?: string
  /** The HTTP status code applicable to this problem, expressed as a string value */
  status?: '200' | '400' | '401' | '409' | '500'
  /** An object containing the location of the error */
  source?: string
  /** An explanation of the problem that occurred */
  detail?: string
  /** An application-specific error code, expressed as a string value */
  code?: string
  /** Error-specific information to help clients further understand the error */
  meta?: object
}
export type JsonApiErrorWrapper = {
  /** A list of errors */
  errors?: JsonApiErrorObject[]
}
export type ChargeManagementConfigurationRequestParams = {
  status: 'ACTIVE' | 'INACTIVE'
  loadManagement: 'OFF' | 'FIXED' | 'DYNAMIC' | 'NODE_MANAGED'
  offlineControls: 'OFF' | 'FIXED_POWER_DISTRIBUTION' | 'DYNAMIC_POWER_DISTRIBUTION'
  siteLimit?: number
  dynamicDefaultsEnabled?: boolean
  optimizeBeforeScheduleCharge?: boolean
  loadAwareAllocationEnabled?: boolean
  minimumTrickleChargeKw?: number
  trickleChargeInitialStepEnabled?: boolean
  stopAtMaxSocEnabled?: boolean
  defaultMaxSoc?: number
  stepIntoV2g?: boolean
  chargerAssignmentStrategy?: 'NONE' | 'FULL_CONNECTOR_ASSIGNMENT' | 'DEFINITIVE_PLACEMENT'
}
export type EnergyManagementConfigurationRequestParams = {
  status: 'ACTIVE' | 'INACTIVE'
  vehicleToGridStatus: 'ACTIVE' | 'INACTIVE'
  linkStatus: 'ACTIVE' | 'INACTIVE'
  autopilotStatus: 'ACTIVE' | 'INACTIVE'
}
export type NodeChargeManagementConfigurationParams = {
  status: 'ACTIVE' | 'INACTIVE'
  loadManagement: 'OFF' | 'FIXED' | 'DYNAMIC'
  nodeLimit?: number
  rampRateKwPerMin?: number | null
  /** The limit in kW, between 0 and nodeLimit, that the node is held to while a curtailment is active and no operator override is in place. A number sets it and null removes it. When omitted, the node's current default is kept unchanged. */
  defaultCurtailmentLimit?: number | null
  /** Whether the optimizer reads this node's curtailment-state shadow and applies dynamic node limits to it. When omitted or null, the node's current setting is kept unchanged; a node starts with it off. */
  dynamicNodeLimitEnabled?: boolean | null
  /** The percentage, between 0 and 50, of what the node's distributed energy resources can supply that is held back and never allocated to chargers, so they are not run at their absolute maximum. A number sets it and null removes it, which is the same as 0. When omitted, the node's current buffer is kept unchanged. */
  derSupplyBufferPercent?: number | null
}
export type CreateNodeEnergyConfigurationParams = {
  nodeId: string
  nodeChargeManagementConfiguration: NodeChargeManagementConfigurationParams
}
export type CreateSiteEnergyConfigurationParams = {
  chargeManagementConfiguration: ChargeManagementConfigurationRequestParams
  energyManagementConfiguration: EnergyManagementConfigurationRequestParams
  nodeEnergyConfigurations?: CreateNodeEnergyConfigurationParams[]
}
export type ScheduledTripRecurrenceCreateModel = {
  siteId: string
  vehicleIds: string[]
  startDate: string
  endDate?: string
  neverEnding?: boolean
  startTime: string
  endTime?: string
  timezone: string
  distance?: number
  distanceUnits?: string
  scheduleName?: string
  recurrenceRule: string
  targetSoc?: number
  includeLoadingPeriod?: boolean
  loadingPeriodStartOffsetMinutes?: number
  loadingPeriodMinutes?: number
  departureSiteId?: string
  arrivalSiteId?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  externalVehicleId?: string
}
export type ScheduledTripRecurrenceSetVehiclesModel = {
  vehicleIds: string[]
  occurrenceIndex: number
}
export type VehicleOptimizationScheduleSegment = {
  segment?: 'CHARGE' | 'LOADING'
  chainIndex?: number
  from?: string
  to?: string
  chargerId?: string
  chargerName?: string
  connectorId?: number
  connectorName?: string
  expectedSoc?: number
}
export type VehicleOptimizationModel = {
  vehicleOptimizationId?: string
  optimizationId?: string
  chargerEventId?: string
  profileId?: string
  vehicleId: string
  depotId: string
  startSoc?: number
  targetSoc?: number
  scheduledRouteId?: string
  batterySize?: number
  maxPower?: number
  chargerId?: string
  connectorId?: number
  from?: string
  to?: string
  feasible?: boolean
  expectedSoc?: number
  sourceEntityId?: string
  sourceEntityType?: 'VEHICLE_CHARGE' | 'SCHEDULED_VEHICLE_TRIP'
  infeasibilityReason?:
    | 'CHARGER_POWER_LIMIT'
    | 'SITE_POWER_LIMIT'
    | 'NODE_POWER_LIMIT'
    | 'ENERGY_EXCEEDS_CAPACITY'
    | 'NO_CHARGER_ASSIGNMENT'
    | 'OTHER'
  schedule?: VehicleOptimizationScheduleSegment[]
}
export type OptimizationModel = {
  optimizationId?: string
  depotId: string
  depotName?: string
  timeStepMinutes?: number
  optimizationType?: string
  timeStepsMinutes?: number[]
  costCurve?: number[]
  siteLimitCurve?: number[]
  regularizationConstant?: number
  from?: string
  to?: string
  feasible?: boolean
  errorMessage?: string
  parentOptimizationId?: string
  validFrom?: string
  validTo?: string
  vehicleOptimizations?: VehicleOptimizationModel[]
  nsteps?: number
}
export type PagedResponseV2OptimizationModel = {
  meta: Meta
  data: OptimizationModel[]
}
export type MarketRegionModel = {
  code?: string
  name?: string
  tariffProvider?: 'CUSTOM' | 'GENABILITY' | 'NORDPOOL'
  timezone?: string
}
export type MarketRegionListModel = {
  regions?: MarketRegionModel[]
}
export type CreateMarketRegionRequest = {
  code: string
  name: string
  tariffProvider: 'CUSTOM' | 'GENABILITY' | 'NORDPOOL'
  timezone?: string
}
export type AverageRatesRequestBody = {
  /** Postal code to look up utility and tariff. Required if masterTariffId is not provided. */
  postalCode?: string
  /** Country code (US or CA). */
  country?: 'US' | 'CA'
  /** Start time (UTC, ISO-8601). */
  startTime: string
  /** End time (UTC, ISO-8601). Must be after startTime. */
  endTime: string
  /** Customer class for utility/tariff selection. */
  customerClass?: 'residential' | 'commercial'
  /** Interval for rate grouping. */
  interval?: '15m' | '1h' | '1d' | 'all'
  /** If provided, skip utility/tariff lookup and use this tariff directly. */
  masterTariffId?: number
}
export type AverageRatesInformational = {
  utilityName?: string
  tariffName?: string
  tariffCode?: string
  tariffHasTimeOfUseRates?: boolean
  currency?: string
  totalMatchingUtilities?: number
  totalMatchingTariffsForUtility?: number
  paramsUsed?: AverageRatesRequestBody
}
export type AverageRatesResults = {
  columns?: string[]
  values?: object[][]
}
export type AverageRatesResponse = {
  informational?: AverageRatesInformational
  results?: AverageRatesResults
}
export type ErrorDetail = {
  message?: string
}
export type Embedded = {
  errors?: ErrorDetail[]
}
export type JsonErrorEnvelope = {
  _links?: {
    [key: string]: object
  }
  _embedded?: Embedded
  message?: string
}
export type LoadBalancerEventModel = {
  id?: string
  origin?: string
  eventType?:
    | 'DEPOT_EVENT'
    | 'CHARGER_EVENT'
    | 'SCHEDULED_EVENT_START'
    | 'HEARTBEAT'
    | 'AFTER_START'
    | 'AFTER_STOP'
    | 'EMS_ON'
    | 'EMS_OFF'
    | 'SITE_LIMIT'
    | 'FIXED_LOAD_MANAGEMENT_TURNED_OFF'
    | 'FIRST_SOC_UPDATE'
  chargerId?: string
  fleetId?: string
  depotId?: string
  originTime?: string
  executionTime?: string
}
export type PagedResponseLoadBalancerEventModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: LoadBalancerEventModel[]
}
export type EnergyEfficiencyPredictionModel = {
  energyEfficiencyPredictionId: string
  fleetId: string
  depotId: string
  vehicleId: string
  efficiency?: number
  confidence?: number
  modelName?: string
  validFrom?: string
  validTo?: string
  windowFrom?: string
  windowTo?: string
}
export type BooleanModel = {
  result?: boolean
}
export type CreateEnergyEfficiencyPredictionRequestParams = {
  fleetId?: string
  depotId?: string
  vehicleId?: string
  efficiency?: number
  confidence?: number
  modelName?: string
  validFrom?: string
  validTo?: string
  windowFrom?: string
  windowTo?: string
}
export type TransactionProfileMappingModel = {
  id?: string
  profileId?: string
  transactionId?: string
  chargerId?: string
  connectorId?: string
  depotId?: string
  siteDataSnapshotTimestamp?: string
  source?: string
}
export type EffectiveNodeEnergyLimitWindow = {
  windowStart: string
  limit: number
}
export type EffectiveNodeEnergyLimitModel = {
  windowStart: string
  windowEnd?: string
  effectiveEnergyLimits: EffectiveNodeEnergyLimitWindow[]
}
export type EffectiveNodeEnergyLimitWindowRequest = {
  windowStart: string
  limit: number
}
export type EffectiveNodeEnergyLimitRequest = {
  nodeId: string
  windowStart: string
  effectiveEnergyLimits: EffectiveNodeEnergyLimitWindowRequest[]
}
export type CustomTariffCreateRequest = {
  name: string
  organizationId: string
  defaultRate: number
  currency: 'EUR' | 'USD' | 'SEK'
  seasonalRates?: SeasonalRateModel[]
}
export type ProfileApplicationRecord = {
  id?: string
  applicationTime?: string
  chargerId?: string
  dispenserId?: string
  profileId?: string
  applicationStatus?: 'ACCEPTED' | 'FAILED' | 'REJECTED' | 'TIMEOUT' | 'NOT_CONNECTED' | 'NOT_SUPPORTED' | 'INVALID'
  profileType?: 'TX_PROFILE' | 'TX_DEFAULT_PROFILE' | 'CHARGE_POINT_MAX_PROFILE'
  origin?: string
  statusDescription?: string
}
export type CreateProfileApplicationRecordParams = {
  dispenserId: string
  profileId: string
  applicationStatus: 'ACCEPTED' | 'FAILED' | 'REJECTED' | 'TIMEOUT' | 'NOT_CONNECTED' | 'NOT_SUPPORTED' | 'INVALID'
  profileType: 'TX_PROFILE' | 'TX_DEFAULT_PROFILE' | 'CHARGE_POINT_MAX_PROFILE'
  origin: string
}
export type ScheduleRequestModel = {
  assetId?: string
  chargerId: string
  dispenserId: string
  powerOffered?: number
  targetSoc?: number
  profileId?: string
  eventType: string
  eventTargetNm?: string
  chargerTagId?: string
  depotId: string
  sessionLengthMinutes?: number
  validUntilDate?: string
  scheduledStart: string
  scheduledEnd?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  eventRecurrence?: EventRecurrenceModel1
}
export type ChargingSessionModel1 = {
  sessionId?: string
  connectorId?: number
  chargerId?: string
  ocppTag?: string
  vehicleId?: string
  vin?: string
  userId?: string
  startTimestamp?: string
  stopTimestamp?: string
  stopReason?: string
  depotId?: string
  fleetId?: string
  chargerName?: string
  depotName?: string
  kwhConsumed?: number
  kwhConsumedUnit?: string
  powerImported?: number
  powerImportUnit?: string
  powerOffered?: number
  powerOfferedUnit?: string
  startSocValue?: number
  endSocValue?: number
}
export type ChargerEventSessionDetailsModel = {
  eventId?: string
  sessions?: ChargingSessionModel1[]
}
export type ChargerEventSessionModel = {
  chargerEventSessionId?: string
  eventId?: string
  sessionId?: string
}
export type ChargerEventPredictionRequestModel = {
  assetId?: string
  chargerId: string
  dispenserId: string
  depotId: string
  fleetId: string
  scheduledStart?: string
  scheduledEnd?: string
  validTo: string
  modelName: string
  chargerEventId: string
  confidence?: number
}
export type PagedResponseChargerEventModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerEventModel[]
}
export type ChargerEventCreateModel = {
  siteId: string
  chargerId?: string
  connectorId?: string
  vehicleId?: string
  eventType: string
  powerOffered?: number
  targetSoc?: number
  profileId?: string
  chargerTagId?: string
  scheduledStart: string
  scheduledEnd?: string
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  eventRecurrence?: EventRecurrenceModel1
  startPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    positive?: boolean
    units?: {
      durationEstimated?: boolean
      duration?: {
        seconds?: number
        zero?: boolean
        nano?: number
        negative?: boolean
        positive?: boolean
      }
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  endPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    positive?: boolean
    units?: {
      durationEstimated?: boolean
      duration?: {
        seconds?: number
        zero?: boolean
        nano?: number
        negative?: boolean
        positive?: boolean
      }
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  effectiveStart?: string
  effectiveEnd?: string
  socTypeEvent?: boolean
  combinedEventType?: string
  predictedEvent?: boolean
  maxPowerEvent?: boolean
  timedChargeEvent?: boolean
  limitChargeEvent?: boolean
  adHocChargeEvent?: boolean
  reservationEvent?: boolean
}
export type ChargerEventNewSessionModel = {
  sessionId: string
}
export type PagedResponseV2VehicleOptimizationModel = {
  meta: Meta
  data: VehicleOptimizationModel[]
}
export type TariffProperty = {
  propertyId?: number
  quantityKey?: string
  keyName?: string
  displayName?: string
  keyspace?: string
  family?: string
  dataType?: string
  operator?: string
  propertyValue?: string
  minValue?: string
  maxValue?: string
  description?: string
  isDefault?: boolean
  lookbackQuantity?: number
  lookbackPeriod?: string
  lookbackIntervalQuantity?: number
  lookbackTimeOfUseId?: number
}
export type Season = {
  seasonId?: number
  lseId?: number
  seasonGroupId?: number
  seasonName?: string
  seasonFromMonth?: number
  seasonFromDay?: number
  fromEdgePredominance?: string
  seasonToMonth?: number
  seasonToDay?: number
  toEdgePredominance?: string
}
export type Period = {
  touPeriodId?: number
  touId?: number
  fromDayOfWeek?: number
  fromHour?: number
  fromMinute?: number
  toDayOfWeek?: number
  toHour?: number
  toMinute?: number
}
export type TimeOfUse = {
  touId?: number
  touGroupId?: number
  lseId?: number
  touName?: string
  calendarId?: number
  season?: Season
  touType?: string
  isDynamic?: boolean
  touPeriods?: Period[]
  privacy?: string
}
export type TariffRateBand = {
  tariffRateBandId?: number
  tariffRateId?: number
  rateSequenceNumber?: number
  hasConsumptionLimit?: boolean
  consumptionUpperLimit?: number
  hasDemandLimit?: boolean
  demandUpperLimit?: number
  hasPropertyLimit?: boolean
  propertyUpperLimit?: number
  prevUpperLimit?: number
  applicabilityValue?: string
  calculationFactor?: number
  rateAmount?: number
  rateUnit?: string
  isCredit?: boolean
}
export type TariffRate = {
  tariffRateId?: number
  tariffId?: number
  riderTariffId?: number
  riderId?: number
  tariffSequenceNumber?: number
  tariffBookSequenceNumber?: number
  rateGroupName?: string
  tariffBookRateGroupName?: string
  rateName?: string
  tariffBookRateName?: string
  fromDateTime?: string
  toDateTime?: string
  season?: Season
  timeOfUse?: TimeOfUse
  chargeType?: string
  chargeClass?: string
  chargePeriod?: string
  transactionType?: string
  quantityKey?: string
  applicabilityKey?: string
  variableLimitKey?: string
  variableRateKey?: string
  variableFactorKey?: string
  rateBands?: TariffRateBand[]
}
export type Tariff = {
  tariffId?: number
  masterTariffId?: number
  tariffCode?: string
  tariffName?: string
  tariffBookName?: string
  lseId?: number
  lseName?: string
  lseCode?: string
  serviceType?: string
  priorTariffId?: number
  distributionLseId?: number
  tariffType?: 'DEFAULT' | 'ALTERNATIVE' | 'OPTIONAL_EXTRA' | 'RIDER'
  customerClass?: 'RESIDENTIAL' | 'GENERAL' | 'SPECIAL_USE' | 'PROPOSED'
  customerCount?: number
  customerLikelihood?: number
  customerCountSource?: string
  territoryId?: string
  effectiveDate?: string
  endDate?: string
  closedDate?: string
  effectiveOnRule?: string
  timeZone?: string
  billingPeriod?: string
  currency?: string
  chargeTypes?: string
  chargePeriod?: string
  minMonthlyConsumption?: number
  maxMonthlyConsumption?: number
  minMonthlyDemand?: number
  maxMonthlyDemand?: number
  hasTimeOfUseRates?: boolean
  hasTieredRates?: boolean
  hasContractedRates?: boolean
  hasTariffApplicability?: boolean
  hasRateApplicability?: boolean
  hasNetMetering?: boolean
  privacy?: string
  properties?: TariffProperty[]
  rates?: TariffRate[]
}
export type TariffsResponse = {
  status?: string
  count?: number
  type?: string
  results?: Tariff[]
  pageStart?: number
  pageCount?: number
}
export type TariffResponse = {
  status?: string
  count?: number
  type?: string
  results?: Tariff[]
}
export type DemandChargeRateModel = {
  tariffId?: number
  tariffRateId?: number
  rateName?: string
  lookbackIntervalMinutes?: number
  rate?: number
}
export type DemandChargesResponse = {
  masterTariffId?: number
  from?: string
  to?: string
  demandCharges?: DemandChargeRateModel[]
}
export type PriceChange = {
  name?: string
  from?: string
  to?: string
  rateAmount?: number
  rateMeanDelta?: number
  projected?: boolean
}
export type Price = {
  description: string
  from: string
  to: string
  currency: string
  rateMean?: number
  rateStandardDeviation?: number
  priceChanges: PriceChange[]
}
export type LinkTelemetryTuple = {
  timestamp?: number
  value?: number
}
export type LinkTelemetrySeries = {
  units?: string
  seriesName?: string
  values?: LinkTelemetryTuple[]
}
export type LinkTelemetryResponse = {
  telemetrySeries?: LinkTelemetrySeries[]
}
export type PagedResponseV2SiteReservationConfigurationResponseModel = {
  meta: Meta
  data: SiteReservationConfigurationResponseModel[]
}
export type BillingPeriodRepresentation = {
  fromDateOffset?: number
  toDateOffset?: number
  style?: string
}
export type LoadServingEntity = {
  lseId?: number
  name?: string
  code?: string
  lseCode?: string
  websiteHome?: string
  offeringType?: string
  ownership?: string
  serviceTypes?: string
  totalRevenues?: number
  totalSales?: number
  totalCustomers?: number
  residentialServiceTypes?: string
  residentialRevenues?: number
  residentialSales?: number
  residentialCustomers?: number
  commercialServiceTypes?: string
  commercialRevenues?: number
  commercialSales?: number
  commercialCustomers?: number
  industrialServiceTypes?: string
  industrialRevenues?: number
  industrialSales?: number
  industrialCustomers?: number
  transportationServiceTypes?: string
  transportationRevenues?: number
  transportationSales?: number
  transportationCustomers?: number
  billingPeriodRepresentation?: BillingPeriodRepresentation
}
export type LoadServingEntitiesResponse = {
  status?: string
  count?: number
  type?: string
  results?: LoadServingEntity[]
  pageStart?: number
  pageCount?: number
}
export type GridEventIntegrationModel = {
  id: string
  name?: string
  pollingRate?: number
  endpoint?: string
}
export type PowerTimeSeriesPeriod = {
  startTimestamp: string
  startEpochSeconds: number
  powerLevel: number
}
export type PowerTimeSeriesModel = {
  startTimestamp: string
  endTimestamp: string
  powerLevels?: PowerTimeSeriesPeriod[]
}
export type DepotEventDetailsModel = {
  eventId?: string
  depotId?: string
  eventStartDate?: string
  eventEndDate?: string
  transactionIds?: string[]
  vehicles?: string[]
  chargers?: string[]
  peakPower?: number
  unmanagedPeakPower?: number
  energyImported?: number
  unmanagedEnergyImported?: number
  energyExported?: number
}
export type ChargerEventPredictionModel = {
  depotId: string
  eventId?: string
  assetId?: string
  chargerId?: string
  dispenserId?: string
  fleetId?: string
  validFrom?: string
  validTo?: string
  scheduledStart?: string
  scheduledEnd?: string
  confidence?: number
  modelName?: string
  chargerEventId?: string
}
export type ChargingSessionTelemetryModel1 = {
  chargerId?: string
  connectorId?: number
  chargingSessionId?: string
  measuredAt?: string
  currentImport?: number
  currentImportUnit?: string
  currentOffered?: number
  currentOfferedUnit?: string
  energyActiveImportRegister?: number
  energyActiveImportRegisterUnit?: string
  powerActiveImport?: number
  powerActiveImportUnit?: string
  livePowerImportUnit?: string
  powerOffered?: number
  powerOfferedUnit?: string
  voltage?: number
  voltageUnit?: string
  temperature?: number
  temperatureUnit?: string
  soc?: number
  socUnit?: string
  currentExport?: number
  currentExportUnit?: string
  powerActiveExport?: number
  powerActiveExportUnit?: string
  energyActiveExportRegister?: number
  energyActiveExportRegisterUnit?: string
  energyActiveImportInterval?: number
  energyActiveImportIntervalUnit?: string
  powerFactor?: number
  powerFactorUnit?: string
  context?: string
  livePowerImport?: number
  livePowerUnit?: string
}
export type ChargerEventSessionTelemetryModel = {
  chargerEventId?: string
  sessionTelemetry?: {
    [key: string]: ChargingSessionTelemetryModel1[]
  }
}
export type TimeSourceAttributeValue = {
  value: number
  confidence?: number
  source: string
  lastUpdated: number
  /** minutes until target soc is reached */
  units: 'min'
}
export type JsonApiErrorModel = {
  /** Details about this individual error */
  detail: string
  /** Error title (category) */
  title: string
  /** HTTP status code */
  status: number
}
export type Coord = {
  /** Longitude */
  lon?: number
  /** Latitude */
  lat?: number
}
export type Weather = {
  /** Weather condition ID */
  id?: number
  /** Main weather condition */
  main?:
    | 'Thunderstorm'
    | 'Drizzle'
    | 'Rain'
    | 'Snow'
    | 'Mist'
    | 'Smoke'
    | 'Haze'
    | 'Dust'
    | 'Fog'
    | 'Sand'
    | 'Ash'
    | 'Squall'
    | 'Tornado'
    | 'Clear'
    | 'Clouds'
  /** Weather condition description */
  description?: string
  /** Weather icon ID */
  icon?: string
}
export type Main = {
  /** Current temperature */
  temp?: number
  /** Temperature feels like */
  feelsLike?: number
  /** Minimum temperature */
  tempMin?: number
  /** Maximum temperature */
  tempMax?: number
  /** Atmospheric pressure (hPa) */
  pressure?: number
  /** Humidity percentage */
  humidity?: number
  /** Deviation from average temperature */
  temperatureDeviation?: number
  /** Temperature percentile (0-100) */
  temperaturePercentile?: number
  /** Human readable temperature context */
  temperatureContext?: string
}
export type Wind = {
  /** Wind speed (imperial: mph, metric: m/s) */
  speed?: number
  /** Wind direction in degrees */
  deg?: number
  /** Wind gust speed */
  gust?: number
}
export type Clouds = {
  /** Cloud coverage percentage */
  all?: number
}
export type Sys = {
  /** Internal parameter */
  type?: number
  /** Internal parameter */
  id?: number
  /** Country code */
  country?: string
  /** Sunrise time, unix, UTC */
  sunrise?: number
  /** Sunset time, unix, UTC */
  sunset?: number
}
export type WeatherResponse = {
  coord?: Coord
  /** Weather conditions */
  weather?: Weather[]
  /** Internal parameter */
  base?: string
  main?: Main
  /** Visibility in meters */
  visibility?: number
  wind?: Wind
  clouds?: Clouds
  /** Time of data calculation, unix, UTC */
  dt?: number
  sys?: Sys
  /** Timezone shift from UTC in seconds */
  timezone?: number
  /** Location ID */
  id?: number
  /** Location name */
  name?: string
  /** Internal parameter */
  cod?: number
}
export type Hourly = {
  /** Time of the forecasted data (unix seconds, UTC) */
  dt?: number
  /** Temperature (metric: °C, imperial: °F, standard: K) */
  temp?: number
  /** Apparent (feels-like) temperature (metric: °C, imperial: °F, standard: K) */
  feelsLike?: number
  /** Relative humidity (%, 0-100) */
  humidity?: number
  /** Atmospheric pressure at sea level (hPa, all unit systems) */
  pressure?: number
  /** Wind speed (metric: m/s, imperial: mph, standard: m/s) */
  windSpeed?: number
  /** Wind direction (meteorological degrees, 0-360) */
  windDeg?: number
  /** Wind gust speed (metric: m/s, imperial: mph, standard: m/s) */
  windGust?: number
  /** Cloud cover (%, 0-100) */
  clouds?: number
  /** Probability of precipitation (fraction, 0-1) */
  pop?: number
  /** Weather conditions */
  weather?: Weather[]
}
export type Daily = {
  /** Time of the forecasted data, local noon (unix seconds, UTC) */
  dt?: number
  /** Sunrise time (unix seconds, UTC) */
  sunrise?: number
  /** Sunset time (unix seconds, UTC) */
  sunset?: number
  /** Minimum daily temperature (metric: °C, imperial: °F, standard: K) */
  tempMin?: number
  /** Maximum daily temperature (metric: °C, imperial: °F, standard: K) */
  tempMax?: number
  /** Day temperature (metric: °C, imperial: °F, standard: K) */
  tempDay?: number
  /** Night temperature (metric: °C, imperial: °F, standard: K) */
  tempNight?: number
  /** Apparent (feels-like) day temperature (metric: °C, imperial: °F, standard: K) */
  feelsLikeDay?: number
  /** Relative humidity (%, 0-100) */
  humidity?: number
  /** Maximum daily wind speed (metric: m/s, imperial: mph, standard: m/s) */
  windSpeed?: number
  /** Probability of precipitation (fraction, 0-1) */
  pop?: number
  /** Weather conditions */
  weather?: Weather[]
}
export type WeatherForecastResponse = {
  coord?: Coord
  /** Timezone shift from UTC (seconds) */
  timezone?: number
  /** IANA timezone name */
  timezoneName?: string
  /** Unit system the numeric values are expressed in (echoes the request's units parameter; metric: °C and m/s, imperial: °F and mph, standard: K and m/s). Efficiency callers always request metric. */
  units?: 'metric' | 'imperial' | 'standard'
  /** Hourly forecast entries (up to 48 hours) */
  hourly?: Hourly[]
  /** Daily forecast entries (up to 8 days) */
  daily?: Daily[]
}
export type TelematicsFeedCursor = {
  id: string
  created: string
  createdBy: string
  lastModified: string
  lastModifiedBy: string
  integrationId: string
  feedType: 'TRIP' | 'STATUS' | 'LOCATION' | 'CHARGE_EVENT' | 'FAULT_DATA'
  cursorValue?: string
  cursorKind: 'TO_VERSION' | 'TIMESTAMP'
  status: 'PENDING' | 'SUCCESS' | 'ERROR' | 'PAUSED'
  lastPolledTimestamp?: string
}
export type UpdateTelematicsFeedCursorStatusRequest = {
  status: 'PENDING' | 'SUCCESS' | 'ERROR' | 'PAUSED'
  reason?: string
}
export type OrganizationReference = {
  id: string
  name: string
}
export type IntegrationProviderReference = {
  id: string
  name: string
  description?: string
  logoUrl?: string
  integrationType:
    | 'PAYMENT_TERMINAL'
    | 'PAYMENT_WEB'
    | 'COMPLIANCE_REPORTING'
    | 'OPERATIONS'
    | 'PAYMENT_PROVIDERS'
    | 'VEHICLE_TELEMATICS'
    | 'ROAMING'
    | 'ENERGY_AGGREGATORS'
}
export type Integration = {
  id: string
  created: string
  createdBy: string
  lastModified: string
  lastModifiedBy: string
  organization: OrganizationReference
  integrationProvider: IntegrationProviderReference
  name: string
  status: 'PENDING' | 'CONNECTED' | 'ACTION_REQUIRED' | 'CONTACT_SUPPORT'
  configuration?: {
    [key: string]: string
  }
}
export type UpdateIntegrationStatusRequest = {
  status: 'PENDING' | 'CONNECTED' | 'ACTION_REQUIRED' | 'CONTACT_SUPPORT'
  reason?: string
}
export type CreateTelematicsFeedCursorRequest = {
  integrationId: string
  feedType: 'TRIP' | 'STATUS' | 'LOCATION' | 'CHARGE_EVENT' | 'FAULT_DATA'
  cursorValue?: string
  cursorKind: 'TO_VERSION' | 'TIMESTAMP'
  status?: 'PENDING' | 'SUCCESS' | 'ERROR' | 'PAUSED'
  lastPolledTimestamp?: string
}
export type SiteReference = {
  id: string
  name: string
}
export type PaymentTerminalOption = {
  label: string
  chargerId: string
  connectorId: number
}
export type PaymentTerminal = {
  id: string
  created: string
  createdBy: string
  lastModified: string
  lastModifiedBy: string
  integrationId: string
  serialNumber: string
  name: string
  online: boolean
  organization: OrganizationReference
  site?: SiteReference
  options?: PaymentTerminalOption[]
}
export type CreatePaymentTerminalRequest = {
  serialNumber: string
  name: string
  integrationId: string
  organizationId: string
  online: boolean
  siteId?: string
  options?: PaymentTerminalOption[]
}
export type AssignPaymentTerminalsRequest = {
  paymentTerminalIds: string[]
  organizationId: string
}
export type PaymentTerminalSession = {
  id: string
  created: string
  createdBy: string
  lastModified: string
  lastModifiedBy: string
  paymentTerminalId: string
  paymentTerminalOption: PaymentTerminalOption
  authorizationStrategy: 'MINIMUM' | 'MAXIMUM' | 'INCREMENTAL'
  authorizationAmount: number
  status: 'READING' | 'AUTHORIZING' | 'AUTHORIZED' | 'COMMITTED' | 'CANCELLED' | 'FAILED'
  externalSessionId: string
  authTag: string
  transactionId: string
  lineItemId: string
  authorizedAmount?: number
  finalAmount?: number
}
export type CreatePaymentTerminalSessionRequest = {
  paymentTerminalId: string
  paymentTerminalOption: PaymentTerminalOption
  authorizationStrategy: 'MINIMUM' | 'MAXIMUM' | 'INCREMENTAL'
  authorizationAmount: number
}
export type CreateIntegrationRequest = {
  integrationProviderId: string
  organizationId: string
  name: string
  configuration?: {
    [key: string]: string
  }
}
export type ConfigurationKey = {
  label: string
  required: boolean
  secret: boolean
}
export type IntegrationProvider = {
  id: string
  created: string
  createdBy: string
  lastModified: string
  lastModifiedBy: string
  name: string
  description?: string
  logoUrl?: string
  integrationKey?: string
  integrationType:
    | 'PAYMENT_TERMINAL'
    | 'PAYMENT_WEB'
    | 'COMPLIANCE_REPORTING'
    | 'OPERATIONS'
    | 'PAYMENT_PROVIDERS'
    | 'VEHICLE_TELEMATICS'
    | 'ROAMING'
    | 'ENERGY_AGGREGATORS'
  status: 'AVAILABLE' | 'COMING_SOON' | 'DEPRECATED'
  configurationKeys?: {
    [key: string]: ConfigurationKey
  }
  requiredGate?: string
  gateFailureBehavior?: 'HIDDEN' | 'COMING_SOON'
}
export type CreateIntegrationProviderRequest = {
  name: string
  description?: string
  logoUrl?: string
  integrationKey?: string
  integrationType:
    | 'PAYMENT_TERMINAL'
    | 'PAYMENT_WEB'
    | 'COMPLIANCE_REPORTING'
    | 'OPERATIONS'
    | 'PAYMENT_PROVIDERS'
    | 'VEHICLE_TELEMATICS'
    | 'ROAMING'
    | 'ENERGY_AGGREGATORS'
  status: 'AVAILABLE' | 'COMING_SOON' | 'DEPRECATED'
  configurationKeys?: {
    [key: string]: ConfigurationKey
  }
  requiredGate?: string
  gateFailureBehavior?: 'HIDDEN' | 'COMING_SOON'
}
export type UpdateTelematicsFeedCursorRequest = {
  cursorValue?: string
  cursorKind?: 'TO_VERSION' | 'TIMESTAMP'
  status?: 'PENDING' | 'SUCCESS' | 'ERROR' | 'PAUSED'
  lastPolledTimestamp?: string
}
export type UpdatePaymentTerminalRequest = {
  name?: string
  organizationId?: string
  online?: boolean
  siteId?: string
  options?: PaymentTerminalOption[]
}
export type UpdatePaymentTerminalSessionRequest = {
  externalSessionId?: string
  status?: 'READING' | 'AUTHORIZING' | 'AUTHORIZED' | 'COMMITTED' | 'CANCELLED' | 'FAILED'
  authTag?: string
  transactionId?: string
  lineItemId?: string
  authorizedAmount?: number
  finalAmount?: number
}
export type UpdateIntegrationRequest = {
  name?: string
  configuration?: {
    [key: string]: string
  }
}
export type UpdateIntegrationProviderRequest = {
  name?: string
  description?: string
  logoUrl?: string
  integrationKey?: string
  integrationType?:
    | 'PAYMENT_TERMINAL'
    | 'PAYMENT_WEB'
    | 'COMPLIANCE_REPORTING'
    | 'OPERATIONS'
    | 'PAYMENT_PROVIDERS'
    | 'VEHICLE_TELEMATICS'
    | 'ROAMING'
    | 'ENERGY_AGGREGATORS'
  configurationKeys?: {
    [key: string]: ConfigurationKey
  }
  status?: 'AVAILABLE' | 'COMING_SOON' | 'DEPRECATED'
  requiredGate?: string
  gateFailureBehavior?: 'HIDDEN' | 'COMING_SOON'
}
export type SparseIntegrationProvider = {
  id: string
  name: string
  description?: string
  logoUrl?: string
  integrationKey?: string
  integrationType:
    | 'PAYMENT_TERMINAL'
    | 'PAYMENT_WEB'
    | 'COMPLIANCE_REPORTING'
    | 'OPERATIONS'
    | 'PAYMENT_PROVIDERS'
    | 'VEHICLE_TELEMATICS'
    | 'ROAMING'
    | 'ENERGY_AGGREGATORS'
  configurationKeys?: {
    [key: string]: ConfigurationKey
  }
  status: 'AVAILABLE' | 'COMING_SOON' | 'DEPRECATED'
}
export type OrganizationIntegrationProvider = {
  id: string
  created: string
  createdBy: string
  lastModified: string
  lastModifiedBy: string
  status: 'READY_TO_CONNECT' | 'CONNECTED' | 'ACTION_REQUIRED' | 'DISCONNECTED' | 'CONTACT_SUPPORT'
  organization: OrganizationReference
  integrationProvider: SparseIntegrationProvider
}
export type SseRequestIdEvent = {
  /** Event type discriminator */
  type?: 'request_id'
  /** UUID identifying this analysis request */
  request_id: string
}
export type SseStatusUpdateEvent = {
  /** Event type discriminator */
  type?: 'status_update'
  /** Status message describing current progress */
  message: string
}
export type SseResponseStartEvent = {
  /** Event type discriminator */
  type?: 'response_start'
}
export type MarkdownBlock = {
  type?: 'markdown'
  /** Markdown-formatted text content */
  content: string
}
export type OcppLogStatement = {
  /** Sequential index of this log statement (0-based) */
  index: number
  /** Direction of the message */
  type: 'SENT' | 'RECEIVED'
  /** ISO 8601 timestamp of the log entry */
  timestamp: string
  /** Log statement content */
  statement: string | object
  /** OCPP message type */
  command:
    | (
        | 'Acknowledgement'
        | 'Authorize'
        | 'BootNotification'
        | 'DataTransfer'
        | 'DiagnosticsStatusNotification'
        | 'FirmwareStatusNotification'
        | 'Heartbeat'
        | 'MeterValues'
        | 'StartTransaction'
        | 'StatusNotification'
        | 'StopTransaction'
        | 'CancelReservation'
        | 'ChangeAvailability'
        | 'ChangeConfiguration'
        | 'ClearCache'
        | 'ClearChargingProfile'
        | 'GetCompositeSchedule'
        | 'GetConfiguration'
        | 'GetDiagnostics'
        | 'GetLocalListVersion'
        | 'RemoteStartTransaction'
        | 'RemoteStopTransaction'
        | 'ReserveNow'
        | 'Reset'
        | 'SendLocalList'
        | 'SetChargingProfile'
        | 'TriggerMessage'
        | 'UnlockConnector'
        | 'UpdateFirmware'
        | 'CertificateSigned'
        | 'DeleteCertificate'
        | 'ExtendedTriggerMessage'
        | 'GetInstalledCertificateIds'
        | 'GetLog'
        | 'InstallCertificate'
        | 'LogStatusNotification'
        | 'SecurityEventNotification'
        | 'SignCertificate'
        | 'SignedFirmwareStatusNotification'
        | 'SignedUpdateFirmware'
        | 'ClearDisplayMessage'
        | 'ClearedChargingLimit'
        | 'ClearVariableMonitoring'
        | 'CostUpdated'
        | 'CustomerInformation'
        | 'Get15118EVCertificate'
        | 'GetBaseReport'
        | 'GetCertificateStatus'
        | 'GetChargingProfiles'
        | 'GetDisplayMessages'
        | 'GetMonitoringReport'
        | 'GetReport'
        | 'GetTransactionStatus'
        | 'GetVariables'
        | 'NotifyChargingLimit'
        | 'NotifyCustomerInformation'
        | 'NotifyDisplayMessages'
        | 'NotifyEVChargingNeeds'
        | 'NotifyEVChargingSchedule'
        | 'NotifyEvent'
        | 'NotifyMonitoringReport'
        | 'NotifyReport'
        | 'PublishFirmware'
        | 'PublishFirmwareStatusNotification'
        | 'ReportChargingProfiles'
        | 'RequestStartTransaction'
        | 'RequestStopTransaction'
        | 'TransactionEvent'
        | 'ReservationStatusUpdate'
        | 'SetDisplayMessage'
        | 'SetMonitoringBase'
        | 'SetMonitoringLevel'
        | 'SetNetworkProfile'
        | 'SetVariableMonitoring'
        | 'SetVariables'
        | 'UnpublishFirmware'
      )
    | null
}
export type LogReferenceWithContent = {
  /** The index of the log statement being referenced */
  index: number
  /** Brief explanation of why this log is noteworthy or relevant to the summary */
  inclusion_rationale: string
  /** The actual log statement content */
  log_content: OcppLogStatement
}
export type LogReferencesBlockWithContent = {
  type?: 'log_references'
  /** Log references to display with content */
  items: LogReferenceWithContent[]
}
export type BriefSummaryBlock = {
  type?: 'brief_summary'
  /** The brief summary text */
  value: string
}
export type HealthCheckCategory =
  | 'heartbeats_connectivity'
  | 'request_response_matching'
  | 'faults_warnings'
  | 'charging_profile'
export type HealthCheckStatus = 'success' | 'warning' | 'informational'
export type HealthCheck = {
  /** The health check category */
  category: HealthCheckCategory
  /** Status of this health check (success, warning, informational) */
  status: HealthCheckStatus
  /** Brief summary of the health check result, e.g. '3 reconnection events detected' */
  summary: string
}
export type HealthCheckBlock = {
  type?: 'health_check'
  /** The health check result */
  value: HealthCheck
}
export type IssueSeverity = 'major' | 'minor' | 'informational'
export type IssueWithLogContent = {
  /** Short title for the issue */
  title: string
  /** Severity level (major, minor, informational) */
  severity: IssueSeverity
  /** Detailed description of the issue */
  description: string
  /** Log references that support this issue finding */
  supporting_logs: LogReferenceWithContent[]
}
export type IssueBlock = {
  type?: 'issue'
  /** The issue with full log content */
  value: IssueWithLogContent
}
export type ActionType = 'external' | 'internal'
export type Recommendation = {
  /** Description of the recommendation */
  text: string
  /** Whether the action is external (outside platform) or internal (inside platform) */
  action_type: ActionType
  /** The specific action to take, e.g. 'Reboot', 'SetConfig' */
  action: string
}
export type RecommendationsBlock = {
  type?: 'recommendations'
  /** List of recommendations */
  value: Recommendation[]
}
export type BlockDelta = {
  /** JSON path to the new content (e.g., ['blocks', 0, 'content']) */
  path: (string | number)[]
  /** The new value at the specified path */
  value:
    | MarkdownBlock
    | LogReferencesBlockWithContent
    | BriefSummaryBlock
    | HealthCheckBlock
    | IssueBlock
    | RecommendationsBlock
}
export type SseBlockDeltaEvent = {
  /** Event type discriminator */
  type?: 'object_delta'
  /** Sequence index of this delta in the stream */
  index: number
  /** Array of path/value changes in this update */
  delta: BlockDelta[]
}
export type SseResponseEndEvent = {
  /** Event type discriminator */
  type?: 'response_end'
}
export type SseErrorEvent = {
  /** Event type discriminator */
  type?: 'error'
  /** Error code identifying the type of error */
  code: string
  /** Human-readable error message */
  message: string
  /** Optional downstream HTTP status code when available (e.g., 403, 404, 500). */
  http_status?: number | null
}
export type SseDebugEvent = {
  /** Event type discriminator */
  type?: 'debug'
  /** Debug message describing the data */
  message: string
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
  ctx?: object
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type AnalysisFormat = 'markdown-narrative' | 'health-checks-and-issues'
export type LogAnalysisRequest = {
  /** The ID of the charger to analyze */
  charger_id: string
  /** Start of the log time range (ISO 8601) */
  start_timestamp: string
  /** End of the log time range (ISO 8601) */
  end_timestamp: string
  /** Custom prompt for LLM analysis */
  prompt?: string | null
  /** Optional model to use for analysis */
  model?: 'gpt-4o' | 'gpt-5.1' | 'gpt-5.5' | 'opus-4.5' | 'opus-4.7' | 'sonnet-4.5' | 'sonnet-4.6' | 'haiku-4.5'
  /** Analysis output format */
  format?: AnalysisFormat
  /** Include debug events in the response stream */
  verbose?: boolean
}
export type SubmitFeedbackResponse = {
  status?: 'created' | 'updated'
  /** UUID of the feedback record */
  feedback_id: string
}
export type CreateFeedbackRequest = {
  /** UUID of the analysis request */
  request_id: string
  /** True if user liked the response (thumbs up), False otherwise */
  approve: boolean
  /** Optional textual feedback from the user */
  feedback?: string | null
}
export type UpdateFeedbackRequest = {
  /** True if user liked the response (thumbs up), False otherwise */
  approve: boolean
  /** Optional textual feedback from the user */
  feedback?: string | null
}
export type DeleteFeedbackResponse = {
  status?: 'deleted'
}
export type SchemaVersionResponse = {
  alembic: string | null
}
export type SyncTariffsResponse = {
  productId?: string
  tariffIds?: string[]
  created?: number
  updated?: number
  error?: string
}
export type SyncTariffsRequest = {
  productIds: string[]
}
export type SyncLocationsResponse = {
  siteId?: string
  locationId?: string
  evsesCreated?: number
  evsesUpdated?: number
  evsesRemoved?: number
  connectorsSkipped?: number
  error?: string
}
export type SyncLocationsRequest = {
  siteIds: string[]
}
export type SyncIntegrationsResponse = {
  integrationId?: string
  credentialId?: string
  sitesSynced?: number
  sitesFailed?: number
  productsSynced?: number
  productsFailed?: number
  locationsClaimed?: number
  locationsGranted?: number
  locationsRestored?: number
  locationsWithdrawn?: number
  evsesGranted?: number
  evsesRestored?: number
  evsesWithdrawn?: number
  tariffsAttached?: number
  tariffsDetached?: number
  tariffObjectsGranted?: number
  tariffObjectsWithdrawn?: number
  locationsPushed?: number
  warnings?: string[]
  dryRun?: boolean
  skipped?: string
  error?: string
}
export type SyncIntegrationsRequest = {
  integrationIds: string[]
  dryRun?: boolean
}
export type SendResponse = {
  queued?: number
  notSent?: string[]
}
export type Party = {
  countryCode: string
  partyId: string
}
export type SendRequest = {
  ids: string[]
  parties: Party[]
}
export type AuthorizationResult = {
  mode?:
    | 'ACCEPTED'
    | 'BLOCKED'
    | 'EXPIRED'
    | 'INVALID'
    | 'CONCURRENT_TX'
    | 'NO_CREDIT'
    | 'NOT_ALLOWED_TYPE_EVSE'
    | 'NOT_AT_THIS_LOCATION'
    | 'NOT_AT_THIS_TIME'
    | 'UNKNOWN'
  start?: string
  expiry?: string
  allowedConnectors?: number[]
}
export type DeleteUnusedTariffsResponse = {
  credentialId?: string
  unusedTariffIds?: string[]
  withdrawn?: number
  dryRun?: boolean
  error?: string
}
export type DeleteUnusedTariffsRequest = {
  credentialIds: string[]
  dryRun?: boolean
}
export type OcpiPartyRole = {
  countryCode: string
  partyId: string
  role: 'CPO' | 'EMSP' | 'HUB' | 'NAP' | 'NSP' | 'OTHER' | 'SCSP'
}
export type InternalCredentials = {
  id?: string
  status?: 'TEMPORARY' | 'PENDING' | 'VALID' | 'SUSPENDED' | 'REVOKED'
  token?: string
  localParty?: OcpiPartyRole
  integrationKey?: string
  organizationId?: string
  shared?: boolean
}
export type CreateCredentialsRequest = {
  localParty?: OcpiPartyRole
}
export type CreateCredentialsRequestWrite = {
  integrationKey?: string
  localParty?: OcpiPartyRole
  shared?: boolean
  tokenA?: string
  versionsUrl?: string
}
export type ExchangeCredentialsRequest = CreateCredentialsRequest & {
  integrationKey?: string
  localParty: OcpiPartyRole
  shared?: boolean
  tokenA: string
  versionsUrl?: string
}
export type ExchangeCredentialsRequestWrite = CreateCredentialsRequestWrite & {
  integrationKey?: string
  localParty: OcpiPartyRole
  shared?: boolean
  tokenA: string
  versionsUrl?: string
}
export type GenerateTokenRequest = CreateCredentialsRequest & {
  integrationKey?: string
  localParty: OcpiPartyRole
  shared?: boolean
}
export type GenerateTokenRequestWrite = CreateCredentialsRequestWrite & {
  integrationKey?: string
  localParty: OcpiPartyRole
  shared?: boolean
}
export type CdrToken1 = {
  /** ISO-3166 alpha-2 country code of the MSP that owns this Token */
  country_code: string
  /** ID of the eMSP that owns this Token (following the ISO-15118 standard) */
  party_id: string
  /** Unique ID by which this Token can be identified */
  uid: string
  /** Type of the token */
  type: 'AD_HOC_USER' | 'APP_USER' | 'OTHER' | 'RFID' | 'VID'
  /** Uniquely identifies the EV driver contract token within the eMSP's platform */
  contract_id: string
}
export type CdrDimension1 = {
  /** Type of CDR dimension */
  type:
    | 'ENERGY'
    | 'FLAT'
    | 'PARKING_TIME'
    | 'TIME'
    | 'MAX_CURRENT'
    | 'MIN_CURRENT'
    | 'MAX_POWER'
    | 'MIN_POWER'
    | 'RESERVATION_TIME'
    | 'CURRENT'
    | 'ENERGY_EXPORT'
    | 'ENERGY_IMPORT'
    | 'POWER'
    | 'STATE_OF_CHARGE'
  /** Volume of the dimension consumed, measured according to the dimension type */
  volume: number
}
export type ChargingPeriod1 = {
  /** Start timestamp of the charging period. A period ends when the next period starts. The last period ends when the session ends. */
  start_date_time: string
  /** List of relevant values for this charging period */
  dimensions: CdrDimension1[]
  /** Unique identifier of the Tariff that is relevant for this Charging Period. If not provided, no Tariff is relevant during this period */
  tariff_id?: string
}
export type Price2 = {
  /** Price/Cost excluding VAT in cents */
  excl_vat: number
  /** Price/Cost including VAT in cents */
  incl_vat?: number
}
export type Session = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object */
  country_code: string
  /** ID of the CPO that 'owns' this object (following the ISO-15118 standard) */
  party_id: string
  /** The unique id that identifies the session in the CPO/eMSP platform */
  id: string
  /** The timestamp when the session became ACTIVE in the Charge Point */
  start_date_time: string
  /** The timestamp when the session was completed/finished */
  end_date_time?: string
  /** How many kWh were charged */
  kwh: number
  /** Token used to start this charging session */
  cdr_token: CdrToken1
  /** Method used for authentication */
  auth_method: 'AUTH_REQUEST' | 'COMMAND' | 'WHITELIST'
  /** Reference to the authorization given by the eMSP */
  authorization_reference?: string
  /** Location.id of the Location object where the charging session is/was happening */
  location_id: string
  /** EVSE.uid of the EVSE where the charging session is/was happening */
  evse_uid: string
  /** Connector.id of the Connector where the charging session is/was happening */
  connector_id: string
  /** Optional identification of the kWh meter */
  meter_id?: string
  /** ISO 4217 code of the currency used for this session */
  currency: string
  /** List of Charging Periods that can be used to calculate and verify the total cost */
  charging_periods?: ChargingPeriod1[]
  /** The total cost of the session in the specified currency */
  total_cost?: Price2
  /** The status of the session */
  status: 'ACTIVE' | 'COMPLETED' | 'INVALID' | 'PENDING' | 'RESERVATION'
  /** Timestamp when this object was last updated (or created) */
  last_updated: string
}
export type PagedResultSession = {
  items?: Session[]
  offset?: number
  limit?: number
  total?: number
}
export type GeoLocation1 = {
  /** Latitude of the point in decimal degree. The geodetic system to be used is WGS 84 */
  latitude: string
  /** Longitude of the point in decimal degree. The geodetic system to be used is WGS 84 */
  longitude: string
}
export type CdrLocation1 = {
  /** Unique identifier for the location within the CPO's platform */
  id: string
  /** Display name of the location */
  name?: string
  /** Street/block name and house number */
  address: string
  /** City or town */
  city: string
  /** Postal code of the location, may be omitted for locations without postal codes */
  postal_code?: string
  /** State or province (when relevant) */
  state?: string
  /** ISO 3166-1 alpha-3 country code */
  country: string
  /** Geographic coordinates of the location */
  coordinates: GeoLocation1
  /** Unique identifier for the EVSE within the CPO's platform */
  evse_uid: string
  /** eMI3 compliant EVSE ID */
  evse_id: string
  /** Identifier of the connector within the EVSE */
  connector_id: string
  /** The standard of the installed connector */
  connector_standard:
    | 'CHADEMO'
    | 'CHAOJI'
    | 'DOMESTIC_A'
    | 'DOMESTIC_B'
    | 'DOMESTIC_C'
    | 'DOMESTIC_D'
    | 'DOMESTIC_E'
    | 'DOMESTIC_F'
    | 'DOMESTIC_G'
    | 'DOMESTIC_H'
    | 'DOMESTIC_I'
    | 'DOMESTIC_J'
    | 'DOMESTIC_K'
    | 'DOMESTIC_L'
    | 'DOMESTIC_M'
    | 'DOMESTIC_N'
    | 'DOMESTIC_O'
    | 'GBT_AC'
    | 'GBT_DC'
    | 'IEC_60309_2_single_16'
    | 'IEC_60309_2_three_16'
    | 'IEC_60309_2_three_32'
    | 'IEC_60309_2_three_64'
    | 'IEC_62196_T1'
    | 'IEC_62196_T1_COMBO'
    | 'IEC_62196_T2'
    | 'IEC_62196_T2_COMBO'
    | 'IEC_62196_T3A'
    | 'IEC_62196_T3C'
    | 'NEMA_5_20'
    | 'NEMA_6_30'
    | 'NEMA_6_50'
    | 'NEMA_10_30'
    | 'NEMA_10_50'
    | 'NEMA_14_30'
    | 'NEMA_14_50'
    | 'PANTOGRAPH_BOTTOM_UP'
    | 'PANTOGRAPH_TOP_DOWN'
    | 'TESLA_R'
    | 'TESLA_S'
  /** The format (socket/cable) of the installed connector */
  connector_format: 'SOCKET' | 'CABLE'
  /** Power type of the connector */
  connector_power_type: 'AC_1_PHASE' | 'AC_2_PHASE' | 'AC_2_PHASE_SPLIT' | 'AC_3_PHASE' | 'DC'
}
export type DisplayText1 = {
  /** Language Code ISO 639-1 */
  language: string
  /** Text to be displayed to end user. No markup, html etc. allowed */
  text: string
}
export type PriceComponent1 = {
  /** Type of tariff dimension (e.g., TIME, ENERGY, PARKING_TIME) */
  type: 'ENERGY' | 'FLAT' | 'PARKING_TIME' | 'TIME'
  /** Price per unit (excluding VAT) for this price component */
  price: number
  /** VAT amount per unit for this tariff dimension */
  vat?: number
  /** Minimum amount to be billed in blocks. Amounts less than this are rounded up to the next block */
  step_size?: number
}
export type TariffRestrictions1 = {
  /** Start time of day in local time (24h format with leading zeros, e.g., 13:30) */
  start_time?: string
  /** End time of day in local time (24h format with leading zeros, e.g., 19:45). If less than start_time, wraps to next day */
  end_time?: string
  /** Start date in local time (YYYY-MM-DD format), valid from this day (inclusive) */
  start_date?: string
  /** End date in local time (YYYY-MM-DD format), valid until this day (exclusive) */
  end_date?: string
  /** Minimum consumed energy in kWh, valid from this amount (inclusive) */
  min_kwh?: number
  /** Maximum consumed energy in kWh, valid until this amount (exclusive) */
  max_kwh?: number
  /** Minimum current in Amperes over all phases. Tariff element becomes active when charging current is above this value */
  min_current?: number
  /** Maximum current in Amperes over all phases. Tariff element becomes active when charging current is below this value */
  max_current?: number
  /** Minimum power in kW. Tariff element becomes active when charging power is above this value */
  min_power?: number
  /** Maximum power in kW. Tariff element becomes active when charging power is below this value */
  max_power?: number
  /** Minimum duration in seconds, valid from this duration (inclusive) */
  min_duration?: number
  /** Maximum duration in seconds, valid until this duration (exclusive) */
  max_duration?: number
  /** Days of the week for which this tariff element is valid. If not specified, valid for all days */
  day_of_week?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Type of reservation restriction that applies to this tariff element */
  reservation?: 'RESERVATION' | 'RESERVATION_EXPIRES'
}
export type TariffElement1 = {
  /** List of price components that describe the pricing of a tariff */
  price_components: PriceComponent1[]
  /** Restrictions that describe the applicability of a tariff */
  restrictions?: TariffRestrictions1
}
export type EnergySource1 = {
  /** The type of energy source */
  source: 'NUCLEAR' | 'GENERAL_FOSSIL' | 'COAL' | 'GAS' | 'GENERAL_GREEN' | 'SOLAR' | 'WIND' | 'WATER'
  /** Percentage of this source (0-100) in the mix */
  percentage: number
}
export type EnvironmentalImpact1 = {
  /** The environmental impact category of this value */
  category: 'NUCLEAR_WASTE' | 'CARBON_DIOXIDE'
  /** Amount of this portion in g/kWh */
  amount: number
}
export type EnergyMix1 = {
  /** True if 100% from regenerative sources. (CO2 and nuclear waste is zero) */
  is_green_energy: boolean
  /** Key-value pairs (enum + percentage) of energy sources of this location's tariff */
  energy_sources?: EnergySource1[]
  /** Key-value pairs (enum + percentage) of nuclear waste and CO2 exhaust of this location's tariff */
  environ_impact?: EnvironmentalImpact1[]
  /** Name of the energy supplier, delivering the energy for this location or tariff */
  supplier_name?: string
  /** Name of the energy suppliers product/tariff plan used at this location */
  energy_product_name?: string
}
export type Tariff1 = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object */
  country_code: string
  /** ID of the CPO that 'owns' this object (following the ISO-15118 standard) */
  party_id: string
  /** The unique id that identifies the tariff in the CPO/eMSP platform */
  id: string
  /** ISO-4217 code of the currency of this tariff */
  currency: string
  /** Defines the type of the tariff. This allows for distinction in case of given Charging Preferences. When omitted, this tariff is valid for all sessions */
  type?: 'AD_HOC_PAYMENT' | 'PROFILE_CHEAP' | 'PROFILE_FAST' | 'REGULAR' | 'PROFILE_GREEN'
  /** List of multi-language alternative tariff info texts */
  tariff_alt_text?: DisplayText1[]
  /** URL to alternative tariff information */
  tariff_alt_url?: string
  /** Minimum price for a charging session with this tariff. When set, if the calculated cost is lower than this amount, the session will cost this amount */
  min_price?: Price2
  /** Maximum price for a charging session with this tariff. When set, the session will not cost more than this amount */
  max_price?: Price2
  /** List of tariff elements that define the pricing components */
  elements: TariffElement1[]
  /** The timestamp when the tariff becomes active */
  start_date_time?: string
  /** The timestamp when the tariff becomes inactive */
  end_date_time?: string
  /** Details on the energy supplied with this tariff */
  energy_mix?: EnergyMix1
  /** Timestamp when this object was last updated (or created) */
  last_updated: string
}
export type SignedValue1 = {
  /** Nature of the value (Start, End, Intermediate) */
  nature: string
  /** The un-encoded string of data. Format depends on the EncodingMethod */
  plain_data: string
  /** Blob of signed data, base64 encoded. Format depends on the EncodingMethod */
  signed_data: string
}
export type SignedData1 = {
  /** The name of the encoding used in the SignedData field */
  encoding_method: string
  /** Version of the EncodingMethod */
  encoding_method_version?: number
  /** Public key used to sign the data, base64 encoded */
  public_key?: string
  /** One or more signed values */
  signed_values: SignedValue1[]
  /** URL that can be shown to an EV driver to check the signed data from a charging session */
  url?: string
}
export type Cdr = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object */
  country_code: string
  /** ID of the CPO that 'owns' this object (following the ISO-15118 standard) */
  party_id: string
  /** Uniquely identifies the CDR within the CPO's platform */
  id: string
  /** Start timestamp of the charging session or reservation */
  start_date_time: string
  /** End timestamp of the charging session */
  end_date_time: string
  /** Unique ID of the Session for which this CDR is sent */
  session_id?: string
  /** Token used to start this charging session */
  cdr_token: CdrToken1
  /** Method used for authentication during the charging session */
  auth_method: 'AUTH_REQUEST' | 'COMMAND' | 'WHITELIST'
  /** Reference to the authorization given by the eMSP */
  authorization_reference?: string
  /** Location where the charging session took place */
  cdr_location: CdrLocation1
  /** Identification of the Meter inside the Charge Point */
  meter_id?: string
  /** Currency of the CDR in ISO 4217 Code */
  currency: string
  /** List of relevant Tariff Elements */
  tariffs?: Tariff1[]
  /** List of Charging Periods that make up this charging session */
  charging_periods: ChargingPeriod1[]
  /** Signed data that belongs to this charging Session */
  signed_data?: SignedData1
  /** Total sum of all the costs of this transaction in the specified currency */
  total_cost: Price2
  /** Total sum of all the fixed costs in the specified currency */
  total_fixed_cost?: Price2
  /** Total energy charged, in kWh */
  total_energy: number
  /** Total sum of all the cost of all the energy used, in the specified currency */
  total_energy_cost?: Price2
  /** Total duration of the charging session in hours */
  total_time: number
  /** Total sum of all the cost related to duration of charging, in the specified currency */
  total_time_cost?: Price2
  /** Total duration of the charging session where the EV was not charging, in hours */
  total_parking_time?: number
  /** Total sum of all the cost related to parking, including fixed price components, in the specified currency */
  total_parking_cost?: Price2
  /** Total sum of all the cost related to a reservation, including fixed price components, in the specified currency */
  total_reservation_cost?: Price2
  /** Optional remark providing additional human-readable information */
  remark?: string
  /** Reference to an invoice that will be sent for this CDR */
  invoice_reference_id?: string
  /** Indicates if this CDR is a credit note */
  credit?: boolean
  /** Reference to the credit note CDR when this CDR is a credit note */
  credit_reference_id?: string
  /** Indicates if this CDR is for home charging compensation */
  home_charging_compensation?: boolean
  /** Timestamp when this object was last updated (or created) */
  last_updated: string
}
export type PagedResultCdr = {
  items?: Cdr[]
  offset?: number
  limit?: number
  total?: number
}
export type OcpiParty = {
  countryCode: string
  partyId: string
}
export type HttpRequest = {
  method?: string
  url?: string
  headers?: {
    [key: string]: string[]
  }
  body?: string
}
export type HttpResponse = {
  statusCode?: number
  headers?: {
    [key: string]: string[]
  }
  body?: string
}
export type OcpiRequestLog = {
  credentialId?: string
  requestId?: string
  ocpiRequestId?: string
  ocpiCorrelationId?: string
  module?:
    | 'cdrs'
    | 'chargingprofiles'
    | 'commands'
    | 'credentials'
    | 'hubclientinfo'
    | 'locations'
    | 'sessions'
    | 'tariffs'
    | 'tokens'
  direction?: 'INBOUND' | 'OUTBOUND'
  fromParty?: OcpiParty
  toParty?: OcpiParty
  request?: HttpRequest
  response?: HttpResponse
  error?: string
  timestamp?: string
}
export type PagedResultOcpiRequestLog = {
  items?: OcpiRequestLog[]
  offset?: number
  limit?: number
  total?: number
}
export type AuthorizationCredential = {
  id?: string
  integrationKey?: string
  organizationId?: string
}
export type LocationReferences = {
  /** Unique identifier for the location. */
  location_id: string
  /** Unique identifiers for EVSEs within the CPO’s platform for the EVSE within the
    given location. */
  evse_uids?: string[]
}
export type EnergyContract = {
  /** Name of the energy supplier for this token */
  supplier_name: string
  /** Contract ID at the energy supplier that belongs to the owner of this token */
  contract_id?: string
}
export type Token = {
  /** ISO-3166 alpha-2 country code of the MSP that owns this Token */
  country_code: string
  /** ID of the eMSP that owns this Token (following the ISO-15118 standard) */
  party_id: string
  /** Unique ID by which this Token can be identified. For RFID tokens, this is typically the RFID hidden ID */
  uid: string
  /** Type of the token */
  type: 'AD_HOC_USER' | 'APP_USER' | 'OTHER' | 'RFID' | 'VID'
  /** Uniquely identifies the EV driver contract token within the eMSP's platform */
  contract_id: string
  /** Visual readable number/identification as printed on the Token (RFID card) */
  visual_number?: string
  /** Issuing company, typically the name printed on the token (RFID card) */
  issuer: string
  /** ID that groups multiple tokens together, allowing them to work as one (e.g., card and key-fob) */
  group_id?: string
  /** Indicates whether this Token is valid */
  valid: boolean
  /** Indicates what type of white-listing is allowed */
  whitelist: 'ALWAYS' | 'ALLOWED' | 'ALLOWED_OFFLINE' | 'NEVER'
  /** Language Code ISO 639-1 indicating the Token owner's preferred interface language */
  language?: string
  /** The default Charging Preference for smart charging sessions */
  default_profile_type?: 'CHEAP' | 'FAST' | 'GREEN' | 'REGULAR'
  /** Information about the energy supplier/contract when using own energy at a Charge Point */
  energy_contract?: EnergyContract
  /** Timestamp when this Token was last updated (or created) */
  last_updated: string
}
export type AuthorizationInfo = {
  /** Status of the Token, and whether charging is allowed at the optionally given location. */
  allowed: 'ALLOWED' | 'BLOCKED' | 'EXPIRED' | 'NO_CREDIT' | 'NOT_ALLOWED'
  /** The complete Token object for which this authorization was requested. */
  token: Token
  /** Optional reference to the location if it was included in the request, and if the EV driver is allowed to charge at that location. Only the EVSEs the EV driver is allowed to charge at are returned. */
  location?: LocationReferences
  /** Reference to the authorization given by the eMSP, when given, this reference will be provided in the relevant Session and/or CDR. */
  authorization_reference?: string
  /** Optional display text, additional information to the EV driver. */
  info?: DisplayText1
}
export type AuthRequest = {
  request?: LocationReferences
  response?: AuthorizationInfo
}
export type StartSession = {
  /** URL that the CommandResult POST should be sent to. This URL might contain unique ID to be able to distinguish between ReserveNow requests */
  response_url: string
  /** Token object the Charge Point has to use to start a new session. The Token provided in this request is authorized by the eMSP */
  token: Token
  /** Location.id of the Location (belonging to the CPO this request is sent to) on which a session is to be started */
  location_id: string
  /** Optional EVSE.uid of the EVSE of this Location on which a session is to be started. Required when connector_id is set */
  evse_uid?: string
  /** Optional Connector.id of the Connector of the EVSE on which a session is to be started. This field is required when the capability: START_SESSION_CONNECTOR_REQUIRED is set on the EVSE */
  connector_id?: string
  /** Reference to the authorization given by the eMSP, when given, this reference will be provided in the relevant Session and/or CDR */
  authorization_reference?: string
}
export type Command = {
  command?: StartSession
}
export type Evidence = AuthRequest | Command
export type AuthorizationDecision = {
  id?: string
  decidedAt?: string
  /** When the grant stops being good: decided_at plus the authorization window it was given */
  expiresAt?: string
  idTag?: string
  /** The OCPP charge box the tag was presented at */
  chargerId?: string
  /** The OCPP connector; set only by a remote start, which is the only branch that knows one */
  connectorId?: string
  locationId?: string
  evseUid?: string
  /** Method used for authentication. Multiple AuthMethods are possible during a charging session. */
  authMethod?: 'AUTH_REQUEST' | 'COMMAND' | 'WHITELIST'
  /** What the OCPP gateway was answered, a refusal included */
  gatewayResponse?:
    | 'ACCEPTED'
    | 'BLOCKED'
    | 'EXPIRED'
    | 'INVALID'
    | 'CONCURRENT_TX'
    | 'NO_CREDIT'
    | 'NOT_ALLOWED_TYPE_EVSE'
    | 'NOT_AT_THIS_LOCATION'
    | 'NOT_AT_THIS_TIME'
    | 'UNKNOWN'
  /** The first session that resolved this grant; null until one did */
  sessionId?: string
  /** The token identity frozen at decision time, as the session and CDR report it */
  token?: CdrToken1
  authorizationReference?: string
  /** The credential the decision was made through; null once it is unregistered */
  credential?: AuthorizationCredential
  /** What the decision was made from. Always null in a listing - fetch the decision by id for it. On a lookup it follows auth_method: AUTH_REQUEST carries the request and response exchanged with the eMSP, COMMAND carries the remote start, and WHITELIST carries nothing, because it asked nobody. */
  evidence?: Evidence
}
export type PagedResultAuthorizationDecision = {
  items?: AuthorizationDecision[]
  offset?: number
  limit?: number
  total?: number
}
export type RoundRobinConfig = {
  /** Whether round robin charging is enabled for this time period */
  enabled?: boolean
  /** Initial target state of charge (SoC) before starting round robin */
  initialTargetSoc?: number
  /** Maximum state of charge (SoC) to reach through round robin */
  maxSoc?: number
  /** Step size to increment each charger's target SoC during round robin */
  socStepSize?: number
  /** Charging priority strategy for virtual charger groups */
  postInitialTargetPriority?: 'NO_ACTION' | 'HARD_CODED' | 'LIFO' | 'FIFO' | 'AUTOPILOT' | 'LOWEST_SOC'
}
export type BatteryTimeTuple = {
  /** Target end time for this configuration */
  time: string
  /** Target battery percentage for this time period. Optional when round robin is enabled. */
  batteryPercentage?: number
  roundRobinConfig?: RoundRobinConfig
  /** Whether to stretch charging to reach target by the specified time */
  stretch?: boolean
}
export type ConnectorSessionState = {
  /** OCPP connector status (Available, Preparing, Charging, Finishing, …) */
  status?: string
  /** Last known SoC percentage for this connector's session */
  lastKnownSoc?: number
  /** Last known active power import for this connector (kW) */
  lastPowerImport?: number
  /** Last known active power export for this connector (kW) */
  lastPowerExport?: number
  /** Last known import current for this connector (A) */
  lastCurrent?: number
  /** Last known voltage for this connector (V) */
  lastVoltage?: number
  /** Synop charging transaction id for this connector's active session */
  transactionId?: string
  /** OCPP ID tag for this connector's session */
  authTag?: string
  /** When this connector was queued for orchestration (FIFO / LIFO ordering per connector) */
  queuedAt?: string
}
export type ChargerState = {
  /** Per-OCPP-connector session state (SoC, transaction id) when the charger supports multiple connectors */
  connectorSessions?: {
    [key: string]: ConnectorSessionState
  }
  /** Current status of the charger (e.g., Available, Preparing, Charging, Finishing) */
  status?: string
  /** Last known SoC (State of Charge) of the charger as a percentage */
  lastKnownSoc?: number
  /** Current transaction ID if charging */
  transactionId?: string
  /** OCPP ID tag used for authorization */
  authTag?: string
  /** Size of the connected battery in kWh */
  connectedBatterySizeKwh?: number
  /** When this charger was added to the queue */
  queuedAt?: string
  /** Number of charging cycles completed */
  roundRobinCycles?: number
  /** Whether this charger is part of the current round-robin cycle */
  inRoundRobin?: boolean
  /** Number of remote start attempts for this charger */
  remoteStartAttempts?: number
  /** Whether remote start attempts are currently paused */
  remoteStartPause?: boolean
  /** Sum of lastPowerImport (kW) across connectors in Charging state; null if none */
  lastPowerImport?: number
  /** Sum of lastPowerExport (kW) across connectors in Charging state; null if none */
  lastPowerExport?: number
  /** Sum of lastCurrent (A) across connectors in Charging state; null if none */
  lastCurrentSum?: number
  /** Max of lastVoltage (V) across connectors in Charging state; null if none */
  lastVoltageMax?: number
  /** Timestamp of the last state update */
  lastUpdate?: string
  /** Timestamp of the last state change */
  lastStateUpdate?: string
}
export type VirtualChargerGroup = {
  /** Unique identifier for the virtual charger group */
  virtualChargerId: string
  /** User-friendly name for the virtual charger group */
  name?: string
  /** Organization ID that owns this virtual charger group */
  organizationId?: string
  /** Site identifier where this group is located */
  siteId?: string
  /** List of physical charger IDs bound to this group */
  boundChargerIds?: string[]
  /** Maximum state of charge (SoC) limit as a percentage */
  socLimit?: number
  /** Time-based SoC limits and configurations */
  socTimeBindings?: BatteryTimeTuple[]
  /** Current state of each charger in the group */
  chargerStates?: {
    [key: string]: ChargerState
  }
  /** Timestamp of the last update to this group */
  lastUpdate?: string
  /** Timestamp of the last start/stop operation */
  lastOperationTimestamp?: string
  /** Days of the week when this group is active */
  daysOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Timezone for evaluating time-bound SOC rules (e.g., 'America/New_York') */
  timezone?: string
  /** If true, power will curtail as SoC approaches 100% */
  keepAlive?: boolean
  /** Charging priority strategy for virtual charger groups */
  priority?: 'NO_ACTION' | 'HARD_CODED' | 'LIFO' | 'FIFO' | 'AUTOPILOT' | 'LOWEST_SOC'
  /** Type of orchestration for virtual charger groups */
  orchestrationType?: 'POWER_ELECTRONICS' | 'KEMPOWER' | 'HITACHI' | 'INCHARGE'
  /** Whether this virtual charger group is currently active */
  active?: boolean
  /** Ordered queue of charger–connector slots (chargerId#connectorId) waiting to charge */
  chargerQueue?: string[]
  /** Timestamp when this group was created */
  createdAt?: string
  /** User ID who created this group */
  createdBy?: string
  /** Instance ID that acquired the lock for orchestration processing (internal use) */
  lockedByInstanceId?: string
  /** Timestamp when the lock was acquired for orchestration processing (internal use) */
  lockedAt?: string
  /** Partition key for LockedVirtualChargerIndex GSI. Set to LOCKED when locked. */
  lockedPartition?: string
  nextCharger?: string
}
export type VirtualChargerGroupUpdateParams = {
  /** User-friendly name for the virtual charger group */
  name?: string
  /** List of physical charger IDs to bind to this group */
  chargerIds?: string[]
  /** Charging priority strategy for virtual charger groups */
  priority?: 'NO_ACTION' | 'HARD_CODED' | 'LIFO' | 'FIFO' | 'AUTOPILOT' | 'LOWEST_SOC'
  /** Type of orchestration for virtual charger groups */
  orchestrationType?: 'POWER_ELECTRONICS' | 'KEMPOWER' | 'HITACHI' | 'INCHARGE'
  /** Maximum state of charge (SoC) limit as a percentage (0-100) */
  socLimit?: number
  /** Time-based SoC limits and configurations for time-bound charging rules */
  socTimeBindings?: BatteryTimeTuple[]
  /** Days of the week when this group is active */
  daysOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Timezone for evaluating time-bound SOC rules (IANA timezone ID) */
  timezone?: string
  /** If true, power will curtail as SoC approaches 100% */
  keepAlive?: boolean
  /** Whether this virtual charger group is currently active */
  active?: boolean
}
export type AssistantContextRef = {
  type?: string
  id?: string
  label?: string
  name?: string
  make?: string
  model?: string
}
export type AssistantSkill = {
  id?: string
  builtin?: boolean
  shareScope?: string
  name?: string
  description?: string
  instructions?: string
  category?: string
  toolNames?: string[]
  defaultContextRefs?: AssistantContextRef[]
  defaultAutoApprove?: boolean
  sourceConversationId?: string
  createdByUserId?: string
  createdAt?: string
  updatedAt?: string
}
export type AssistantSkillUpdateParams = {
  name?: string
  description?: string
  instructions?: string
  shareScope?: string
  category?: string
  toolNames?: string[]
  defaultContextRefs?: AssistantContextRef[]
  defaultAutoApprove?: boolean
}
export type AssistantSkillSchedule = {
  id?: string
  organizationId?: string
  userId?: string
  skillId?: string
  skillName?: string
  name?: string
  enabled?: boolean
  cronExpression?: string
  timezone?: string
  contextRefs?: AssistantContextRef[]
  messageOverride?: string
  autoApprove?: boolean
  requiresMutatingApproval?: boolean
  nextRunAt?: string
  lastRunAt?: string
  lastRunStatus?: string
  createdAt?: string
  updatedAt?: string
}
export type AssistantSkillScheduleUpdateParams = {
  name?: string
  cronExpression?: string
  timezone?: string
  contextRefs?: AssistantContextRef[]
  messageOverride?: string
  autoApprove?: boolean
  enabled?: boolean
}
export type VirtualChargerGroupCreateParams = {
  /** User-friendly name for the virtual charger group */
  name?: string
  /** Site identifier for the virtual charger group */
  siteId?: string
  /** List of physical charger IDs to bind to this group */
  chargerIds: string[]
  /** Charging priority strategy for virtual charger groups */
  priority?: 'NO_ACTION' | 'HARD_CODED' | 'LIFO' | 'FIFO' | 'AUTOPILOT' | 'LOWEST_SOC'
  /** Type of orchestration for virtual charger groups */
  orchestrationType?: 'POWER_ELECTRONICS' | 'KEMPOWER' | 'HITACHI' | 'INCHARGE'
  /** Maximum state of charge (SoC) limit as a percentage (0-100) */
  socLimit?: number
  /** Time-based SoC limits and configurations for time-bound charging rules */
  socTimeBindings?: BatteryTimeTuple[]
  /** Days of the week when this group is active. If null, the group is active every day. */
  daysOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Timezone for evaluating time-bound SOC rules (IANA timezone ID) */
  timezone?: string
  /** If true, power will curtail as SoC approaches 100% */
  keepAlive?: boolean
}
export type GroupPreview = {
  /** Group identifier extracted from charger names */
  groupKey?: string
  /** Charger IDs that would be in this group */
  chargerIds?: string[]
  /** Charger names in this group */
  chargerNames?: string[]
}
export type BulkCreateResult = {
  /** Whether this was a dry run (no groups actually created) */
  dryRun?: boolean
  /** Total number of chargers found at the site */
  totalChargers?: number
  /** Number of chargers matching the prefix */
  matchingChargers?: number
  /** Number of chargers that were skipped (already bound to a group) */
  skippedChargers?: number
  /** Number of groups created (or would be created in dry run) */
  groupsCreated?: number
  /** Groups that were created, keyed by group identifier (e.g., '9' for MONTGOMERY-MD-SG-9*) */
  groupPreviews?: {
    [key: string]: GroupPreview
  }
  /** The actual created groups (empty for dry run) */
  createdGroups?: VirtualChargerGroup[]
  /** Charger IDs that didn't match the prefix */
  unmatchedChargers?: string[]
  /** Charger IDs that were skipped because they're already bound */
  alreadyBoundChargers?: string[]
}
export type BulkCreateParams = {
  /** Site/depot ID to fetch chargers from */
  siteId: string
  /** Prefix to match charger names against. Chargers are grouped by the number following the prefix. For example, with prefix 'MONTGOMERY-MD-SG-', chargers 'MONTGOMERY-MD-SG-9A', 'MONTGOMERY-MD-SG-9B' would be grouped together as group '9'. */
  prefix: string
  /** SOC limit to apply to all created groups */
  socLimit?: number
  /** Time-based SOC configurations to apply to all groups */
  socTimeBindings?: BatteryTimeTuple[]
  /** Days of the week when groups should be active */
  daysOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Timezone for evaluating time-bound rules (IANA timezone ID) */
  timezone?: string
  /** Charging priority strategy for virtual charger groups */
  priority?: 'NO_ACTION' | 'HARD_CODED' | 'LIFO' | 'FIFO' | 'AUTOPILOT' | 'LOWEST_SOC'
  /** Type of orchestration for virtual charger groups */
  orchestrationType?: 'POWER_ELECTRONICS' | 'KEMPOWER' | 'HITACHI' | 'INCHARGE'
  /** Keep-alive setting for all groups */
  keepAlive?: boolean
  /** If true, performs a dry run without creating any groups. Returns what would be created. */
  dryRun?: boolean
}
export type JsonNode = object
export type GenerativeDashboardSave = {
  id?: string
  title?: string
  spec?: JsonNode
  createdAt?: string
  updatedAt?: string
}
export type GenerativeDashboardSaveList = {
  saves?: GenerativeDashboardSave[]
  hasMore?: boolean
  nextCursor?: string
}
export type GenerativeDashboardSaveCreateParams = {
  title: string
  spec?: JsonNode
}
export type GenerativeDashboardRefreshParams = {
  tiles: JsonNode
}
export type FirmwareVersion = {
  /** Unique firmware version identifier */
  id: string
  /** Charger OEM / manufacturer name the image applies to */
  vendor?: string
  /** Charger model name the image applies to */
  model?: string
  /** Optional chargers-api make/model catalog id for exact matching */
  makeModelId?: string
  /** Firmware version string reported by the station after install (e.g. v4.13.0) */
  version?: string
  /** Original file name of the uploaded binary */
  fileName?: string
  /** MIME type recorded at upload time */
  contentType?: string
  /** Binary size in bytes; null until the upload is confirmed */
  sizeBytes?: number
  /** Upload lifecycle status */
  status?: 'PENDING_UPLOAD' | 'AVAILABLE'
  /** Free-text operator notes */
  notes?: string
  createdAt?: string
  createdBy?: string
  updatedAt?: string
}
export type CursorLinks = {
  current?: string
  next?: string
  prev?: string
}
export type CursorMeta = {
  total?: number
  pageSize?: number
  last?: boolean
}
export type CursorPagedListFirmwareVersion = {
  data?: FirmwareVersion[]
  links?: CursorLinks
  meta?: CursorMeta
}
export type FirmwareVersionUpload = {
  firmwareVersion?: FirmwareVersion
  /** Presigned S3 PUT URL. Upload the binary here, then call complete-upload. */
  uploadUrl?: string
}
export type FirmwareVersionCreateParams = {
  /** Charger OEM / manufacturer name the image applies to (e.g. EVBox) */
  vendor: string
  /** Charger model name the image applies to (e.g. Elvi) */
  model: string
  /** Optional chargers-api make/model catalog id for exact matching */
  makeModelId?: string
  /** Firmware version string reported by the station after install (e.g. v4.13.0) */
  version: string
  /** File name of the binary to upload */
  fileName: string
  /** MIME type of the binary. Defaults to application/octet-stream. */
  contentType?: string
  /** Free-text operator notes (release notes link, known issues, ...) */
  notes?: string
}
export type FirmwareDeploymentProgress = {
  /** Total number of stations in the deployment */
  total?: number
  /** Stations waiting to be dispatched */
  pending?: number
  /** Stations currently downloading/installing */
  updating?: number
  /** Stations that completed successfully */
  succeeded?: number
  /** Stations that failed */
  failed?: number
  /** Stations cancelled before being dispatched */
  cancelled?: number
}
export type FirmwareDeploymentStation = {
  /** Charger identifier (chargers-api chargerId) */
  chargerId: string
  /** Site (depot) the station belongs to */
  siteId?: string
  /** Display name of the station */
  chargerName?: string
  /** Firmware version the station reported when the deployment was created */
  currentFirmwareVersion?: string
  /** Firmware version this deployment upgrades the station to */
  targetFirmwareVersion?: string
  /** IANA timezone used to evaluate the maintenance window for this station */
  timezone?: string
  /** Station update status */
  status?: 'PENDING' | 'UPDATING' | 'SUCCEEDED' | 'FAILED' | 'CANCELLED'
  /** Human-readable reason when the station failed */
  failureReason?: string
  /** Number of dispatch attempts (initial dispatch + retries) */
  attempts?: number
  /** When the OCPP UpdateFirmware command was last accepted */
  updateStartedAt?: string
  /** Last firmware update status reported by the station (e.g. Downloading, Installing) */
  lastChargerStatus?: string
  lastStatusAt?: string
  completedAt?: string
}
export type FirmwareDeployment = {
  /** Unique deployment identifier */
  id: string
  /** Organization that owns the deployment */
  organizationId?: string
  /** Optional operator-facing label for the deployment */
  name?: string
  /** Firmware image URI sent to the stations via OCPP UpdateFirmware. Null when the deployment references a firmware catalog entry instead. */
  firmwareLocation?: string
  /** Firmware catalog entry being deployed. Null when a static firmwareLocation was supplied. */
  firmwareVersionId?: string
  /** How stations are dispatched relative to each other */
  rolloutStrategy?: 'ONE_PER_SITE' | 'ONE_AT_A_TIME' | 'ALL_AT_ONCE'
  /** What happens when a station fails to update */
  failureHandling?: 'CONTINUE_ON_FAILURE' | 'STOP_ON_FIRST_FAILURE'
  /** Calendar date (YYYY-MM-DD) for the one-shot maintenance window in station-local time. Null when no window is configured. Legacy deployments may omit this and treat start/end as daily. */
  maintenanceWindowDate?: string
  /** Maintenance window start (HH:mm, station-local time). Null when no window is configured. */
  maintenanceWindowStart?: string
  /** Maintenance window end (HH:mm, station-local time). Null when no window is configured. */
  maintenanceWindowEnd?: string
  /** Deployment lifecycle status */
  status?: 'IN_PROGRESS' | 'PAUSED' | 'CANCELLED' | 'COMPLETED' | 'COMPLETED_WITH_FAILURES'
  /** Sites currently paused by failure handling; pending stations at these sites wait for operator review (resume or cancel the site) */
  pausedSiteIds?: string[]
  progress?: FirmwareDeploymentProgress
  /** Per-station progress. Populated on the deployment detail endpoint; null in list responses. */
  stations?: FirmwareDeploymentStation[]
  createdAt?: string
  /** User ID who created the deployment */
  createdBy?: string
  /** Display name of the user who created the deployment, snapshotted at create time so list views do not need a per-row user lookup. Prefer the platform user's name; may fall back to email. Null when the name could not be resolved at create time. */
  createdByName?: string
  updatedAt?: string
  completedAt?: string
}
export type CursorPagedListFirmwareDeployment = {
  data?: FirmwareDeployment[]
  links?: CursorLinks
  meta?: CursorMeta
}
export type FirmwareDeploymentStationParams = {
  /** Charger identifier (chargers-api chargerId) */
  chargerId: string
  /** Site (depot) the station belongs to. Enriched from chargers-api when omitted. */
  siteId?: string
  /** Display name of the station. Enriched from chargers-api when omitted. */
  chargerName?: string
  /** Firmware version currently installed. Enriched from chargers-api when omitted. */
  currentFirmwareVersion?: string
  /** Firmware version this deployment upgrades the station to (informational; also used to confirm success) */
  targetFirmwareVersion?: string
  /** IANA timezone for evaluating the maintenance window in the station's local time (e.g. Europe/Paris). Defaults to UTC. */
  timezone?: string
}
export type FirmwareDeploymentCreateParams = {
  /** Optional operator-facing label for the deployment */
  name?: string
  /** Firmware image URI sent to the stations via OCPP UpdateFirmware (ftp/ftps/http/https). Provide exactly one of firmwareLocation or firmwareVersionId. */
  firmwareLocation?: string
  /** Firmware catalog entry to deploy (see /api/v1/firmware-versions). A fresh presigned download URL is generated for each station at dispatch time. Provide exactly one of firmwareLocation or firmwareVersionId. */
  firmwareVersionId?: string
  /** How stations are dispatched relative to each other */
  rolloutStrategy: 'ONE_PER_SITE' | 'ONE_AT_A_TIME' | 'ALL_AT_ONCE'
  /** What happens when a station fails to update. Defaults to CONTINUE_ON_FAILURE. */
  failureHandling?: 'CONTINUE_ON_FAILURE' | 'STOP_ON_FIRST_FAILURE'
  /** Calendar date (YYYY-MM-DD) for the one-shot maintenance window, evaluated in each station's local timezone. Omit with start/end for an immediate rollout. Must be provided together with maintenanceWindowStart and maintenanceWindowEnd. */
  maintenanceWindowDate?: string
  /** Maintenance window start (HH:mm, station-local time). Omit for immediate rollout. Must be provided together with maintenanceWindowDate and maintenanceWindowEnd. */
  maintenanceWindowStart?: string
  /** Maintenance window end (HH:mm, station-local time). Updates already in progress complete; remaining stations stay pending after the window ends. Overnight windows (start > end) span into the next local calendar day after maintenanceWindowDate. */
  maintenanceWindowEnd?: string
  /** Charging stations to include in the deployment */
  stations: FirmwareDeploymentStationParams[]
}
export type BugReport = {
  /** Linear issue UUID */
  issueId?: string
  /** Human-readable Linear issue key */
  issueIdentifier?: string
  /** Linear issue URL */
  issueUrl?: string
  /** User-facing confirmation message */
  message?: string
}
export type ApiError = {
  /** Error type */
  type?: string
  /** Error code */
  code?: string
  /** Human-readable error message */
  message?: string
  /** Parameter that caused the error, if applicable */
  param?: string
  /** HTTP status code */
  statusCode?: number
}
export type BugReportCreateParams = {
  /** Short bug summary */
  title: string
  /** Customer-provided bug description */
  description: string
  /** Support category selected in the app */
  category?: string
  /** Page URL where the report was submitted */
  pageUrl?: string
  /** Application route where the report was submitted */
  pagePath?: string
  /** Browser document title */
  pageTitle?: string
  /** Resolved in-app page/entity context */
  pageContext?: string
  /** Datadog RUM session replay URL */
  datadogSessionReplayUrl?: string
  /** Datadog RUM session ID */
  datadogSessionId?: string
  /** Datadog RUM view ID */
  datadogViewId?: string
  /** Datadog RUM application ID */
  datadogApplicationId?: string
  /** Browser user agent */
  userAgent?: string
  /** Browser language */
  browserLanguage?: string
  /** Browser timezone */
  timezone?: string
  /** Viewport width in CSS pixels */
  viewportWidth?: number
  /** Viewport height in CSS pixels */
  viewportHeight?: number
  /** Screen width in CSS pixels */
  screenWidth?: number
  /** Screen height in CSS pixels */
  screenHeight?: number
  /** Device pixel ratio */
  devicePixelRatio?: number
  /** Browser network effective type */
  networkEffectiveType?: string
  /** Active backend environment */
  environment?: string
  /** Frontend build profile */
  buildProfile?: string
  /** Frontend app version */
  appVersion?: string
  /** Frontend build timestamp */
  buildTimestamp?: string
}
export type AssistantSkillList = {
  builtinSkills?: AssistantSkill[]
  personalSkills?: AssistantSkill[]
  organizationSkills?: AssistantSkill[]
  hasMorePersonal?: boolean
  nextPersonalCursor?: string
  hasMoreOrganization?: boolean
  nextOrganizationCursor?: string
}
export type AssistantSkillCreateParams = {
  name: string
  description?: string
  instructions: string
  shareScope?: string
  category?: string
  toolNames?: string[]
  defaultContextRefs?: AssistantContextRef[]
  defaultAutoApprove?: boolean
  sourceConversationId?: string
}
export type AssistantSkillSaveFromConversationParams = {
  conversationId: string
  name: string
  description?: string
  shareScope?: string
  category?: string
  instructions?: string
  toolNames?: string[]
  defaultContextRefs?: AssistantContextRef[]
  defaultAutoApprove?: boolean
}
export type AssistantSkillScheduleList = {
  schedules?: AssistantSkillSchedule[]
  hasMore?: boolean
  nextCursor?: string
}
export type AssistantSkillScheduleCreateParams = {
  skillId: string
  name: string
  cronExpression: string
  timezone: string
  contextRefs?: AssistantContextRef[]
  messageOverride?: string
  autoApprove?: boolean
}
export type AssistantConversation = {
  id?: string
  shareScope?: string
  createdByUserId?: string
  title?: string
  status?: string
  createdAt?: string
  updatedAt?: string
  lastMessageAt?: string
}
export type AssistantConversationList = {
  conversations?: AssistantConversation[]
  hasMore?: boolean
  nextCursor?: string
}
export type AssistantConversationCreateParams = {
  title?: string
  /** personal (default) or organization. Use organization so other org members can read the conversation. */
  shareScope?: 'personal' | 'organization'
}
export type AssistantConversationShareParams = {
  shareScope: string
}
export type AssistantPageContext = {
  route?: string
  pageTitle?: string
}
export type AssistantSendMessageParams = {
  message?: string
  contextRefs?: AssistantContextRef[]
  pageContext?: AssistantPageContext
  autoApprove?: boolean
  skillId?: string
  attachmentIds?: string[]
}
export type AssistantAttachment = {
  attachmentId?: string
  filename?: string
  contentType?: string
  sizeBytes?: number
  createdAt?: string
}
export type AssistantMessage = {
  id?: string
  role?: string
  content?: string
  contentPreview?: string
  messageType?: string
  toolTrace?: string
  thinkingPreview?: string
  thinkingTrace?: string
  transcriptS3Key?: string
  feedbackRating?: string
  attachments?: AssistantAttachment[]
  createdAt?: string
}
export type AssistantMessageFeedbackParams = {
  rating?: string
}
export type AssistantAction = {
  id?: string
  type?: string
  status?: string
  longRunning?: boolean
  outputSummary?: string
  errorMessage?: string
  artifactKey?: string
  createdAt?: string
  updatedAt?: string
}
export type AssistantActionDispatch = {
  actionId?: string
  status?: string
}
export type ArcadeScore = {
  id?: string
  organizationId?: string
  userId?: string
  game?: string
  board?: string
  score?: number
  createdAt?: string
}
export type ArcadeScoreList = {
  scores?: ArcadeScore[]
  hasMore?: boolean
  nextCursor?: string
}
export type ArcadeScoreCreateParams = {
  score: number
  game?: string
  board?: string
}
export type ChargingDecisionLog = {
  /** Virtual charger group ID */
  virtualChargerGroupId?: string
  /** Site ID this virtual charger group belongs to */
  siteId?: string
  /** Timestamp of the decision */
  timestamp?: string
  /** Charger ID the decision was made for */
  chargerId?: string
  /** OCPP connector id the decision was made for; null for charger-level decisions */
  connectorId?: number
  /** The action taken (START_CHARGING, STOP_CHARGING, QUEUE_CHARGER, REMOVE_FROM_QUEUE, etc.) */
  action?: string
  /** Reason for the decision */
  reason?: string
  /** Current state of the charger */
  chargerState?: string
  /** Current SoC of the charger */
  currentSoc?: number
  /** Priority strategy being used */
  priorityStrategy?: string
  /** Current SoC limit */
  socLimit?: number
  /** Additional context about the decision */
  context?: {
    [key: string]: string
  }
  timestampForSiteIndex?: string
}
export type PaginatedDecisionLog = {
  /** List of decision logs */
  items?: ChargingDecisionLog[]
  /** Token for retrieving the next page of results */
  nextToken?: string
  /** Number of items in this page */
  count?: number
}
export type Notification = {
  /** User ID this notification is for */
  userId?: string
  /** Unique identifier for the notification */
  id?: string
  /** Type of notification */
  type?:
    | 'TASK_ASSIGNED'
    | 'TASK_COMPLETED'
    | 'TASK_COMMENT'
    | 'PROJECT_UPDATE'
    | 'MENTION'
    | 'ASSISTANT_SCHEDULE_RUN'
    | 'ASSISTANT_DIAGNOSTICS_COMPLETE'
    | 'ASSISTANT_ACTION_COMPLETE'
    | 'TASK_DELEGATION'
    | 'FIRMWARE_ROLLOUT_COMPLETE'
    | 'FIRMWARE_ROLLOUT_NEEDS_ATTENTION'
    | 'WORK_ORDER'
  /** Title/headline of the notification */
  title?: string
  /** Body/content of the notification */
  body?: string
  /** ID of the related entity (project, task, etc.) */
  entityId?: string
  /** Type of the related entity */
  entityType?: string
  /** Assistant conversation to reopen when this notification is clicked */
  conversationId?: string
  /** Organization scope for the related assistant conversation */
  organizationId?: string
  /** Whether the notification has been read */
  read?: boolean
  /** Timestamp when the notification was created */
  createdAt?: string
}
export type CursorPagedListNotification = {
  data?: Notification[]
  links?: CursorLinks
  meta?: CursorMeta
}
export type AssistantSkillRun = {
  id?: string
  scheduleId?: string
  organizationId?: string
  userId?: string
  skillId?: string
  conversationId?: string
  status?: string
  startedAt?: string
  completedAt?: string
  summary?: string
  errorMessage?: string
  skipReason?: string
  transcriptS3Key?: string
}
export type AssistantSkillRunList = {
  runs?: AssistantSkillRun[]
  hasMore?: boolean
  nextCursor?: string
}
export type AssistantSkillRunTranscriptTurn = {
  messageId?: string
  role?: string
  content?: string
  thinkingTrace?: string
  toolTrace?: object[]
  toolTurnCount?: number
  createdAt?: string
}
export type AssistantSkillRunTranscript = {
  runId?: string
  scheduleId?: string
  conversationId?: string
  turns?: AssistantSkillRunTranscriptTurn[]
}
export type AssistantQuota = {
  used?: number
  limit?: number
  remaining?: number
}
export type AssistantConversationDetail = {
  conversation?: AssistantConversation
  messages?: AssistantMessage[]
  actions?: AssistantAction[]
  quota?: AssistantQuota
  readOnly?: boolean
}
export type Pagination = {
  /** Whether this is the first page */
  first: boolean
  /** Whether this is the last page */
  last: boolean
  /** Number of items per page */
  pageSize: number
  /** Current page number (0-indexed) */
  page: number
  /** Total number of pages */
  totalPages: number
  /** Total number of items */
  totalItems: number
}
export type PaginationMeta = {
  pagination: Pagination
}
export type ActivityEventResponse = {
  /** Unique identifier for this event. */
  id: string
  /** When the event occurred (UTC). */
  event_time: string
  /** Your organization's identifier. */
  org_id?: string | null
  /** Dot-namespaced event type. Examples: `charger.created`, `vehicle.updated`, `auth.login.succeeded`, `auth.logout.succeeded`. */
  event_type: string
  /** The route template matched by the request, e.g. `/api/v1/chargers/{id}`. Null for authentication events. */
  endpoint?: string | null
  /** `USER` for a human user authenticated via bearer token; `API_KEY` for a machine caller authenticated via API key; `SYSTEM` for automated platform actions. */
  actor_type: string
  /** Identifier of the actor who performed the action. Null when the actor could not be resolved. */
  actor_id?: string | null
  /** The type of resource affected by the action, e.g. `Charger`, `Vehicle`, `Depot`. Null for authentication events. */
  resource_type?: string | null
  /** Identifier of the affected resource. Null for authentication events. */
  resource_id?: string | null
  /** An opaque, stable token identifying the client's IP subnet (/24 for IPv4, /48 for IPv6). Events from the same subnet share the same token. Pass it back in the `ip_hashed` query parameter to retrieve all events from that subnet. The raw IP address is never exposed by the API. */
  ip_hashed?: string | null
  /** HTTP `User-Agent` header sent by the client. Null if not provided. */
  user_agent?: string | null
  /** Unique identifier for the HTTP request. Use for correlation with platform logs. */
  request_id?: string | null
  /** HTTP response status code returned for the request (e.g. `200`, `201`, `400`, `404`). Null for authentication events. */
  response_status?: number | null
  /** Sanitized snapshot of the request body at the time of the call. Sensitive fields such as passwords and tokens are redacted. Null for authentication events or requests without a body. */
  request_payload?: {
    [key: string]: unknown
  } | null
  /** Channel through which the request originated: `web`, `mobile`, `api`, or `system`. */
  source?: string | null
  /** Broad category of the event: `request` for API mutations, `auth` for authentication events, `stripe` for billing events. */
  event_category: 'request' | 'auth' | 'stripe'
  /** Identity provider event code for authentication events. Examples: `auth.login.succeeded`, `auth.login.failed`, `auth.logout.succeeded`. Null for non-authentication events. */
  auth0_code?: string | null
  /** When this audit record was written (UTC). May differ slightly from `event_time`. */
  created_at: string
}
export type PagedResponseActivityEventResponse = {
  meta: PaginationMeta
  data: ActivityEventResponse[]
}
export type ErrorObject = {
  /** Short, human-readable summary of the error. */
  title: string
  /** HTTP status code as a string. */
  status: string
  /** Human-readable explanation specific to this occurrence. */
  detail?: string | null
  /** Object containing references to the source of the error. */
  source?: {
    [key: string]: string
  } | null
}
export type ErrorResponse = {
  /** List of error objects. */
  errors: ErrorObject[]
}
export type ReleaseNoteItem = {
  id: string
  title: string
  highlights: string[]
  release_date: string
  visible_at: string
  seen: boolean
}
export type WhatsNewFeedResponse = {
  notes: ReleaseNoteItem[]
  unseen_count: number
}
export type ValidationError2 = {
  loc: (string | number)[]
  msg: string
  type: string
  input?: unknown
  ctx?: object
}
export type HttpValidationError2 = {
  detail?: ValidationError2[]
}
export type MarkSeenRequest = {
  note_ids?: string[]
}
export const {
  useGetSiteReservationConfigurationQuery,
  useLazyGetSiteReservationConfigurationQuery,
  useUpdateSiteReservationConfigurationMutation,
  useCreateSiteReservationConfigurationMutation,
  useGetSiteGridProfilesQuery,
  useLazyGetSiteGridProfilesQuery,
  useUpdateSiteGridProfileMutation,
  useCreateSiteGridProfileMutation,
  useGetScheduledTripsQuery,
  useLazyGetScheduledTripsQuery,
  useUpdateTripMutation,
  useCreateTripMutation,
  useDeleteTripMutation,
  useGetRecurrenceScheduleQuery,
  useLazyGetRecurrenceScheduleQuery,
  useUpdateRecurrenceScheduleMutation,
  useDeleteRecurrenceScheduleMutation,
  useUpdateTripOccurrencesMutation,
  useGetGridEventIntegrationAccountsQuery,
  useLazyGetGridEventIntegrationAccountsQuery,
  useUpdateGridEventIntegrationAccountMutation,
  useCreateGridEventIntegrationAccountMutation,
  useGetDepotEventsByDepotIdQuery,
  useLazyGetDepotEventsByDepotIdQuery,
  useUpdateDepotEventMutation,
  useSaveDepotEventMutation,
  useUpdateCustomTariffMutation,
  useGetScheduledChargerSessionQuery,
  useLazyGetScheduledChargerSessionQuery,
  useUpdateScheduledChargerSessionMutation,
  useCancelScheduledChargerSessionMutation,
  useGetChargerEventByIdQuery,
  useLazyGetChargerEventByIdQuery,
  useUpdateChargerEventMutation,
  useCancelChargerEventMutation,
  usePatchChargerEventMutation,
  useMoveChargerEventMutation,
  useStartDepotBackfillMutation,
  useStartBackfillForSiteMutation,
  useGetTelemetryExclusionPeriodQuery,
  useLazyGetTelemetryExclusionPeriodQuery,
  useCreateTelemetryExclusionPeriodMutation,
  useGetSiteEnergyConfigurationsQuery,
  useLazyGetSiteEnergyConfigurationsQuery,
  useCreateSiteEnergyConfigurationMutation,
  useCreateRecurrenceScheduleMutation,
  useSetRecurrenceScheduleVehiclesMutation,
  useGetOptimizationsQuery,
  useLazyGetOptimizationsQuery,
  useCreateOptimizationMutation,
  useGetActiveNodeEnergyConfigurationsQuery,
  useLazyGetActiveNodeEnergyConfigurationsQuery,
  useCreateNodeEnergyConfigurationMutation,
  useDeleteNodeEnergyConfigurationByNodeIdMutation,
  useListMarketRegionsQuery,
  useLazyListMarketRegionsQuery,
  useCreateMarketRegionMutation,
  useGetAverageRatesMutation,
  useGetLoadBalancerEventsQuery,
  useLazyGetLoadBalancerEventsQuery,
  useCreateLoadBalancerEventMutation,
  useGetEnergyEfficiencyPredictionsQuery,
  useLazyGetEnergyEfficiencyPredictionsQuery,
  useCreateEnergyEfficiencyPredictionMutation,
  useGetTransactionProfileMappings1Query,
  useLazyGetTransactionProfileMappings1Query,
  useGetTransactionProfileMappingsMutation,
  useCreateEffectiveNodeEnergyLimitMutation,
  useSearchCustomTariffsQuery,
  useLazySearchCustomTariffsQuery,
  useCreateCustomTariffMutation,
  useGetProfileHistories1Query,
  useLazyGetProfileHistories1Query,
  useCreateProfileHistoryMutation,
  useGetScheduledChargerSessionsQuery,
  useLazyGetScheduledChargerSessionsQuery,
  useCreateScheduledChargerSessionMutation,
  useGetScheduledChargerSessionDetailsQuery,
  useLazyGetScheduledChargerSessionDetailsQuery,
  useSaveScheduledChargerSessionDetailsMutation,
  useCreateChargerEventPredictionMutation,
  useGetChargerEventsQuery,
  useLazyGetChargerEventsQuery,
  useCreateChargerEventMutation,
  useGetChargerEventDetailsByIdQuery,
  useLazyGetChargerEventDetailsByIdQuery,
  useAddSessionToChargerEventMutation,
  useGetVehicleOptimizationsQuery,
  useLazyGetVehicleOptimizationsQuery,
  useGetTariffsQuery,
  useLazyGetTariffsQuery,
  useGetTariffQuery,
  useLazyGetTariffQuery,
  useGetDemandChargesQuery,
  useLazyGetDemandChargesQuery,
  useGetPriceCurveQuery,
  useLazyGetPriceCurveQuery,
  useGetLinkTelemetryQuery,
  useLazyGetLinkTelemetryQuery,
  useGetSiteEnergyConfigurationQuery,
  useLazyGetSiteEnergyConfigurationQuery,
  useGetBulkSiteEnergyConfigurationsQuery,
  useLazyGetBulkSiteEnergyConfigurationsQuery,
  useGetBulkSiteReservationConfigurationsQuery,
  useLazyGetBulkSiteReservationConfigurationsQuery,
  useGetSiteGridProfileQuery,
  useLazyGetSiteGridProfileQuery,
  useGetOptimizationQuery,
  useLazyGetOptimizationQuery,
  useGetNodeEnergyConfigurationQuery,
  useLazyGetNodeEnergyConfigurationQuery,
  useDeleteNodeEnergyConfigurationIdMutation,
  useGetLoadServingEntitiesQuery,
  useLazyGetLoadServingEntitiesQuery,
  useGetGridEventIntegrationsQuery,
  useLazyGetGridEventIntegrationsQuery,
  useGetGridEventIntegrationQuery,
  useLazyGetGridEventIntegrationQuery,
  useGetGridEventIntegrationAccountQuery,
  useLazyGetGridEventIntegrationAccountQuery,
  useGetGridEventIntegrationEventByAccountQuery,
  useLazyGetGridEventIntegrationEventByAccountQuery,
  useGetGridEventIntegrationEventQuery,
  useLazyGetGridEventIntegrationEventQuery,
  useGetLoadBalancerEventQuery,
  useLazyGetLoadBalancerEventQuery,
  useGetEnergyEfficiencyPredictionQuery,
  useLazyGetEnergyEfficiencyPredictionQuery,
  useGetEffectiveEnergyLimitQuery,
  useLazyGetEffectiveEnergyLimitQuery,
  useGetSmartPricesQuery,
  useLazyGetSmartPricesQuery,
  useGetScheduledDepotPowerQuery,
  useLazyGetScheduledDepotPowerQuery,
  useGetDepotEventByIdQuery,
  useLazyGetDepotEventByIdQuery,
  useCancelDepotEventMutation,
  useGetDepotEventDetailsQuery,
  useLazyGetDepotEventDetailsQuery,
  useGetScheduledChargerSessionsByDepotQuery,
  useLazyGetScheduledChargerSessionsByDepotQuery,
  useGetPredictedChargerEventsQuery,
  useLazyGetPredictedChargerEventsQuery,
  useGetDepotEventsQuery,
  useLazyGetDepotEventsQuery,
  useGetScheduledChargerSessionTelemetryQuery,
  useLazyGetScheduledChargerSessionTelemetryQuery,
  useGetProfileHistoryQuery,
  useLazyGetProfileHistoryQuery,
  useDeleteTelemetryExclusionPeriodMutation,
  useGetApiVehiclesByIdTimeToSocQuery,
  useLazyGetApiVehiclesByIdTimeToSocQuery,
  useGetApiTransactionsTimeToSocQuery,
  useLazyGetApiTransactionsTimeToSocQuery,
  useGetApiMlTimeToSocQuery,
  useLazyGetApiMlTimeToSocQuery,
  useGetWeatherQuery,
  useLazyGetWeatherQuery,
  useGetWeatherForecastQuery,
  useLazyGetWeatherForecastQuery,
  useUpdateTelematicsFeedCursorStatusMutation,
  useUpdateIntegrationStatusMutation,
  useSearchTelematicsFeedCursorsQuery,
  useLazySearchTelematicsFeedCursorsQuery,
  useCreateTelematicsFeedCursorMutation,
  useSearchPaymentTerminalsQuery,
  useLazySearchPaymentTerminalsQuery,
  useCreatePaymentTerminalMutation,
  useAssignPaymentTerminalsMutation,
  useSearchPaymentTerminalSessionsQuery,
  useLazySearchPaymentTerminalSessionsQuery,
  useCreatePaymentTerminalSessionMutation,
  useSearchIntegrationsQuery,
  useLazySearchIntegrationsQuery,
  useCreateIntegrationMutation,
  useSearchIntegrationProvidersQuery,
  useLazySearchIntegrationProvidersQuery,
  useCreateIntegrationProviderMutation,
  useRetrieveTelematicsFeedCursorQuery,
  useLazyRetrieveTelematicsFeedCursorQuery,
  useDeleteTelematicsFeedCursorMutation,
  useUpdateTelematicsFeedCursorMutation,
  useRetrievePaymentTerminalQuery,
  useLazyRetrievePaymentTerminalQuery,
  useDeletePaymentTerminalMutation,
  useUpdatePaymentTerminalMutation,
  useRetrievePaymentTerminalSessionQuery,
  useLazyRetrievePaymentTerminalSessionQuery,
  useDeletePaymentTerminalSessionMutation,
  useUpdatePaymentTerminalSessionMutation,
  useRetrieveIntegrationQuery,
  useLazyRetrieveIntegrationQuery,
  useDeleteIntegrationMutation,
  useUpdateIntegrationMutation,
  useRetrieveIntegrationProviderQuery,
  useLazyRetrieveIntegrationProviderQuery,
  useDeleteIntegrationProviderMutation,
  useUpdateIntegrationProviderMutation,
  useSearchOrganizationIntegrationProvidersQuery,
  useLazySearchOrganizationIntegrationProvidersQuery,
  useRetrieveOrganizationIntegrationProviderQuery,
  useLazyRetrieveOrganizationIntegrationProviderQuery,
  useRetrieveIntegrationFeedCursorQuery,
  useLazyRetrieveIntegrationFeedCursorQuery,
  useOcppLogAnalysisApiV1OcppLogAnalysisPostMutation,
  useSubmitFeedbackApiV1OcppLogAnalysisFeedbackPostMutation,
  useUpdateFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdPutMutation,
  useDeleteFeedbackApiV1OcppLogAnalysisFeedbackFeedbackIdDeleteMutation,
  useGetSchemaVersionApiChargerLlmSchemaVersionGetQuery,
  useLazyGetSchemaVersionApiChargerLlmSchemaVersionGetQuery,
  useSyncOcpiTariffsMutation,
  useSyncOcpiLocationsMutation,
  useSyncOcpiIntegrationsMutation,
  useSendTariffsMutation,
  useSendLocationsMutation,
  useAuthorizeMutation,
  useDeleteUnusedOcpiTariffsMutation,
  useGetCredentialsQuery,
  useLazyGetCredentialsQuery,
  useCreateCredentialsMutation,
  useGetSessionsQuery,
  useLazyGetSessionsQuery,
  useGetCdrsQuery,
  useLazyGetCdrsQuery,
  useGetRequestLogsQuery,
  useLazyGetRequestLogsQuery,
  useGetRequestLogQuery,
  useLazyGetRequestLogQuery,
  useGetAuthorizationDecisionsQuery,
  useLazyGetAuthorizationDecisionsQuery,
  useGetAuthorizationDecisionQuery,
  useLazyGetAuthorizationDecisionQuery,
  useGetVirtualChargerGroupQuery,
  useLazyGetVirtualChargerGroupQuery,
  useUpdateVirtualChargerGroupMutation,
  useDeleteVirtualChargerGroupMutation,
  useGetSkillQuery,
  useLazyGetSkillQuery,
  useUpdateSkillMutation,
  useDeleteSkillMutation,
  useGetSkillScheduleQuery,
  useLazyGetSkillScheduleQuery,
  useUpdateSkillScheduleMutation,
  useDeleteSkillScheduleMutation,
  useListVirtualChargerGroupsQuery,
  useLazyListVirtualChargerGroupsQuery,
  useCreateVirtualChargerGroupMutation,
  useBulkCreateVirtualChargerGroupsMutation,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useListSavesQuery,
  useLazyListSavesQuery,
  useCreateSaveMutation,
  useRefreshMutation,
  useListFirmwareVersionsQuery,
  useLazyListFirmwareVersionsQuery,
  useCreateFirmwareVersionMutation,
  useCompleteUploadMutation,
  useListDeploymentsQuery,
  useLazyListDeploymentsQuery,
  useCreateDeploymentMutation,
  useRetryStationMutation,
  useResumeSiteMutation,
  useCancelSiteMutation,
  useResumeDeploymentMutation,
  usePauseDeploymentMutation,
  useCancelDeploymentMutation,
  useCreateBugReportMutation,
  useListSkillsQuery,
  useLazyListSkillsQuery,
  useCreateSkillMutation,
  useSaveFromConversationMutation,
  useListSkillSchedulesQuery,
  useLazyListSkillSchedulesQuery,
  useCreateSkillScheduleMutation,
  useListConversationsQuery,
  useLazyListConversationsQuery,
  useCreateConversationMutation,
  useShareConversationMutation,
  useSendMessageMutation,
  useSetMessageFeedbackMutation,
  useUploadAttachmentMutation,
  useRunActionMutation,
  useRejectActionMutation,
  useDispatchMutation,
  useListScoresQuery,
  useLazyListScoresQuery,
  useCreateScoreMutation,
  useGetDecisionLogsQuery,
  useLazyGetDecisionLogsQuery,
  useGetOpsNotificationsQuery,
  useLazyGetOpsNotificationsQuery,
  useGetNotificationQuery,
  useLazyGetNotificationQuery,
  useDeleteNotificationMutation,
  useGetSaveQuery,
  useLazyGetSaveQuery,
  useDeleteSaveMutation,
  useGetFirmwareVersionQuery,
  useLazyGetFirmwareVersionQuery,
  useDeleteFirmwareVersionMutation,
  useGetDownloadUrlQuery,
  useLazyGetDownloadUrlQuery,
  useGetDeploymentQuery,
  useLazyGetDeploymentQuery,
  useListStationsQuery,
  useLazyListStationsQuery,
  useListSkillScheduleRunsQuery,
  useLazyListSkillScheduleRunsQuery,
  useGetSkillScheduleRunQuery,
  useLazyGetSkillScheduleRunQuery,
  useGetSkillScheduleRunTranscriptQuery,
  useLazyGetSkillScheduleRunTranscriptQuery,
  useGetConversationQuery,
  useLazyGetConversationQuery,
  useGetActionQuery,
  useLazyGetActionQuery,
  useStreamActionQuery,
  useLazyStreamActionQuery,
  useIngestDescartesRouteMutation,
  useListActivityEventsQuery,
  useLazyListActivityEventsQuery,
  useGetWhatsNewFeedV1WhatsNewGetQuery,
  useLazyGetWhatsNewFeedV1WhatsNewGetQuery,
  useMarkNotesSeenV1WhatsNewSeenPostMutation
} = injectedRtkApi
